<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =

          [{
            "num_cand": "U2FsdGVkX19wFeY/Z8TmWAXC4m5k+iOMtW+9ZrDN1Go=",
            "cpf": "U2FsdGVkX18YObsuLes9hGP9YUiB5dx6929bmRMLbw4="
          }, {
            "num_cand": "U2FsdGVkX1/c2DzVk6yOwR3E2VY5VD+dGr7KhIwCWhA=",
            "cpf": "U2FsdGVkX19FxZejOJ45wiBHt5obV3WwZZvw8YbBK7Q="
          }, {
            "num_cand": "U2FsdGVkX1+llsYKKN04VJfgJrxStY/POsSOFtV0Hmk=",
            "cpf": "U2FsdGVkX1828UfL8owzIIR9k0FsWaBpAkrxyWhYyYE="
          }, {
            "num_cand": "U2FsdGVkX18Hor9OtmLQWR0QrMksJJVotVwlLgvAiYU=",
            "cpf": "U2FsdGVkX19fHrDCCdI172svlh5/Lg6QHHwJNF7cO1c="
          }, {
            "num_cand": "U2FsdGVkX1+jmfuszG/195foeJrHfxyCliO2+NB9Dqo=",
            "cpf": "U2FsdGVkX18tqG+cfwEEj/wzEcwf7NdD/GeOrVLs1Cw="
          }, {
            "num_cand": "U2FsdGVkX19lR+ISba8/GZomQly4JZuO0HTCNs4HV1Y=",
            "cpf": "U2FsdGVkX1+lsZZ1dp+BFoUjqjp0+ZvYy+AmK6EIP+4="
          }, {
            "num_cand": "U2FsdGVkX19it+qULlcovASGLKi3ht9MMeRnmzIrziA=",
            "cpf": "U2FsdGVkX1+u9eaRwyIPBc1HDl2JbOVspWYE+RTiKD8="
          }, {
            "num_cand": "U2FsdGVkX18FxEaSyjS3m8xRwjx64sKvyxW+GiOEKLE=",
            "cpf": "U2FsdGVkX1+eVu87OHLC8LkPPwoRTv4S+65tCtx98a4="
          }, {
            "num_cand": "U2FsdGVkX19smRW41vYqP6k0LCsq4cJ+0jzu1ozTcok=",
            "cpf": "U2FsdGVkX1/ukU1MbxCN2BaFkj5WytaRsrv5y72zJUY="
          }, {
            "num_cand": "U2FsdGVkX1+4aJRiJo8IijD/jC93T2K7PWB109JWzBY=",
            "cpf": "U2FsdGVkX1856rqbotLJX7te6wzBbZBJlzf8iILTnYI="
          }, {
            "num_cand": "U2FsdGVkX18pivQAs57fqfO0OS0xvT36QrJbPxMcbQ8=",
            "cpf": "U2FsdGVkX1/47418h/oBQ1//iD0A2+mTar5fbJpYPyk="
          }, {
            "num_cand": "U2FsdGVkX19/V/xEhWFQ4xP8qxjik8vMwLJBfkoL+UM=",
            "cpf": "U2FsdGVkX19RATQ11g7/T60UatN8cUiQTY8fq76I2mU="
          }, {
            "num_cand": "U2FsdGVkX1+WVETWjzgPZOzQlfNTTTTK8ykOTcvWyRQ=",
            "cpf": "U2FsdGVkX18jmN34RaGq9pFxINd41raI7twwEZBwJx0="
          }, {
            "num_cand": "U2FsdGVkX19AnSvlvpX3oSdNYmpSYyQw/xKRFQC+VgE=",
            "cpf": "U2FsdGVkX18ClXfcrvNoBGPF2gB1cyvyUg9aXQlC96U="
          }, {
            "num_cand": "U2FsdGVkX184iGni1se3P3gTuInBCKRrKsVIXkI/7NI=",
            "cpf": "U2FsdGVkX18ZH9KgNUqDGrtfTt6Bw7XcaFCTmjQ18YE="
          }, {
            "num_cand": "U2FsdGVkX1/YReMqeRIlJ5RZDUMwTdSRJnKj6Fjdf3E=",
            "cpf": "U2FsdGVkX1/iJKSadGhyku0Jrr2PwNIZ41m5tfAW6iM="
          }, {
            "num_cand": "U2FsdGVkX1/LnnYymeTTnvfzrUxeqD/JmY1+R+1frAw=",
            "cpf": "U2FsdGVkX18c9gKAjho0eoSpzYpGcgHIBsyG1QfTW9Y="
          }, {
            "num_cand": "U2FsdGVkX19gd47OM4TbpgM06NCgIIWXGNt+l84KzNk=",
            "cpf": "U2FsdGVkX191ny5T3+hz14n+TJTlZhL9iu7KXu77PQc="
          }, {
            "num_cand": "U2FsdGVkX1/R9QuYHCrdsTvPhhT4Jw2ceZvbMNDl50Q=",
            "cpf": "U2FsdGVkX19oickji3UHMcJVQz8xK58zLu29p9YN+F8="
          }, {
            "num_cand": "U2FsdGVkX184fhaNmPpJj67Z0JMPHHrfIunmUGMmBBE=",
            "cpf": "U2FsdGVkX1+Qct6bBEqDoA4fejZqxrK6684s5O6dFrs="
          }, {
            "num_cand": "U2FsdGVkX1/zjj7vj3WVEHlWtxtwmvJno9lonPUSFIY=",
            "cpf": "U2FsdGVkX18GeAt67gQzkfkDKuRqHeaJ5FA+M3oG6ps="
          }, {
            "num_cand": "U2FsdGVkX19QKyKTRKSHO7DAKf4SAX+1+YhHhCHGN6A=",
            "cpf": "U2FsdGVkX1/w0BBVIzYHeh2BiZYvWZwed2n+HXK1t4E="
          }, {
            "num_cand": "U2FsdGVkX1/BUKEp+Boaqp5oWKVSIlyNMIGKF8k4eCM=",
            "cpf": "U2FsdGVkX1+JiAlnvwTr9f+Hle0+z3XVDozRmURmLqk="
          }, {
            "num_cand": "U2FsdGVkX1/ik0YUzlgImzeYlKXAcp8fAje929yP/eE=",
            "cpf": "U2FsdGVkX1/hZDQFuTYslAHw4PVYYPJxKZYzYOkskvo="
          }, {
            "num_cand": "U2FsdGVkX191idwe/S8B+PkiW6u37j7fykcdKKmIHrM=",
            "cpf": "U2FsdGVkX199zJOvsAAXROvR7HTT4IA1AiARy8IyyI4="
          }, {
            "num_cand": "U2FsdGVkX181VD5Wy4Kn8obYHrTBmkgemhglO3i9Ng0=",
            "cpf": "U2FsdGVkX1+nKz72tVJrw6CjWGjMPJkMd4zHBrVF0U0="
          }, {
            "num_cand": "U2FsdGVkX18R+savUWAjCyFs1f9lkmLVMB0Ihn4Pbi4=",
            "cpf": "U2FsdGVkX1+/dCDKmTJuz0zXh8wMkwO9UVZlKGq+9NQ="
          }, {
            "num_cand": "U2FsdGVkX1+b9XAFgLY4A1YwAQkR1Q/i4YO2SYxX0NI=",
            "cpf": "U2FsdGVkX1/Ovin1HtDM+cinGdCTFDm3Yh/Iht1Usd4="
          }, {
            "num_cand": "U2FsdGVkX1/H7kyaoLTGrZbwElGnl8GzTAY6oTqdxVE=",
            "cpf": "U2FsdGVkX19uzpcVs6cuPymcLXPqf+6CZIuIEiyQl4c="
          }, {
            "num_cand": "U2FsdGVkX1+REUAuc0E0xXTQz1CNkRNn8ii5qlK5wpw=",
            "cpf": "U2FsdGVkX1/DTc1ppl/CLBtlnpDZnIG+pSe7Ch6pKI4="
          }, {
            "num_cand": "U2FsdGVkX1/U3aQo5c0mEYSlfsMxaD8qXBqfOd9Sf0g=",
            "cpf": "U2FsdGVkX195iPhMgsiFi5xrai4a6nx/G0g3hY4DoUM="
          }, {
            "num_cand": "U2FsdGVkX1/Ob9JqQq2fHZOrWpcFwVQm6q59VKPM8lc=",
            "cpf": "U2FsdGVkX1+ZAa5PzsHG9banwW5UEnuylci+KjfvtbA="
          }, {
            "num_cand": "U2FsdGVkX19qbNJHBpzKfFQl9XQtYU3Gv6acuQsI/Xg=",
            "cpf": "U2FsdGVkX1/CLcr5lIY4atZCM1aKvRnmIjaGxijZFqU="
          }, {
            "num_cand": "U2FsdGVkX1/jZb3PeuCwFA/tK/r9KwCwI2rfoviJCBY=",
            "cpf": "U2FsdGVkX19UorOkk5I1BcDbSwyuNARbRY2M1n8v3dk="
          }, {
            "num_cand": "U2FsdGVkX1++AOfoljnH5tCR/nAtpbZo9XgxyIOVpwo=",
            "cpf": "U2FsdGVkX1/iOcClMbwTbGzgdH5M6p/MJBeG2TdvCqE="
          }, {
            "num_cand": "U2FsdGVkX1+ut1r84S8RUH3NDoLa1Mn8onnFl/BDV5M=",
            "cpf": "U2FsdGVkX1/emNN0SHYbxAjWq4mhYzBpvG6+b3wyya8="
          }, {
            "num_cand": "U2FsdGVkX18fUdxFnKvd00WlAjpm9LZ60Uv+2ffsfvE=",
            "cpf": "U2FsdGVkX19/IcbmT98i6Om4FD2iOouYNaT9fumMBz0="
          }, {
            "num_cand": "U2FsdGVkX18PtPu7sVOQC3CgHlasWBAUQiOjBguxsAQ=",
            "cpf": "U2FsdGVkX1+z6BLC0wXbgdv3NIIEuy4/bw/MFPvfYFI="
          }, {
            "num_cand": "U2FsdGVkX19BaJl1DihnqmnKs/Hhsvu/Ia+3Zvk6Sz0=",
            "cpf": "U2FsdGVkX1/GxdPa6zlc2kIsdjj6d/U83ozf/j8jI+4="
          }, {
            "num_cand": "U2FsdGVkX1/HAbOrSRhiDrkSN7/1UNNymlnVEpeK6Ho=",
            "cpf": "U2FsdGVkX1894YamRz37U9H15icKNFNBMJWNKn3sTRg="
          }, {
            "num_cand": "U2FsdGVkX1/vPUn4ADUceIqbWYHsgP2sA41TcxzlGQE=",
            "cpf": "U2FsdGVkX18uIYtEc8wrb+ZdbOGugZBLjf8BN3At8wc="
          }, {
            "num_cand": "U2FsdGVkX19kdc4N0MnsRHh4nyRoEchcfnCf78/Brto=",
            "cpf": "U2FsdGVkX1/ysnS88Zt+6mpVj2NH3pW2us64fYQr7yY="
          }, {
            "num_cand": "U2FsdGVkX18bigG+VyM9Zws1ibTzvEMbMMxv4a5MvPQ=",
            "cpf": "U2FsdGVkX1/JbjXV1+mvbY1zy4wlS5chfIvL+sLx4iw="
          }, {
            "num_cand": "U2FsdGVkX19RYcCwkhNPzSyOV0UqhvG1j67tgZMDzic=",
            "cpf": "U2FsdGVkX19yL/RCQoUpQlXFBEyihxgQT9GFJtCT8OM="
          }, {
            "num_cand": "U2FsdGVkX1/bJ/XzrWLJw/AI+K6CwYC1nNAhcyA3s4E=",
            "cpf": "U2FsdGVkX1/7oQQ6yEuWQcDgV1dHMHQpjd43rvpG2dc="
          }, {
            "num_cand": "U2FsdGVkX1+Z+KAyfixaSwkRieuVdXZ1xuE2GlEBXBU=",
            "cpf": "U2FsdGVkX1/WzILVPrtsCgJZHq5CqKI4Qhgowe0n208="
          }, {
            "num_cand": "U2FsdGVkX19iEytXC2uMRs69DKCe2vqG7FQob4IcZng=",
            "cpf": "U2FsdGVkX1/iO2G16oADDiUc2FphC0+AFPmwc+H/UB0="
          }, {
            "num_cand": "U2FsdGVkX196g0UEhfFXuxVX/duYhlGOFskJWBgDuVA=",
            "cpf": "U2FsdGVkX19uVocCRVjOj+d/O8lxsD7vvHY5Sq7IH5I="
          }, {
            "num_cand": "U2FsdGVkX1/7xjfN8u/yRRfAPUiUf8ZnepUd3XS37Uo=",
            "cpf": "U2FsdGVkX19h4HaUs2nZmN4382alhLUPXTfsoGrmWoc="
          }, {
            "num_cand": "U2FsdGVkX1/tl7l1n/QLR8/BcJTtVJ8qsk8Dn/+dtiA=",
            "cpf": "U2FsdGVkX1/ZA/j+Rc/GxWwWcVkPA/RBwKCqDjEcKao="
          }, {
            "num_cand": "U2FsdGVkX18K2km/y5WPI+XtIyK5foBAJZgR8s+3FOA=",
            "cpf": "U2FsdGVkX1/lOKNatbc0gTEN0Ph06QbT5wHg4aiWOyc="
          }, {
            "num_cand": "U2FsdGVkX19NK0snw7acjSldP8FQENrWO8SVJgSBO7U=",
            "cpf": "U2FsdGVkX18hJWW0LLvccNlAzLInZKRR4TTZqfx2GFI="
          }, {
            "num_cand": "U2FsdGVkX1/K6fOsLBXq9Q4DgXwkpSajmNn4SGltWXE=",
            "cpf": "U2FsdGVkX1+HF7laGFBkA5x17LVHEAxvP6eH59bPYuo="
          }, {
            "num_cand": "U2FsdGVkX1/hkJvu22s0nZz9CQjjjekpMW/iZcsT0zk=",
            "cpf": "U2FsdGVkX19icm+36tmm8tRNcD0gmlE4ieuZUS00/Z8="
          }, {
            "num_cand": "U2FsdGVkX18EF4/37YzXXFikOX71xNHxyyd9VMFEGLw=",
            "cpf": "U2FsdGVkX18BMfTLoI9kqHNC2CZ+KIW+7TgrCIe1HjI="
          }, {
            "num_cand": "U2FsdGVkX19KFFnhmpRhxVui5LlBI+nmXz1oOo2XFL8=",
            "cpf": "U2FsdGVkX1+gyPVccKftFYyE4PG7Mdq9yu60dznSpsw="
          }, {
            "num_cand": "U2FsdGVkX1+GdWeCPDdibaP4yVlJ2gQ8TfMdPKew6p4=",
            "cpf": "U2FsdGVkX1+HUEGv0nHbSeXvNn6pBQkT0StN0uiuejI="
          }, {
            "num_cand": "U2FsdGVkX191SinqpoZMpb/FdsCTqotkByw72jr8Xws=",
            "cpf": "U2FsdGVkX1/HG8qcTSLNfuk32ga5rnH41z71h3ShU10="
          }, {
            "num_cand": "U2FsdGVkX1/ADQxQVVqohMlmZ8a3zFopIbwaUJx/3Pk=",
            "cpf": "U2FsdGVkX19TmriekQU/9JvrbVUuKcYtC8B5h/VO+BY="
          }, {
            "num_cand": "U2FsdGVkX18wI9aKB8AKkcFtlF1x2MwPtRHbYwTy5zI=",
            "cpf": "U2FsdGVkX18ZeLeqjqanNW1sXGy1joGLJCVMoKuC/Ac="
          }, {
            "num_cand": "U2FsdGVkX19/Ea9HS0CEvU4GFRwloJAtnWpqmXskYuA=",
            "cpf": "U2FsdGVkX19ns0g+JY+Ub1hU/x01oHpwTu2DE9XovyI="
          }, {
            "num_cand": "U2FsdGVkX18M+17fLjjhfCfHXqdm2DYgBLL7YXX0zCg=",
            "cpf": "U2FsdGVkX1/9e3KmAaX9mEN1sHymjaqaP5qizD9HRSk="
          }, {
            "num_cand": "U2FsdGVkX1+CJVLnRl7ew78I68IyIO7aQJBdhVN+Lw8=",
            "cpf": "U2FsdGVkX19WhroEdbW2h/dwlLf7XJhPdS9FX4/qjG8="
          }, {
            "num_cand": "U2FsdGVkX1/+24kvzWjjrenlOKcJHWII8Bfb6SCD2YI=",
            "cpf": "U2FsdGVkX18pXlW5CvUrCTXurm/V15oPW4O1h/FnCaQ="
          }, {
            "num_cand": "U2FsdGVkX1/6XP7TSTgBgQUplnun2TfjWMNUz/6i5zM=",
            "cpf": "U2FsdGVkX1+QjTZqCYcosMvSBxWIbUOfAJcmLcorL8o="
          }, {
            "num_cand": "U2FsdGVkX1/KR5hUyxNRA8uioObGUrOxu8x7+xj5fCs=",
            "cpf": "U2FsdGVkX1+NmyCK+ekOS0Z7A8WOCuwWoiCZh3fwl8o="
          }, {
            "num_cand": "U2FsdGVkX1+DDrENsO6WMYS8PI6zzZCcNbu3HPdU8BE=",
            "cpf": "U2FsdGVkX18529ky9aOJ8xsyfwBmdsxDEJlCnguWF/8="
          }, {
            "num_cand": "U2FsdGVkX19hWIVjP/+/R/SG6hJAuJdElG7Y4KQ2e1A=",
            "cpf": "U2FsdGVkX1+548Q8bMQunc44fwr9uHqhLzlqvQYOv2Q="
          }, {
            "num_cand": "U2FsdGVkX19IvOedwnCnvLqOUcLhzTSpz6IRESPn4lU=",
            "cpf": "U2FsdGVkX185hlQwSIgpeiFiZOHI6MWr3tlo9T64zOc="
          }, {
            "num_cand": "U2FsdGVkX1/UdZA37PmE8l9Qed9wftdaMvFLYaWrFfA=",
            "cpf": "U2FsdGVkX18p6TosdgqAYRfSus3crsPZDKP3OK7EkAo="
          }, {
            "num_cand": "U2FsdGVkX1/m2LJ9K3+TTlSmK6qKuKK1wAurGHSaVk8=",
            "cpf": "U2FsdGVkX19W7gVvERyCDsuyBMrZl63+Qi6JnBc3Tos="
          }, {
            "num_cand": "U2FsdGVkX1+eEDdYeLKpfvVYFdqk5++Q8BOEuIZmJXk=",
            "cpf": "U2FsdGVkX18Ww6rqvQCw5dLvdGgeKKN3ZOOUh17e/84="
          }, {
            "num_cand": "U2FsdGVkX19eyVlnCNhC8yrP60Ll3c4tSE/YD3e2PWQ=",
            "cpf": "U2FsdGVkX1/LppRmMXQjP72syGoEqMZp9d700uqTfS8="
          }, {
            "num_cand": "U2FsdGVkX1/Orwh9ADS2eAHdpKKVDdVccxFs6U+/hTI=",
            "cpf": "U2FsdGVkX18u0NWb4hHPRADpr+dhrm3SqyEWFdvyVsg="
          }, {
            "num_cand": "U2FsdGVkX187ety4y2hbWmmnV/+gValAW+6YrmBIOBY=",
            "cpf": "U2FsdGVkX18UWaFmI8oxSa5SovebRw6GrkOPHdLe9cU="
          }, {
            "num_cand": "U2FsdGVkX18MOUWIzpucwVYy6aSAe/Uvdl7sKVDpX/k=",
            "cpf": "U2FsdGVkX19WdZc9jhIv6rHSZubsyjYOzYpORI/Xmyw="
          }, {
            "num_cand": "U2FsdGVkX19bzPyJGWxbEHGZBmujLD7hA5sO35KEaTM=",
            "cpf": "U2FsdGVkX1/B2+w4NrUWHRWmgNOPgaHKdQANJNgFDWA="
          }, {
            "num_cand": "U2FsdGVkX1/GLGgRRavRNoP89STS+QI49/JzsF8DFi0=",
            "cpf": "U2FsdGVkX18+DstHjj4vCxnyJTNvzOy1LomCC1TzMGw="
          }, {
            "num_cand": "U2FsdGVkX18HXqMirzSSmop+ioLZUlybC06POE3zOcU=",
            "cpf": "U2FsdGVkX19RgfeDANEGlx3gQAEstmBGXxJhEBzuBjE="
          }, {
            "num_cand": "U2FsdGVkX182nTeFkWxBW2tGdN7/0nTklF6nnRtQq2U=",
            "cpf": "U2FsdGVkX19rNphcXRBCDxrfqYmJDzunZZDwVbed5us="
          }, {
            "num_cand": "U2FsdGVkX19SjAcQwgRS83OfgHL+VKADtT5PbSeogvs=",
            "cpf": "U2FsdGVkX18uNzOex14oW3D5Yxt7BDFwxHbgbW03VXQ="
          }, {
            "num_cand": "U2FsdGVkX1+CvdcZT3jx0JMVGgFFWU5xgG04o0E/Rs8=",
            "cpf": "U2FsdGVkX1/nlaUjGfSuud1A0zRWwlR7Cd7vTcdqb/8="
          }, {
            "num_cand": "U2FsdGVkX18Bftez8qaRx37tVbJvbUDfgcnzZGLwOHM=",
            "cpf": "U2FsdGVkX1+P4TYoTvbNY/q9f92deBEn0PL9BENzZ7I="
          }, {
            "num_cand": "U2FsdGVkX1+45lGrNkjZL6KAdPVtPfTNslzNu9dDIrw=",
            "cpf": "U2FsdGVkX1+9tnSn0XdN9s+TwcbnuP5kgUVAIUy4xhI="
          }, {
            "num_cand": "U2FsdGVkX1/j955IonDWuTUuC4quLjtmd9i2oNBWHWc=",
            "cpf": "U2FsdGVkX18Flm0lfHgayzxY5RPrjace3XtEY5lldFc="
          }, {
            "num_cand": "U2FsdGVkX1+M0GcBqKdQbePVieMJ98WlxAnfUZxBUz0=",
            "cpf": "U2FsdGVkX18V3A5FfFoipM2utcSAacqXB6VJ0SpyPxI="
          }, {
            "num_cand": "U2FsdGVkX18GwMujtuzkVdWue/uo182Z0YAlutxzQwI=",
            "cpf": "U2FsdGVkX1+UrWh+yKdkV4/8gz5zkCbgEooEVoCEFQ4="
          }, {
            "num_cand": "U2FsdGVkX19arBGKuJ+m7ez2bdFWvZsmyeq+9+1p7Ls=",
            "cpf": "U2FsdGVkX19KSZk/F65eGSXbkYUfzshj/Zh29Xiy+mg="
          }, {
            "num_cand": "U2FsdGVkX19Rn8nJ6KBJddCduegXm7XObMwswvKd54U=",
            "cpf": "U2FsdGVkX1+9SzjmMJP3GQnU7vSMLUTzjXchj9EeA/4="
          }, {
            "num_cand": "U2FsdGVkX19jYki0+mFSd/hoQNLecSUzbnfA7u6s5+Y=",
            "cpf": "U2FsdGVkX18wmVBITS6kNp42AZoN0VlNV9DxN9rpsc8="
          }, {
            "num_cand": "U2FsdGVkX18PpIbl1r/6BCSuwL9RRJsD/uYb21AiOUg=",
            "cpf": "U2FsdGVkX18mvwB3J1BzqjIoMa/TH4pCVpNpf5oM/hk="
          }, {
            "num_cand": "U2FsdGVkX1/cgc434kxdJufMJgBJA+ktvKdqHNgUXyg=",
            "cpf": "U2FsdGVkX19wU3T4wGcQ2JvlRp0dI9FfYM6sOgK2r+w="
          }, {
            "num_cand": "U2FsdGVkX1/We+KDq8Bi7BDOSansq71bqt82P52lDM8=",
            "cpf": "U2FsdGVkX1/+JgvMWZB65Qoc95OHQIVxKF/v7HE4G7w="
          }, {
            "num_cand": "U2FsdGVkX1+HflfR42GLt/PDVOJ8WZKMs3hnMIcaCxs=",
            "cpf": "U2FsdGVkX1+UY/AS26sFL1ZopYJb1CTA0MjyyL3HBxA="
          }, {
            "num_cand": "U2FsdGVkX1+BeBABwx41WgV9uRHBqJHk7Z+Y7s/fkis=",
            "cpf": "U2FsdGVkX1/R12+E3R1Jhjvb3U4WIPlFAt7fXfrtIV8="
          }, {
            "num_cand": "U2FsdGVkX19NEnhxBk5HpNG4Jjdkv5TQ9ocUDyO+Se8=",
            "cpf": "U2FsdGVkX1/EV9Xe5h8mKXywZwecj6L5sQ6SA5GcjhQ="
          }, {
            "num_cand": "U2FsdGVkX19PNy3meDaszXU5fS2YMuwPO5Z0GVRWlTo=",
            "cpf": "U2FsdGVkX1861WukTZ31WgAq1M9rhPz3Ui+2llxvEFE="
          }, {
            "num_cand": "U2FsdGVkX1/Ek9dbtNoQ3nu1WVH/WFOn7vBiiDCd3fA=",
            "cpf": "U2FsdGVkX19uIFHp7HnoVESlD7Z49BEGvm+BwAYGaZE="
          }, {
            "num_cand": "U2FsdGVkX19INi5H5KRRQ0zlwwG10YxtQ2YSH3c345Q=",
            "cpf": "U2FsdGVkX19356v42HjveCevD1aGPM2pyBks7hRSWwI="
          }, {
            "num_cand": "U2FsdGVkX1/tr3EejH06agcTPHUmwVUvxAQ+YYmFXGA=",
            "cpf": "U2FsdGVkX19Fgl0cO2aejEpPI2U3/aSc5HVWuFD5uWk="
          }, {
            "num_cand": "U2FsdGVkX18ixgeHm0Rp8PNEJYSxOj9auCkNlAO8Wuo=",
            "cpf": "U2FsdGVkX1/7O8AgqwigVcvwRLaIy8ZRcN0PT871qbw="
          }, {
            "num_cand": "U2FsdGVkX1+3/ihfOEfLkGN4MSPJ9z6AF3iTmhLZsbM=",
            "cpf": "U2FsdGVkX1+JFsCftEBm51bJNRWFCKhUxeXqdUiMiJ0="
          }, {
            "num_cand": "U2FsdGVkX1+DxpEc3zeebbq1zTozBBcy3fEe7uayFAY=",
            "cpf": "U2FsdGVkX19/7TzR+pmmRO5Ge7XAIawh2rJlxb+AJBw="
          }, {
            "num_cand": "U2FsdGVkX18VAQp4JPLHarW2iWW6JOjEKn0/5upwSH4=",
            "cpf": "U2FsdGVkX1/4OazVrrx9Suo+9Q48wONtaNnpnCDahaY="
          }, {
            "num_cand": "U2FsdGVkX19NGOmBSyE2jOIz+To6PJkV+x7Rocxs+jw=",
            "cpf": "U2FsdGVkX19ZH36HiI1sFDcbjTvI8IW4zb5b1FYONK4="
          }, {
            "num_cand": "U2FsdGVkX1+Ag/bwle9vjdJPzShGf6YFUUT8IL/JLJA=",
            "cpf": "U2FsdGVkX19wk8kzNdhwZpAxa5BOu4ePIKQ+6cYp+Eo="
          }, {
            "num_cand": "U2FsdGVkX19BPRXAmqvcYsr6qJQnm+N68rmb6TZQ7cc=",
            "cpf": "U2FsdGVkX1+ovXYTH9wIYrDj6iVfBFzPX0Yf+03mWkM="
          }, {
            "num_cand": "U2FsdGVkX1/pRSaYzHTHDzhUP+lqZ+sgFpdKutXO36s=",
            "cpf": "U2FsdGVkX1/EVYWtllT/8sDYAu25VgYclbbDDOE0DGM="
          }, {
            "num_cand": "U2FsdGVkX1/Mn18dhpoBLWFuArtDJxw5STE/WYNeLL0=",
            "cpf": "U2FsdGVkX19jBodsLmszspPCslC0yRHiAW1mrWB7LGY="
          }, {
            "num_cand": "U2FsdGVkX19I8srI2VJJwYDBIWFKZfS9bKob0VBSDB0=",
            "cpf": "U2FsdGVkX1+GxLHTO6bYjljX5hyFXkeTdaTPzWmH324="
          }, {
            "num_cand": "U2FsdGVkX1+MgfqJOqh/MWxNOhKFhTb84WIvt7lWxBQ=",
            "cpf": "U2FsdGVkX1+IjGy1DmVvseekfm7l5zkzP15ATd7ZQb4="
          }, {
            "num_cand": "U2FsdGVkX1+/Ulvu8rY6iMlvlxkqtedxuuoqpJHKSnc=",
            "cpf": "U2FsdGVkX1+Qe2g9SrUZXd8imvLdiTRrv0+WQaYEcE8="
          }, {
            "num_cand": "U2FsdGVkX19R9yyaj49fJMp44Uz5vR8gUXy5QcNcNFw=",
            "cpf": "U2FsdGVkX1/88Ns/F/ugVQ5sggG1uOm3dO+azxZNK4k="
          }, {
            "num_cand": "U2FsdGVkX18J58OC/HDvZMj8Sb2TsOnvCbKMfCOlLDI=",
            "cpf": "U2FsdGVkX18b9aXGTjm8SDoqj2PX3I+RcT4osj+gjC4="
          }, {
            "num_cand": "U2FsdGVkX1+mI3TSEL/EKqolY6zubMfmPInN3mGYMms=",
            "cpf": "U2FsdGVkX18YWbXBBNhZZG6pX3h7Mxkvm6dDKqbIe44="
          }, {
            "num_cand": "U2FsdGVkX183p6U67AcRPXEsdW5bdxvi0P5ZUlFTsjc=",
            "cpf": "U2FsdGVkX19yUAU20q6ZZE0BozcwlyxmIZ2EJ2dbYqQ="
          }, {
            "num_cand": "U2FsdGVkX1/BqBAMrglYE58+qjzNuQ15Jd/GSaPr94c=",
            "cpf": "U2FsdGVkX195oj+Z5kguEakYWnqoyz88b75x2iMwctY="
          }, {
            "num_cand": "U2FsdGVkX1+OcgbwCwwcVP9Dphrw0lmDPkoN6Thz2/k=",
            "cpf": "U2FsdGVkX18VZTlq+EbW5wmzPpJGpYatq3KpvlkFkAE="
          }, {
            "num_cand": "U2FsdGVkX195cqu+dCr9l23qpk5+ONuT2dblUx9/310=",
            "cpf": "U2FsdGVkX1+9vKW3+CUdGYj/UuMmBDbYuuPcVLIBAf0="
          }, {
            "num_cand": "U2FsdGVkX1/J38E1hNWoTDun4/h/+QmYgHmXeEr2odA=",
            "cpf": "U2FsdGVkX1/TWpqRzAMRQiY7ZahJZQWgg4HowEmGbMs="
          }, {
            "num_cand": "U2FsdGVkX1/y0fD8tb8RKScyb3kfvHUgcyEiBUhoaDY=",
            "cpf": "U2FsdGVkX1+xavNAR2mAtB5GFJigLS5FOc1Gb32TilI="
          }, {
            "num_cand": "U2FsdGVkX19Z4P1+ao4c2LcgkQ7wURkaVQHjyv5wfHQ=",
            "cpf": "U2FsdGVkX1+z7cFX4BjtyoA+i3JkiF/4V2XqkpNI3CE="
          }, {
            "num_cand": "U2FsdGVkX19Kb9mlOqsXKcWT0fan8revHMGF8fAK8Hk=",
            "cpf": "U2FsdGVkX1+ivSlvfeP9qvB8s93SGbiJUhma6p8rlvo="
          }, {
            "num_cand": "U2FsdGVkX1+0vCWyrYAHWFA/hl1sqVQ+053b+VO5LTw=",
            "cpf": "U2FsdGVkX184BmcnQxZPnTdEt3FvzEC8MnbSWdZE+Co="
          }, {
            "num_cand": "U2FsdGVkX1/Xv6JMaRQ/RrakkfR1xKXtUU+omUVPU3g=",
            "cpf": "U2FsdGVkX18HZ9IxhzS5/o+jKH8pBVHbxeoIFFB9uWI="
          }, {
            "num_cand": "U2FsdGVkX1/dRAcCwi7N1swdXZCeJnRwv17LGqOXEyE=",
            "cpf": "U2FsdGVkX1/qTDuByJciKk8TvVlCG8P1BhUSbqUVUeI="
          }, {
            "num_cand": "U2FsdGVkX1+oUD0ytslw62P63s1ZbL7SE55x5+ky24g=",
            "cpf": "U2FsdGVkX1+VyONCtAW+dvU8GiQfAWK530QS3b/GmBw="
          }, {
            "num_cand": "U2FsdGVkX18/ACIWhSr6o4DhUCr8SLHT/AhH+OVGaQg=",
            "cpf": "U2FsdGVkX19vWktm5KWQDDIzFSc9xtrFZjkmGN3xDRs="
          }, {
            "num_cand": "U2FsdGVkX19csdiUlXQ8W0cUwys6l1z55pmFkMRC+D4=",
            "cpf": "U2FsdGVkX1/gU9VKBTiZnA1TpjvdNalSeZrsSUURvgQ="
          }, {
            "num_cand": "U2FsdGVkX19TnsgTTOQh0RWAjxaFM9B6xZfZf+ueKGA=",
            "cpf": "U2FsdGVkX1+LsWdj5C/eEvBfi5hadfVX921MjnQrPe8="
          }, {
            "num_cand": "U2FsdGVkX18Q/ItKfuIeSuOfUCzJnQWqPYYKRwiArwU=",
            "cpf": "U2FsdGVkX1+funNuVhN7v3MNo4XgLiOfHteY7lhvwbo="
          }, {
            "num_cand": "U2FsdGVkX182W1VULqLT3ag36IvvD4FY5agLIiwEquo=",
            "cpf": "U2FsdGVkX1/Pdb5PFcqh7iOOBtj91N7zoa4iHB30U38="
          }, {
            "num_cand": "U2FsdGVkX19lJi38bym0qF+MCIKwuOJOfoL8zf9phIA=",
            "cpf": "U2FsdGVkX1+EoqqIrmRdOiGtTQYJIZjPJRgJ4dECOGA="
          }, {
            "num_cand": "U2FsdGVkX1/gKlzFF7oD9LxTrU+DBrIIzFtffPhDbyo=",
            "cpf": "U2FsdGVkX1+0by3vwmoxp3K2dmC6rOjYqnZCcpM9Wgg="
          }, {
            "num_cand": "U2FsdGVkX1/qeHcBEHdQKNBdE5/mAggKFSOAedKr3MU=",
            "cpf": "U2FsdGVkX18MatO9qoXch7R8+bMZCf7XOhNUPSMJiSs="
          }, {
            "num_cand": "U2FsdGVkX19SBqUbKCRKRtVd7qtX8bV/zgg4RaO18Lc=",
            "cpf": "U2FsdGVkX1+n6WD31I+0LfMBeYWYI9FwzI/KNPOhY2w="
          }, {
            "num_cand": "U2FsdGVkX1+1g6dX+eHrehyARMty/sBerlQG8IO7B8A=",
            "cpf": "U2FsdGVkX1961FQrj9cwgS60n/cPfrD0KkCJyGaNXu8="
          }, {
            "num_cand": "U2FsdGVkX18hHJivdgPD218P/bs+CnAUCnRWv+Xzq8o=",
            "cpf": "U2FsdGVkX18o4SFpUsQepdwemDbBKOA2CgJ5IvN7S74="
          }, {
            "num_cand": "U2FsdGVkX1+SU0L9SPdmUBMYKltYbtfCZL8pc/4Kb/I=",
            "cpf": "U2FsdGVkX19Tfio+sIGOhNAySErkwx47UzNdB3ZspKo="
          }, {
            "num_cand": "U2FsdGVkX18qHED0m/z8cRKl8vcOIdzviIZ3KFEPCGE=",
            "cpf": "U2FsdGVkX1+kLXMsnbLqKXxk4QQF1N4oVddAviO/zxM="
          }, {
            "num_cand": "U2FsdGVkX19JVJaR+Xz4kXpXNMNCzFzmsBAlUM0bQ8s=",
            "cpf": "U2FsdGVkX18ONLxg3jiA8jF9WpJ5lZ+4ZOMOxD0zH0I="
          }, {
            "num_cand": "U2FsdGVkX1+Lc+mirnD4lJTjkiHoqjAfJfwwAuzERyw=",
            "cpf": "U2FsdGVkX1+nKwiNa12+sdR4qg1UgI8mjViqbvCwps0="
          }, {
            "num_cand": "U2FsdGVkX1+Yp7dTEj9VeISmgQVVT5xiy3awoXCNZWI=",
            "cpf": "U2FsdGVkX1/g6xnlotrEXEH4WZrt2bEfdhRCnwwHdFc="
          }, {
            "num_cand": "U2FsdGVkX18c2GhzmxyMNChm9lmwfeSdGnd0NyV7Q0g=",
            "cpf": "U2FsdGVkX18FIPRFD0HEttSSRY8I3FTYtZOp0laE6XA="
          }, {
            "num_cand": "U2FsdGVkX19QRdNEYNPq265Ncg31v44+p6qHyPuskUw=",
            "cpf": "U2FsdGVkX198sOfQ2oN+pvgmWJ2pwzV2o4WN9sevJwQ="
          }, {
            "num_cand": "U2FsdGVkX1+aB0/+YwIDOecEzBtINH9SXdlH+SxNpeE=",
            "cpf": "U2FsdGVkX18Kv9vzB5p0CLy7zBK1CBvGKTh1KONtq0Q="
          }, {
            "num_cand": "U2FsdGVkX1+eagvOuha3Nby1CToayzsPRzrJHPAmXtM=",
            "cpf": "U2FsdGVkX1/BKYyyjbhLphUR7nXoRPMCoFmMPXNu11E="
          }, {
            "num_cand": "U2FsdGVkX1/N57myvsINK5yeD/AXVJTRY+SA4OMlwvo=",
            "cpf": "U2FsdGVkX18k3vA7bU2q9+zmpLxIbTHihIAyN4dBuXM="
          }, {
            "num_cand": "U2FsdGVkX1/NZjS+OfpVU9eh07+oQ2IRqOC7iAAUHw4=",
            "cpf": "U2FsdGVkX1+5eTiZ91E0XkqXC4Kg69/Y9BxRh9Xh73I="
          }, {
            "num_cand": "U2FsdGVkX19Km3KdSv3130Fts8AwwxnZr0Bz21ORw90=",
            "cpf": "U2FsdGVkX19vAGWgg7pkkTZdwqUF8N26iiK7r0fP0ss="
          }, {
            "num_cand": "U2FsdGVkX1+oepqP3m68NtHhNrKxa9+KCTjDB4lrbaY=",
            "cpf": "U2FsdGVkX1/a3H02o2WJWI454NKBvnsNTRN9fNEt9vE="
          }, {
            "num_cand": "U2FsdGVkX183oi5oQCW1ePMpXS64MvOUa0eaaXCesSY=",
            "cpf": "U2FsdGVkX19vEHyvScUnnPHcdmN3Lokm4ZkMIwbkz8A="
          }, {
            "num_cand": "U2FsdGVkX19qaWgxTWWd05MEPc1yZnQVYEIjgz1sXg0=",
            "cpf": "U2FsdGVkX19JOqAqAtmfFs7XnUTix2cltapLFdqAvEc="
          }, {
            "num_cand": "U2FsdGVkX19fgXadzyI52CTORP5RlY5MOFPSvVn/3Ig=",
            "cpf": "U2FsdGVkX1+3/OQG+hByaVqKG8Fc0WRqh1jxUglW5cE="
          }, {
            "num_cand": "U2FsdGVkX19ZaR34vT1upZHfJNixVO/wiWTaPzWhJ4U=",
            "cpf": "U2FsdGVkX1/ZkaJsj+y/Nxx/ZFv0zKm5PM12doRaLZY="
          }, {
            "num_cand": "U2FsdGVkX18UyV9WMyjoLMugchHjpy1375huFY/9Am8=",
            "cpf": "U2FsdGVkX1/RN5ayRlfzJ2FKud925F2AGABRSjab5PM="
          }, {
            "num_cand": "U2FsdGVkX18S613tWMZReOmRkuxbK+a/TcOu6KTibvU=",
            "cpf": "U2FsdGVkX18c38QPlMknwLVYGMbpII4ckAI0CfviD9Y="
          }, {
            "num_cand": "U2FsdGVkX196kO8/6ULrQ6yKddFgyoIvjyTyR7cgX7s=",
            "cpf": "U2FsdGVkX1/rtMY5WYGnli9vBzOcSbb9r+trs0lFHbY="
          }, {
            "num_cand": "U2FsdGVkX1/uOafF+Cq58L80YTjN+XjR/TsMd2fW1TI=",
            "cpf": "U2FsdGVkX19Wq2+r5EkNTrHb8fOpcfeOT08igvbJXQY="
          }, {
            "num_cand": "U2FsdGVkX1+OTqbM9Xq68EyfqaK6BsB2QgEQyEuAd2E=",
            "cpf": "U2FsdGVkX19ozrbkLZk31Ov/DXdy4HWK5UBIXXHBw6M="
          }, {
            "num_cand": "U2FsdGVkX18/oLHiZ5cR6qRQKIJs+m3xappNU24kpu4=",
            "cpf": "U2FsdGVkX1/XI/BVqlieGj/0OMdcX1NshYEuW0oFhzQ="
          }, {
            "num_cand": "U2FsdGVkX19HNshLE95NoPGb98gc+WOxFFcbjJm5KQY=",
            "cpf": "U2FsdGVkX1+WCnevDonXWfTvEuYtYfk/5OBwnBC/yHM="
          }, {
            "num_cand": "U2FsdGVkX1/yLdBMXIh0ogLPhNGXqwyRC3N4kUYL/Mg=",
            "cpf": "U2FsdGVkX19t6OdhCOg8fvfmGeZfpx/HCtK7Rbfs94k="
          }, {
            "num_cand": "U2FsdGVkX196B0uC+9Ig1zfWWwAoxDOu2+HAH9EIQyI=",
            "cpf": "U2FsdGVkX18GFuV/X0dxDLXgXR6MUwj426DVDw7E7aA="
          }, {
            "num_cand": "U2FsdGVkX18Rf5OQNqOHDQ8zmmCZMC3/XBQugBukvm4=",
            "cpf": "U2FsdGVkX18szqIi+OjHyo7kqUunEaMYkiM0Xw3JarU="
          }, {
            "num_cand": "U2FsdGVkX1944D/mEHR0sb3LOOMlI+aC2C/GTsMUscs=",
            "cpf": "U2FsdGVkX1/kpT8oogPmuHowtqfT8lycJYgbboAIl3s="
          }, {
            "num_cand": "U2FsdGVkX1/8iScmKRyZuq1ZudLeniLPqEMvjByTLEg=",
            "cpf": "U2FsdGVkX1+nwumYtD/PuQhCMgNcHuX7s7UoiAFiGr4="
          }, {
            "num_cand": "U2FsdGVkX19JOWECuAKQvnN+SACC8LjQNBjomP3r334=",
            "cpf": "U2FsdGVkX193P0LrPc77PaVBRSAAKgp+pJy0jovaZ7g="
          }, {
            "num_cand": "U2FsdGVkX1+PBAOMihnLUFklpw2kXvcmwV1FJo609Vw=",
            "cpf": "U2FsdGVkX1+H8to8mQN6lqTL4comRmZV8ZGZES5fNi0="
          }, {
            "num_cand": "U2FsdGVkX1+VVK61P/+L/EgbEFAEJI7R3kd8ilX2kP8=",
            "cpf": "U2FsdGVkX19jjGB4cG5InBFGFodkQmE+OyU5FWVPXdk="
          }, {
            "num_cand": "U2FsdGVkX18kk+vzyr6ZrYNP3S9CB+8KyMsoJfy1yZU=",
            "cpf": "U2FsdGVkX18Q9FpSLfNeeRZohzFnQxd2CMimOurWi6I="
          }, {
            "num_cand": "U2FsdGVkX18qk2A0mvG0pJ7dhMir57o/gwA1aCcOGr8=",
            "cpf": "U2FsdGVkX1/ac5jCFH9fYuPS+pv2U5CtiN6Yw7qKGR8="
          }, {
            "num_cand": "U2FsdGVkX18+AN2rjubj9MP+azS5JiLVrPzt04bnN48=",
            "cpf": "U2FsdGVkX1/iQaveyieLL4oDKYPZkNIEl/xETPZuVvk="
          }, {
            "num_cand": "U2FsdGVkX18YE53cDT1aBYoJThcYGvEGfKX+AkzJs50=",
            "cpf": "U2FsdGVkX1+/VE4hZGladTRy+B4XYNztXbGIGISz86U="
          }, {
            "num_cand": "U2FsdGVkX1/ym3tdAAvialavHxmIhu1waU5AoTgqDAg=",
            "cpf": "U2FsdGVkX19QdeWGHsiqB2O+EmcC5+9jC2TIhbuDII0="
          }, {
            "num_cand": "U2FsdGVkX1/1YIZTIjVkDZH4nCTWimkIUq65EIWvCFQ=",
            "cpf": "U2FsdGVkX19iR9lvLbuI+ztrmmlHU4h4bgTwmK5IpAo="
          }, {
            "num_cand": "U2FsdGVkX1+hrL3d7Lovi09VO1Vh8/bBdIfzeIAK0aw=",
            "cpf": "U2FsdGVkX1/OT/QYNS6FivL1+vFDVjZ4LsjeBJqYtY4="
          }, {
            "num_cand": "U2FsdGVkX19l4h0yjJcbdIjQPZz0IhG461HW3uZieBY=",
            "cpf": "U2FsdGVkX1+Zoia6F4+vNbsBFS5L7WOXdPPBEdCxVaE="
          }, {
            "num_cand": "U2FsdGVkX19AjF4ms2Esl23AYiF5vpvTlPjGcVYpHkg=",
            "cpf": "U2FsdGVkX1/XJuhMmRdB+af7jamlKm5BNYEDxdzdvD8="
          }, {
            "num_cand": "U2FsdGVkX1+UAnRAkIcF+ZWJj0I6CnjhkEr8Nfo3Q4g=",
            "cpf": "U2FsdGVkX18o1tQhZquAUnTNvWynDU8KAka0FelzuyY="
          }, {
            "num_cand": "U2FsdGVkX1+uEK+OoFJhKHOhITWFLBPabqs2gHYUA2Y=",
            "cpf": "U2FsdGVkX19aayHXHCKaQ8iY2YDKJm5MH9Y3OKUONJY="
          }, {
            "num_cand": "U2FsdGVkX190Cr1hse9yFkJC73ylz4pXhmpBsiLBgNM=",
            "cpf": "U2FsdGVkX192pm9OixtwTvjO3omUOay62jQT/yBNhBQ="
          }, {
            "num_cand": "U2FsdGVkX1+5DGSZdqy4xuxL237F7hcMfhrjgw89gV4=",
            "cpf": "U2FsdGVkX187573dNMeE6/ovGGd6+FHG6ZA+48c5+0E="
          }, {
            "num_cand": "U2FsdGVkX196IjIyQ8XO35KJpCIefsvKb77nWy0CkAQ=",
            "cpf": "U2FsdGVkX181tDlx/S0NMRnxyyI4ET2yjYTF9+Pb8h8="
          }, {
            "num_cand": "U2FsdGVkX19Kg2YRcS689p27Pnl6S4hgZKQ2+WuRRfQ=",
            "cpf": "U2FsdGVkX18Iu1M5utQ7bUimbR6gRnO+vU59Ky8To0M="
          }, {
            "num_cand": "U2FsdGVkX1/IoSApbbl+z9IOBWsRY1Ewpt9KLjemyTc=",
            "cpf": "U2FsdGVkX19d8Z3GO6ayA43QYJ4i3xdhVhY8i+We6Ao="
          }, {
            "num_cand": "U2FsdGVkX189a2b7KNbPYoo93JJIGgV1i501KCRAjIk=",
            "cpf": "U2FsdGVkX197EncID0epNIVGlrwka/eHLrVM6QQDqBo="
          }, {
            "num_cand": "U2FsdGVkX1/mTJadRb2oPEMJcNBlpSVImNeFnMHMPrs=",
            "cpf": "U2FsdGVkX19C7dYf0xoIDUH/XSQdldhk54XazM38DqA="
          }, {
            "num_cand": "U2FsdGVkX189zz51lrsf1WrnOOefYElMyM/mbNwpM9U=",
            "cpf": "U2FsdGVkX1+RsTNU2ihP1ksjk/ftRRLRFl9Iz3VaF2M="
          }, {
            "num_cand": "U2FsdGVkX1/Fs79JOoa+mUvabWXTY8TSd9Ykz78twyc=",
            "cpf": "U2FsdGVkX19Ixd7eQKaYSFVHofHYN1wqOpT41MWnc7k="
          }, {
            "num_cand": "U2FsdGVkX19Zqi8M2TS8tMHp8b0/xakAUhCzuFshAoU=",
            "cpf": "U2FsdGVkX18MJTIC4pkI9iaIpzv7xKssKMSQpGrL3as="
          }, {
            "num_cand": "U2FsdGVkX19lC+xqut/4q3EgdeR3iwGDSKF5C61JamQ=",
            "cpf": "U2FsdGVkX1836zu6k9PX9CqiHk6fMjiC0mJAcYHQ+9s="
          }, {
            "num_cand": "U2FsdGVkX18D0MzZ7Fd1facoZnkNN2DikE0KAgzkKvU=",
            "cpf": "U2FsdGVkX18Ynl5AAF1etwyx63SxjHn7A30Phcz1Zdw="
          }, {
            "num_cand": "U2FsdGVkX19piSuDkEcbhslRkThTuIzQZFj9sKqAMoA=",
            "cpf": "U2FsdGVkX1+7Bn6Z53JKQPI5lrfoXbOpgYEGgbRC0Ec="
          }, {
            "num_cand": "U2FsdGVkX1/6odMC9BtStWzP+MzDnICS5FqBTn+I57Y=",
            "cpf": "U2FsdGVkX19v2uYG6UskQwrfi6MS95ez0qsOcFmYyOs="
          }, {
            "num_cand": "U2FsdGVkX19JvYJxOhFr7sESkil4mFnjnftWR4otTs8=",
            "cpf": "U2FsdGVkX1/4/axz4J6jKIGzGz/UiWK4fYzSHA/CnFw="
          }, {
            "num_cand": "U2FsdGVkX1/wmmW2xCwCzRDlBMfwZDxCO9mP1H4M3bA=",
            "cpf": "U2FsdGVkX1/qY4NK0tHwZV8yYaWNel63b26DQVSZA5g="
          }, {
            "num_cand": "U2FsdGVkX1/vPKpk4OkIsTfNAHauEHqn1K0LSqzBuwU=",
            "cpf": "U2FsdGVkX1/HODzItFqv+b6HRaEQZKc3rtPTzs34dE4="
          }, {
            "num_cand": "U2FsdGVkX18NDDDWIi/o1M2+E+0pQcG1bfz8Hsv88bc=",
            "cpf": "U2FsdGVkX19DYOtk24GUVg/kKGTFtNMIo2iNbewEjA4="
          }, {
            "num_cand": "U2FsdGVkX19WwbunGT4fJWKazNtZ4nUTH4Fnwm3Vd1g=",
            "cpf": "U2FsdGVkX1/a2YpoiMxZ+Vu1BPtw3hMVrQw9skkdvc0="
          }, {
            "num_cand": "U2FsdGVkX1/gJRNHuPByRUXKc199Ckz8CI28tJsTEWQ=",
            "cpf": "U2FsdGVkX1+di3e3UI/I+rWVxHMgGDTtp5Q+gqzCul4="
          }, {
            "num_cand": "U2FsdGVkX1+/SFbAGcEcJpqUKUgSePaGiL1PAHQb2dI=",
            "cpf": "U2FsdGVkX19b3DItkZgeUfdaD9RWYzWzvj2LNCY76LY="
          }, {
            "num_cand": "U2FsdGVkX19pXUwAOf0vRc3sTghi8h7szX5tKAOaSCI=",
            "cpf": "U2FsdGVkX1/pBI00D1Cwlh5XBMrQpat/NgsqybDsBP8="
          }, {
            "num_cand": "U2FsdGVkX1+fzoqldYx2wc3IayTUlJqhgB2IM6ZVVM4=",
            "cpf": "U2FsdGVkX1+z29PcJz8vu/OGoPah0zYrUC+lfkxQxws="
          }, {
            "num_cand": "U2FsdGVkX1+o5+oQ+xKlDodUbSAwA3hO8uUjXqCxMZM=",
            "cpf": "U2FsdGVkX19h3O/Vt5ClOyRno12aB7w/lsevdTW4F2E="
          }, {
            "num_cand": "U2FsdGVkX1+fVZTuXX8K9+hx4d2tyoky6AaHm9fHjcM=",
            "cpf": "U2FsdGVkX199VSsG28X3ChVA9iRx4SyfNXzxB7+1yug="
          }, {
            "num_cand": "U2FsdGVkX18FWnsMeeqmcWJFbF6LjKv6Rya00SApe9o=",
            "cpf": "U2FsdGVkX18W2VB3j0oOFBQWt5tX1aupwCeQwSYRhoM="
          }, {
            "num_cand": "U2FsdGVkX1+PnSKzZ9PT4wL818k5bkLqh9O1V63cbFs=",
            "cpf": "U2FsdGVkX19Olp1BaoK1KbB2d31DgQJoJBtHVbhPLek="
          }, {
            "num_cand": "U2FsdGVkX1/JnuWVmWCZ2pp7hfifJDbWn+uBker3Tq4=",
            "cpf": "U2FsdGVkX1+3XIszPtujIoUZVDhize5srJkYHp0jUuc="
          }, {
            "num_cand": "U2FsdGVkX18tfQnvOwWWJzCN3d7ADBg12z2Tc4AVVZM=",
            "cpf": "U2FsdGVkX1/zG+E+DTJumyRIHXJHnjOXR4I/ufhxaXg="
          }, {
            "num_cand": "U2FsdGVkX1+oHZSq9ZlDRu4Rfoq20Hr/S4C9eOiNNbw=",
            "cpf": "U2FsdGVkX185HAgh68tS9RTUei8/rKbNpMi86jK/iUE="
          }, {
            "num_cand": "U2FsdGVkX18mIZs/26kSQA9T4wStEM3WqHvgkCYbGRU=",
            "cpf": "U2FsdGVkX1/UlNr82WBSNKA1O2pYpmwzUqi3njpz2XE="
          }, {
            "num_cand": "U2FsdGVkX1+1tB0QlMtz2uExEG0fJHaOLbS3eeBJZgY=",
            "cpf": "U2FsdGVkX1+j3WAmkwps+3nuIlbH0VIfhXaD7VnnO40="
          }, {
            "num_cand": "U2FsdGVkX19CixZ3JkxWXrTsNhNfA9WYmVCN5XHgQnw=",
            "cpf": "U2FsdGVkX18FM3JK6ddnT5Dj0KJEP4zJuGUh/occpwg="
          }, {
            "num_cand": "U2FsdGVkX18RhgaFDudVySPjQ86K0/CbdQ9bv1vOAaI=",
            "cpf": "U2FsdGVkX1+1St7A0KlL68Cs5gVJZeAgTi3dc4sK6II="
          }, {
            "num_cand": "U2FsdGVkX19+ruWhRcHCHA31Azjvp1B7samFCflvgFE=",
            "cpf": "U2FsdGVkX19slnT7v0bzYCGI8pYmT9HY7NFxbuIbaEY="
          }, {
            "num_cand": "U2FsdGVkX19OZizJSOxkro4gupoLfXAM3EqpMg/cp4s=",
            "cpf": "U2FsdGVkX1+9D2zb+aWlFsda1KKixu/5GQ8r+ywRmsM="
          }, {
            "num_cand": "U2FsdGVkX1/tGUThQXwYwrvdAVrmqKVZ+hSzu48buOg=",
            "cpf": "U2FsdGVkX19Gz0+bHL4P6ebu2CiLr7ZKhLEZUbmkH7o="
          }, {
            "num_cand": "U2FsdGVkX1+1093wHOyKGnxGxGIuzcT2pkd+dD2kbM0=",
            "cpf": "U2FsdGVkX1+abtyoh2EpdyZWX1lQJS2OtpoxBzOME9s="
          }, {
            "num_cand": "U2FsdGVkX19rpMI0A3vPYuz9/iV9RMECkrZnhfF0wsY=",
            "cpf": "U2FsdGVkX1+pSJTevJ97ZrhmCU9Wm3KaNVk6FDSgG04="
          }, {
            "num_cand": "U2FsdGVkX189RX0GA2Xy+ks0vbSzMSOKbG/GPK+P+mQ=",
            "cpf": "U2FsdGVkX1/dYw9GD77yH0MPsLQS/8usIXGpnt3rqRc="
          }, {
            "num_cand": "U2FsdGVkX19I5zEkm28OItyo9Eks85vD1yAWXd2QtW0=",
            "cpf": "U2FsdGVkX19A5rzIRAYN/v5DHBpcF9+lYz8893nbu/U="
          }, {
            "num_cand": "U2FsdGVkX1/8UagJiLUoIwSAcYUdMSQTPCEdyhvf6TE=",
            "cpf": "U2FsdGVkX1/epIR8TsRz9HH4Tq2on7GOhTJ5jnYwZho="
          }, {
            "num_cand": "U2FsdGVkX18hPG59WDP7ipR2JaOZQlk6Cz0MFail2L4=",
            "cpf": "U2FsdGVkX1/9WwmWIK35xe9XlgYIeOi1zwnhPHl0aMo="
          }, {
            "num_cand": "U2FsdGVkX18+1FTapyG7by5h35TxbX+nbuGnkEPKdGI=",
            "cpf": "U2FsdGVkX1/nfU0/qrZzjMH5i8dGprN+OvETXlKWlZ4="
          }, {
            "num_cand": "U2FsdGVkX1+We7QdHsaiwGHDLpkelE7P5f8Dx9abeYo=",
            "cpf": "U2FsdGVkX1+5aUIsXRgcXEOYPgq6TbPafdECH256i+U="
          }, {
            "num_cand": "U2FsdGVkX18jU6E7DWXuXvi7VIxGdGY9YSfmBn76qJE=",
            "cpf": "U2FsdGVkX1+XblsdZ2u3rBLZcJjWaNL9ta6DDSnnoZQ="
          }, {
            "num_cand": "U2FsdGVkX18L6MSaly2q9w98T4rjrj5TkO+xACRaG9M=",
            "cpf": "U2FsdGVkX1/Bd4rM7vnCeDi8Pa9+ryUje7f0hGEQlfk="
          }, {
            "num_cand": "U2FsdGVkX1+oTKc2TM3xEMMU3BLxFZGGdr9FUATjKog=",
            "cpf": "U2FsdGVkX197kq34l2TYx8n54JJ24prk1hDHaoSCBi4="
          }, {
            "num_cand": "U2FsdGVkX19qRuGBNgg0sDNuiAZXcRz0hjm++kcBtRA=",
            "cpf": "U2FsdGVkX1+NYzVTjSLoMrKFqskYn36MSu2lxRGQSfI="
          }, {
            "num_cand": "U2FsdGVkX1+pwjKqXbFfUnQSyZg9EKOFJivC3eWeffI=",
            "cpf": "U2FsdGVkX19ZkSS6yrpicI46ftcyDhOv//6qwxPiAY0="
          }, {
            "num_cand": "U2FsdGVkX18E64TLxbLhqL4W1cU+fiEnpA2HjBuzJsA=",
            "cpf": "U2FsdGVkX1+6JnHpPhy7/8CZfFyLy0GCSgt7sG9n2JA="
          }, {
            "num_cand": "U2FsdGVkX18UC+7x9I87+XqbTi8jZ2z5rye4zmaeFj8=",
            "cpf": "U2FsdGVkX1/Ysg9R+mFxU53VXWK6Oa/65ga3YGLlkPM="
          }, {
            "num_cand": "U2FsdGVkX1/LhPZTD0lwdqBVaGBsdUVKNBO1g4XA/1U=",
            "cpf": "U2FsdGVkX18trM+LqeUN7mZzAJC48S3zJEvbiqjCye4="
          }, {
            "num_cand": "U2FsdGVkX1/UnC4gkAtTWcXbf7qXJRF4FX2uF4m5TyY=",
            "cpf": "U2FsdGVkX184qOYKTRCvhCV99GF/KNhhliqToTkgSi4="
          }, {
            "num_cand": "U2FsdGVkX19oI81PxDhodZaE7oSwF8HxJpP+MVMpvJE=",
            "cpf": "U2FsdGVkX1+dpHaoTL1+QUVkSUUNYj6u90iVOtR1oDc="
          }, {
            "num_cand": "U2FsdGVkX18F4QnyK+CKRvB4uB9m+XNZ3qKkL+xhSI4=",
            "cpf": "U2FsdGVkX1+byG1txVRMU62ou7Hx70YR9SjeAHFjCgY="
          }, {
            "num_cand": "U2FsdGVkX1/iBIUAd24VlY8FeKZVDiezAeCyVA1r+JQ=",
            "cpf": "U2FsdGVkX1/7MVBXlp/VddV3xu8DzIy4WV4pznXYaao="
          }, {
            "num_cand": "U2FsdGVkX19T9l/t30jnRzELNBAp+U9A5Aa/EEOlToY=",
            "cpf": "U2FsdGVkX1+0TKhGG2SW8MRrahc7AdYIBSsf3YR6Cqw="
          }, {
            "num_cand": "U2FsdGVkX1+FQDEWK1j2HcNYmZeeNmbJPkfF/WfRDpE=",
            "cpf": "U2FsdGVkX187sNCo4pJmIBn0PW3/BeOEbr+o3AsYG/Y="
          }, {
            "num_cand": "U2FsdGVkX18BF1mi8A3tv5/0Y9vcedCgUEZlcLlkT9A=",
            "cpf": "U2FsdGVkX193275n6ioUjf0ru7naP2SmDJIqn588OuQ="
          }, {
            "num_cand": "U2FsdGVkX19hDs8kmzbESB55wrBiF0WIf5fbYAHlqUM=",
            "cpf": "U2FsdGVkX19E8lCtzSE0CRfaAh8TX1Pvtdwk8uh3fXk="
          }, {
            "num_cand": "U2FsdGVkX182nW+so9BCRMQxmw/SNy92WEndCHYpg6g=",
            "cpf": "U2FsdGVkX192Oo2wqBees9sghLPh2AJ/G0OW2Lav2X4="
          }, {
            "num_cand": "U2FsdGVkX1+BWs7qimw756BjE8p799cVUHvF0IlqeoE=",
            "cpf": "U2FsdGVkX19JWOHtCiLzT70vn0FUC51sn+iUR0fi2uU="
          }, {
            "num_cand": "U2FsdGVkX18EsW/KDELg61BsQ2V+jxXOdJ7RYxoszN4=",
            "cpf": "U2FsdGVkX18P2mguvR8TOl4/UPQDCXoGIzbbrc4DwhA="
          }, {
            "num_cand": "U2FsdGVkX18xa+j2a+xZjNOLsnffCzJDt0TMlro3lkE=",
            "cpf": "U2FsdGVkX19IeeMHsT4AFUMQv1P6ntwqLx0pk+8gf5s="
          }, {
            "num_cand": "U2FsdGVkX19fcECYw8/oTMdU+il87Z51jVPXJ4TLAkw=",
            "cpf": "U2FsdGVkX1/Q9lDvNbgc/E6LB+Osou2VSxCkGuhuX9s="
          }, {
            "num_cand": "U2FsdGVkX18IfBk2G+NmeG6t+OvH+JWnKCpv7e0Z9P8=",
            "cpf": "U2FsdGVkX1/njkLqKRVU9bJXFU24UoHmhsfsIA7KUw0="
          }, {
            "num_cand": "U2FsdGVkX18ehFCsc9mA28VrJRbpeQndKPhTp9XN0rQ=",
            "cpf": "U2FsdGVkX19A3O1RdkV2tJzGdVkgi/cfwi1MJWgUyK8="
          }, {
            "num_cand": "U2FsdGVkX1/ZkKZC3PHsARMIBxrbSD2BiDmK8b1DrV0=",
            "cpf": "U2FsdGVkX1/d+uj9x2bNgBkwwNx4tlngUL0upo1BSis="
          }, {
            "num_cand": "U2FsdGVkX1/SVxw5fdTxX0KmiFtAooYPIaBujB+UWPk=",
            "cpf": "U2FsdGVkX18+J+D/AElBNb07mfG/vr73Ac0cPYLhGWM="
          }, {
            "num_cand": "U2FsdGVkX1+/1sW0XQO1x4n2wiKGcamW0NKumtM/csU=",
            "cpf": "U2FsdGVkX18m04ouOQE9IeO/87TNtws9nBdBvc3sZxE="
          }, {
            "num_cand": "U2FsdGVkX1+hv4rXpiJ6x1OYYx0MdWS7tcTyCg4ZZI8=",
            "cpf": "U2FsdGVkX1/tUZpVMa57JRTY0riTI4EWyXD3SjseNL0="
          }, {
            "num_cand": "U2FsdGVkX18s//Tku65ve1eEdB+O58q9tIDdDOtmUHQ=",
            "cpf": "U2FsdGVkX1/4tBHW4p+uH9bM4+riyiK84ktYRZTj8IA="
          }, {
            "num_cand": "U2FsdGVkX18K7gTJ5QGCRldm1BUwXvJNbyzHuggpECE=",
            "cpf": "U2FsdGVkX1834DISHEGDxAdZpxSLNF5ELtBgYifrBoo="
          }, {
            "num_cand": "U2FsdGVkX18HvmYrS354secVwunh7SAArbY1GetBx/I=",
            "cpf": "U2FsdGVkX19u5bT39qCPACeZV9PgxwHnBBU2f09vHIQ="
          }, {
            "num_cand": "U2FsdGVkX1+PNgQK95EfyRDO1cTjxEHcDG6CFyY70Sw=",
            "cpf": "U2FsdGVkX18J1nFezk8fQXZUgXd3OY7JZLU0/8IGq40="
          }, {
            "num_cand": "U2FsdGVkX1/G8aTyUz7wh1YY00jKAycj79hydAMAsBE=",
            "cpf": "U2FsdGVkX18dF9A6YeTE3E29nrCya5RsZ08Z3LzU1J0="
          }, {
            "num_cand": "U2FsdGVkX1/VBFCMz0azYuLUFen7gd5narYA7KMOuDQ=",
            "cpf": "U2FsdGVkX18CA5FOc6yQacBRE9hfIB55vFXtfDork5E="
          }, {
            "num_cand": "U2FsdGVkX19M283htKN7RVk7N1IkWTLrSiyVJjvXRm8=",
            "cpf": "U2FsdGVkX1+f39zVsgK6PpCyT6JOuc+vVN9uSAH+TRQ="
          }, {
            "num_cand": "U2FsdGVkX198JIl7MYgogwPNFcCTY6l7Moh37X+5Mu0=",
            "cpf": "U2FsdGVkX1+f8AsdbG1fDo4U+f59hHzBnmn/JS40ORU="
          }, {
            "num_cand": "U2FsdGVkX1/wzGJNMEySfQtPid5uj/G4hmQLsqRW5TE=",
            "cpf": "U2FsdGVkX1/cNMmNdzEh1KUBvGZ9jfjlJpwpsIXJUV0="
          }, {
            "num_cand": "U2FsdGVkX1805vsv8cLU6oZyE+a1H5P49xbNQHTNfXY=",
            "cpf": "U2FsdGVkX1+3EFqoZ9VtIrkKogvNnvWHhXY6U8XsqvU="
          }, {
            "num_cand": "U2FsdGVkX191HSsYEYC76J+9tR3SQecFHMWln9lvZh8=",
            "cpf": "U2FsdGVkX1+nql+qk2j2etqylKkgv6kRLeK4N9gCyYM="
          }, {
            "num_cand": "U2FsdGVkX18eJFz/Noxx4NZbfxNkzxMYpx5vsKFi8OU=",
            "cpf": "U2FsdGVkX1+DnkmhqojM51D7ksq7HOKRoD4cxpnQ0Cw="
          }, {
            "num_cand": "U2FsdGVkX18pb+L3EIiIA9nn3SFl0OI26bmkMt48B7w=",
            "cpf": "U2FsdGVkX18XfSz8zWD1iF1ACOWEhC9UWla9M1yMZW0="
          }, {
            "num_cand": "U2FsdGVkX18t3OawIj7b1KaT5eSomhjnp31jtY7EhT8=",
            "cpf": "U2FsdGVkX1/QZbkVTqzw/nmwrgKMcwXwJm01XTzutUs="
          }, {
            "num_cand": "U2FsdGVkX19cyPWXm+dFkTz41cL5N/p3X8RhQG6m27k=",
            "cpf": "U2FsdGVkX1/Jye7z0zPPsHkReVuABPq1EEDu4eZKmIE="
          }, {
            "num_cand": "U2FsdGVkX1/84bH9Lby62aMgXEGk/y36iloIkiBe6zg=",
            "cpf": "U2FsdGVkX1+sh4T5WgarmyfU35HRHJlwg7XCMpS47XM="
          }, {
            "num_cand": "U2FsdGVkX1+/+Tj01sj4W3T2TN/w3ZTzd9jcSzrXcRE=",
            "cpf": "U2FsdGVkX190kuoz76z79+C7dAVxh6RVCxoMeZNiuBY="
          }, {
            "num_cand": "U2FsdGVkX1+Pmo8RKptdaXFZKuFKu+wzI4fBRiYzXQA=",
            "cpf": "U2FsdGVkX1+NZ/bX2eCipTIGEuM4enuGbJY7IwBUi38="
          }, {
            "num_cand": "U2FsdGVkX1/55UOIzYQwq/mHPQ+42T4lAwYoIg9PxMM=",
            "cpf": "U2FsdGVkX1+i3wkbarzwkjJ6SmOXC3X3p0laRM1ztE4="
          }, {
            "num_cand": "U2FsdGVkX1+PLMx0M+qRBsiWDhLOtIkmbdPEKQ0jgp0=",
            "cpf": "U2FsdGVkX1/JIGH/q863n/I1/8H9g+d0AqpZ5yaC1BI="
          }, {
            "num_cand": "U2FsdGVkX18iYeyI/fOmBFD2fvXXxgCXDqGANWHdj3M=",
            "cpf": "U2FsdGVkX1+dsIy7IHqKz7yPicUl39FLqRQM8fheFq0="
          }, {
            "num_cand": "U2FsdGVkX18Um+z9UphKQ6sSlC5hskoRzOFesDRwzP4=",
            "cpf": "U2FsdGVkX18fACmTwKVNFvVIJ3vgrniCA+eyhSqQ9uc="
          }, {
            "num_cand": "U2FsdGVkX1/9EYzsMb8lOIYXs0S9WDxRPkma7TvLP3E=",
            "cpf": "U2FsdGVkX19g8EeX6UibesCEHvYk0In0QiMb3OEvsik="
          }, {
            "num_cand": "U2FsdGVkX19PoicZ4lfnG5oRBn/6F4iRSEVbhtph1Ow=",
            "cpf": "U2FsdGVkX187UzNPXkgoAhgC1YU1ymuFFV16aJSlvNI="
          }, {
            "num_cand": "U2FsdGVkX1/wRZJ1Jj80VdZKuPVdsPUPy5AYLh0F7YM=",
            "cpf": "U2FsdGVkX1+c6oOO1i+/6x71Dj9eAOAFXDjzzgSw904="
          }, {
            "num_cand": "U2FsdGVkX1/8tX8KkqYQT/f5QLINNLxqI57iGsP8Tb0=",
            "cpf": "U2FsdGVkX18TEiciPubYBX2Mzd7L9KD6hYKBI+6hJGA="
          }, {
            "num_cand": "U2FsdGVkX19z0kQHdnBMzREtCBCH2w+p8laQhWUvbes=",
            "cpf": "U2FsdGVkX19UFP/4HEL6r+uWyUjdHCOQMhPV63iDdQk="
          }, {
            "num_cand": "U2FsdGVkX19RtLjlk2/8s6H4tbtAYO7B8IOv791b82A=",
            "cpf": "U2FsdGVkX19nTIdWrSj7oWvYTa3kMtvscL22IRLxxV8="
          }, {
            "num_cand": "U2FsdGVkX1/pyBo1BNuWdW2flhiqyfE2a415gNgQAL8=",
            "cpf": "U2FsdGVkX1+NS5I2bsrnxB+dZvQNmVi0XBakRQ4WDGM="
          }, {
            "num_cand": "U2FsdGVkX19ahSBWKBOAUxaIvTwSvPfmbM4c2pJ/BAc=",
            "cpf": "U2FsdGVkX191Yzk+tRDN8stSruRbcese9HOIiXkKhhI="
          }, {
            "num_cand": "U2FsdGVkX19qR+FSKLthWpDLlnrz9NZXNogxhpcI9zY=",
            "cpf": "U2FsdGVkX1+mc8YlzbD5yULVR//m0hh/AAh7Pp0Lo3g="
          }, {
            "num_cand": "U2FsdGVkX1/sYXbPohlqlGKv/sysDgYGdCxC700SUsA=",
            "cpf": "U2FsdGVkX18bs1WUHO/Hjrnf8NT7LoHWdw65uTFfEWk="
          }, {
            "num_cand": "U2FsdGVkX18aT+Sgb7qqcn4q7r7hK+pjB4EcdEbWVck=",
            "cpf": "U2FsdGVkX18Q0co4+P6mwkTumDnwvPZ6BF56P/Hkaz0="
          }, {
            "num_cand": "U2FsdGVkX1/K/CnPjJQIBMi/QhJlFnQh3ZQ81wXZ6Dk=",
            "cpf": "U2FsdGVkX1+FWa8NGGZwa6Upbtz3cXC5J43d8ckv1K8="
          }, {
            "num_cand": "U2FsdGVkX1+NaNZwngpHdgh0SyuFdrpiaLjSQnhnfRA=",
            "cpf": "U2FsdGVkX19cd/2ZQS3CUJJEuRJGhXXM1g2TcUQzhx8="
          }, {
            "num_cand": "U2FsdGVkX1/71ihFujNRg621fjLo7Bk1S2AEEF0RJ2g=",
            "cpf": "U2FsdGVkX19bNvL7htg1Ppw1LS/etXdAA+kpxuw2Jh8="
          }, {
            "num_cand": "U2FsdGVkX196iw6EeE8RTaWx0FXAQ3QH85kGVqtrStc=",
            "cpf": "U2FsdGVkX1+8QYUe/5+MGHi6NHx4zAIwlXhukDN9+Yg="
          }, {
            "num_cand": "U2FsdGVkX1+7HJThrgvtQQm7t8wGi1Qb9LOt3NTUva4=",
            "cpf": "U2FsdGVkX19WsXdxnIyC4aPv8q+nI29HjQbukYZItt4="
          }, {
            "num_cand": "U2FsdGVkX18pVbHrAMr8xoDe9VxW0UQUeKAMbqVgPLM=",
            "cpf": "U2FsdGVkX1/fxalvrT38sQQX0UxkrJwIcxHHVSEbi6k="
          }, {
            "num_cand": "U2FsdGVkX18khOWSqxz1+fH9i5fRfc6Za8cfnvMnpJ8=",
            "cpf": "U2FsdGVkX18jnJ1CyfuIsbVDMbjXWpRy7zI/movMBg0="
          }, {
            "num_cand": "U2FsdGVkX191p8nzJq0neSVA6/66rwUoyDJFmjrod2U=",
            "cpf": "U2FsdGVkX19R6cSfcJJwxBTW6WgMSFI4kh3FdSaJM0o="
          }, {
            "num_cand": "U2FsdGVkX189FjULRxlTJqsaYvxPvagU0BkPlyTgDRM=",
            "cpf": "U2FsdGVkX19opsFazZaI6qZcCcoeINRdgMOaLTiefXk="
          }, {
            "num_cand": "U2FsdGVkX18NjBYebH8n7n17SmrcrxY6t9muE+5c+M8=",
            "cpf": "U2FsdGVkX1/PrWI+pwVuaHWSyu+T+wTcsPESf2OYUe8="
          }, {
            "num_cand": "U2FsdGVkX18G3E7lW5vepuEYVHGyMWaXzkg4r9dXh3s=",
            "cpf": "U2FsdGVkX19oy9MU8MjPtlGEO+ORJd0eYVMhLqVyhwQ="
          }, {
            "num_cand": "U2FsdGVkX19j4RvKmN8Ftdaf18Mc/zqr+wknIQbCGcc=",
            "cpf": "U2FsdGVkX19LO4++xYWbSjEHakyCGL14aDo1D2H2Fvk="
          }, {
            "num_cand": "U2FsdGVkX18vtg+Q5rDYOB03vmjYX8iFozeMl30fXuQ=",
            "cpf": "U2FsdGVkX1+6QK3KTMJr5NG95SNUhTEj4H6Yh1KZm+I="
          }, {
            "num_cand": "U2FsdGVkX1/OrUYAG3bZRY4rk9wGoIQU6Jnj5Z7EBYM=",
            "cpf": "U2FsdGVkX19TODBNgfl6AEOgdrneyOFyCxdcqPeJ6Y8="
          }, {
            "num_cand": "U2FsdGVkX1/m1mNaY1VLXNvZIe2uIsQSRB5l8eYerwk=",
            "cpf": "U2FsdGVkX19Kuo3e4eqJtQuqBjgeqRiGNgJY3A37prs="
          }, {
            "num_cand": "U2FsdGVkX193Yk+2WvGasZP7BVZR2pOejo/zgzDkKa4=",
            "cpf": "U2FsdGVkX1+ETkCGcSRPCjYf8r9Bik+AjZcJgPVk5sw="
          }, {
            "num_cand": "U2FsdGVkX1+VH7CkBelc1tMSJ0+PDzlNnlzH+mUEuYk=",
            "cpf": "U2FsdGVkX18YocPu5d3A2g9RDKSLdeOZNTYpKUclCi0="
          }, {
            "num_cand": "U2FsdGVkX18um5tEDE7E2GPtYHeUG/DK2DtWf5u1qH4=",
            "cpf": "U2FsdGVkX1/VoVxYtd0CJRp7rN5aCDbZwTucqEL8z24="
          }, {
            "num_cand": "U2FsdGVkX1/otASmxahQAeA1wEOdYsHo65exO4WrK6M=",
            "cpf": "U2FsdGVkX1/IZsSuhlvuwfTiKEZF5UXz/C7phxeJ484="
          }, {
            "num_cand": "U2FsdGVkX1/364NDowKvejOT35mOF0LG6VL9Bccc7tM=",
            "cpf": "U2FsdGVkX19eQh7BUguHK4yqC4xuW7U6sannjQWbuW4="
          }, {
            "num_cand": "U2FsdGVkX19jMTXgOOh9/0ns6k0ncaJXRb3yDBOg+K8=",
            "cpf": "U2FsdGVkX18n/NAL7n1AwFMAXUA3AoJMNEaLUB5eYhM="
          }, {
            "num_cand": "U2FsdGVkX1+z/Ohc+/LSN0qgh53GPMZ1MgKu06HxqpI=",
            "cpf": "U2FsdGVkX19IcG7PKCLoLIQrxY6t9ScPf2QbAMkcyww="
          }, {
            "num_cand": "U2FsdGVkX198+e6ZV25qxIGmVZsm2UfLQymh2Yj7mYs=",
            "cpf": "U2FsdGVkX188Q0IyidTPDklPfwA/26JOsChUzgIXL1I="
          }, {
            "num_cand": "U2FsdGVkX1+OPymJA1wD7nb7joQJZsunq8Nk57LUnTY=",
            "cpf": "U2FsdGVkX18W0hjviX/4S3XFMOctkH0kG3bwgZrriJE="
          }, {
            "num_cand": "U2FsdGVkX19cpa2ymbtrYXz0qp2BnhLw3pn7jB1yqyo=",
            "cpf": "U2FsdGVkX19c2bCmop2WqRmJ4dCi7hHZJTCwsy+177Q="
          }, {
            "num_cand": "U2FsdGVkX19SlMyKKjU6P5S8+UltFK/9qTHrOoeNsfc=",
            "cpf": "U2FsdGVkX19xsGQ0ZM11IKXfdRaLmiq+0vY8q0Cy6hY="
          }, {
            "num_cand": "U2FsdGVkX18SxG/wxAHrdVhPxRDjjJFla4BRUTfr11o=",
            "cpf": "U2FsdGVkX19gSPSntEvlYlpMKgFPdqcNELmImSyGD5c="
          }, {
            "num_cand": "U2FsdGVkX1+nuYa3FBT+FOhNakF1Uw/ZYh5vtOKy+Bw=",
            "cpf": "U2FsdGVkX1/esB5PMcwmBezlFOuvoBY3u4Nr1E07Zxs="
          }, {
            "num_cand": "U2FsdGVkX1/l78BiSp1MeefPkiZc555lbUizYHlIWcY=",
            "cpf": "U2FsdGVkX1+IWZCk1W/vAVw2H98arsnvc7ugCaWwW98="
          }, {
            "num_cand": "U2FsdGVkX1848kK8dztnmgpvIRcxpE5fPi4lxlYyeZs=",
            "cpf": "U2FsdGVkX1+rP0SIs0VMVbM97F18yMQ16eS3YweVDbw="
          }, {
            "num_cand": "U2FsdGVkX1+3HmZsgLMevM0m9bFxTMxFdvj/KzlTZQU=",
            "cpf": "U2FsdGVkX19GLMAycQUdC/WfEMaLKDTDWfzRd0UOFFI="
          }, {
            "num_cand": "U2FsdGVkX18swP183GI9FTAFSTwmAnVX6NhKjGzfIbU=",
            "cpf": "U2FsdGVkX18/eGrXCqzBUEHTqqKa3bio8UMGgQeXS84="
          }, {
            "num_cand": "U2FsdGVkX18WiBKrHnWGGi/fL7TEIuKZvDuu2mQ6W40=",
            "cpf": "U2FsdGVkX1/BQu0w3W27/IQSMLmBrNceKuaJzY3nW3I="
          }, {
            "num_cand": "U2FsdGVkX184MHraekrcltXTjxno4G0aQ4m0xIuP++w=",
            "cpf": "U2FsdGVkX195ku/1H1miDyx5UEZdiUs+fkAe7JIz7eA="
          }, {
            "num_cand": "U2FsdGVkX1/jgVOdezN/brsFvEleBqJJjhgUtkQtCEE=",
            "cpf": "U2FsdGVkX1+SnlIxOIntdlLhvZbJw/Io5I+GeXEvsaM="
          }, {
            "num_cand": "U2FsdGVkX18BO7/vHbnfheKybqEyMDjwy2L8dtdHBLA=",
            "cpf": "U2FsdGVkX1/Ae0KNOmwGRom0VxviSY9i/vzRn6sEgyk="
          }, {
            "num_cand": "U2FsdGVkX1/M/Xw8LHxvh64QieYP8mj+zTg2T9yLVi4=",
            "cpf": "U2FsdGVkX18yqY19oLelqNa/qQjVOES6vCeLwq0TpGA="
          }, {
            "num_cand": "U2FsdGVkX19AXbY8evHPTEWXa6LrNSq+UZfYOyRITz4=",
            "cpf": "U2FsdGVkX1+FvdfWvDTnCD2bXKhZpgfPfE8NSjRXzlw="
          }, {
            "num_cand": "U2FsdGVkX1/Gpo7opiBdK5To/o0QsN6NNEamNeFpTrM=",
            "cpf": "U2FsdGVkX1/Rh6VEZZY5JgIVPsP23RSshyRDQa4AIl4="
          }, {
            "num_cand": "U2FsdGVkX19Bix+lh9WAopEDVCPcSOTDPntluNPHk6E=",
            "cpf": "U2FsdGVkX1/rcVNMVScv5EfuomCjZMFYiJz5JHy/GSM="
          }, {
            "num_cand": "U2FsdGVkX183fWa0xcHlC9k+pPGGib5LDr3rULSDg2w=",
            "cpf": "U2FsdGVkX1/8SX08hKPxt7wLDmika5sTD/Qg/pRO1jE="
          }, {
            "num_cand": "U2FsdGVkX1+ApRptNhq7Qki6duQAyYdl0JYbHa4KjwQ=",
            "cpf": "U2FsdGVkX19tKUnjU/Z3rv1PCcRsiqerOtM2gnIEO0s="
          }, {
            "num_cand": "U2FsdGVkX1+G9ORXyGWAArMbGYOgmUZCJS7yBCjH69g=",
            "cpf": "U2FsdGVkX18/MJPyXg5SmJVPLfSDW1blN4ZfS5t62mM="
          }, {
            "num_cand": "U2FsdGVkX19mgfgmkxgucNDHbVAyUtB1Y8XVo7+falQ=",
            "cpf": "U2FsdGVkX1+KpNliZQr2mrd4pGXn+/y2OMRgSZV9jYo="
          }, {
            "num_cand": "U2FsdGVkX1/ywP5ja6TGNuG/f31TXBhKF1/GULqQpdM=",
            "cpf": "U2FsdGVkX18iIsdUMyBYZJ6gR0vgzO5gbPRMkwE8suQ="
          }, {
            "num_cand": "U2FsdGVkX1/7i35JpPKw6Vfc+CLoZVTTMfe3B+yUCJY=",
            "cpf": "U2FsdGVkX1+qgQNAaoDI1EzNV6ls4lUURuO2K9OUdE4="
          }, {
            "num_cand": "U2FsdGVkX1//ih7WdK5bKP7q8ILfP8SncdZ81PcaaHc=",
            "cpf": "U2FsdGVkX19MZz8oaQATGp0deyz9w2er1oin4R56Iaw="
          }, {
            "num_cand": "U2FsdGVkX19NrhH1K4ys0PTtuNd3vTTyJ4Tl3lxpp+Y=",
            "cpf": "U2FsdGVkX1/+FJiSk8W8cnM5TPnADAl9jiQUaUjFh+0="
          }, {
            "num_cand": "U2FsdGVkX18h3EmD3UotuSmlmLsq8zLIJpu1dcA6CgY=",
            "cpf": "U2FsdGVkX1/KTKrMaaGMTYtKU4bwD8fnApU6fKbAwwI="
          }, {
            "num_cand": "U2FsdGVkX1+WztGf0peCTV50nxwx8sc1gKEsz2kjI6I=",
            "cpf": "U2FsdGVkX1/23mC8GLmHc2px9cKmN1MRdbyFp3aRcM8="
          }, {
            "num_cand": "U2FsdGVkX1+ZP8fCNvL/7RDKqszE0teFojsVXo8wY30=",
            "cpf": "U2FsdGVkX19jYJx83N984mtvpIg7BMe4fYvBSr+ajqc="
          }, {
            "num_cand": "U2FsdGVkX19Q+jPVQjfqJn3BoTV+rj4GmCVTFFtCgxM=",
            "cpf": "U2FsdGVkX1/P1kfen8arY/S/OPrPBEDn8ELIDh07vZ8="
          }, {
            "num_cand": "U2FsdGVkX1/ZB2BWOQbTYjCGd6LQIGt0E4jddptJOuE=",
            "cpf": "U2FsdGVkX1/w+NMEr8fEmQJRa124HLRJRn+5Nq6uBrg="
          }, {
            "num_cand": "U2FsdGVkX1/iPl+m/9XHKKmPrI+dXWD/qwlLKaFSY7A=",
            "cpf": "U2FsdGVkX18dwrAtpxZVckF1S8cobLZq4HXl1kmNJRY="
          }, {
            "num_cand": "U2FsdGVkX18a9D/GgQuf4+eZdnk8/YaBjtJFkYAAJxY=",
            "cpf": "U2FsdGVkX19fOCzjdhn0c59TLa6xhNl3I8Al9+nJBuo="
          }, {
            "num_cand": "U2FsdGVkX18Ry9w4y+kP7er/hwOYyMcOtUX3/kBpyTQ=",
            "cpf": "U2FsdGVkX1+aoMJQe8dYyn1AmiQKpGzHELlg3JjJTkw="
          }, {
            "num_cand": "U2FsdGVkX1+/MarKaScuk6QYG8QkvMxuenwPNITDX/c=",
            "cpf": "U2FsdGVkX193bP/q5QNZ67513KMqeG0UHj9JUNXYv4M="
          }, {
            "num_cand": "U2FsdGVkX18X2EdQE5izpISTld26Hw0W1LBicYrTUuY=",
            "cpf": "U2FsdGVkX19zakiznFCFaYU8WjeAuSWzNyW3CHJuttY="
          }, {
            "num_cand": "U2FsdGVkX19tLZw2zK08k99KwV74iMyDh95ZNTsp8wI=",
            "cpf": "U2FsdGVkX1/b0ScHp0roWiamH8WfJBfQf4m+J6/3DO4="
          }, {
            "num_cand": "U2FsdGVkX18gVAx2ZFEOLItYr5FZfFhR7NCcIXoUPiI=",
            "cpf": "U2FsdGVkX18SxuRg6XApkzdvJWkmTUfUyLWGi83mFFk="
          }, {
            "num_cand": "U2FsdGVkX18k3pG/tMhHTwHWFMFAh6Wqka0E9zjT/jA=",
            "cpf": "U2FsdGVkX19pQ3bJFAJJS3NRvXK/HFjdt30pYkRbpiE="
          }, {
            "num_cand": "U2FsdGVkX1+x9NVaT5DBUJ8bnrYLzH53peQcw6e/+4A=",
            "cpf": "U2FsdGVkX1+7kuthXNULcnx+xEsMbJDQQs18oT6bSkw="
          }, {
            "num_cand": "U2FsdGVkX1/eJo6CITaH9ic03sA8CWJEAox9cmSJlGE=",
            "cpf": "U2FsdGVkX18WL5yw8F1xQ8orHgbr8I3FvIWklkRsXpQ="
          }, {
            "num_cand": "U2FsdGVkX19f6WXlpvBwk5xSwmnh7Uj0T/XEqq91/UY=",
            "cpf": "U2FsdGVkX18YPB1xJVe6jKPgD0vHJYWUHYWAJJc3pOA="
          }, {
            "num_cand": "U2FsdGVkX1/8LDHgbMxDS5JuIFm4zbtWASZFDVAw8RU=",
            "cpf": "U2FsdGVkX1/JHYScFRxQ/lPtMKkJjatMg+FAVHbUoQc="
          }, {
            "num_cand": "U2FsdGVkX19S3hHrOG9oz5q/vOOCynciopp33u4B5Mk=",
            "cpf": "U2FsdGVkX19MG8VhYEINvjOAuJBqCuHcvRDzCigIveA="
          }, {
            "num_cand": "U2FsdGVkX18QRkosnDlyNg9WuEEMlLeASWRcq2zi1g8=",
            "cpf": "U2FsdGVkX1/+B6aT8R/FqknDDiC42Gka6mDvDXcLHG8="
          }, {
            "num_cand": "U2FsdGVkX193/5XZh+QNb7+ldoZ+ZwJ4p5ELdonUvF4=",
            "cpf": "U2FsdGVkX18bccOiVSwDphnqte/xDzFaA31WtALbKUU="
          }, {
            "num_cand": "U2FsdGVkX1/s0OQd/zL/udb+xvLgyn7ylyK5i56kaDI=",
            "cpf": "U2FsdGVkX1/JUZ/4Gpika7L6YGPBaVKBe33TJoizAII="
          }, {
            "num_cand": "U2FsdGVkX1+gi8MRFZipppNwlgOfbhfyR/e9HwHcYj4=",
            "cpf": "U2FsdGVkX1930zJtuqVKtZ+u58XxJR+4Li/5d5tKMdQ="
          }, {
            "num_cand": "U2FsdGVkX18VMMl4+/rInx1cPbQsfR6p95Ec4vlwbWU=",
            "cpf": "U2FsdGVkX19OyjX+hVoufkFkzqUc0TSl8lE+dwIBaJE="
          }, {
            "num_cand": "U2FsdGVkX1+10X8RusXDZ4wf208Sj8Urclq55wKLVu0=",
            "cpf": "U2FsdGVkX19E4bUwGK5JZXSH4AxNNGuWyZs8GQ1ijmg="
          }, {
            "num_cand": "U2FsdGVkX198mG/eJ63EL2nP3Y4TBkoWIgB+G1t54ps=",
            "cpf": "U2FsdGVkX1+gJRpF024zpOwfq7nocUquKQQxYxmwRrw="
          }, {
            "num_cand": "U2FsdGVkX1/Xn03eMaVWilNWe28mxyik9Z3R3bkg+Ho=",
            "cpf": "U2FsdGVkX18l83UMq1IFonsdM+bKpEmrXmxfPrGqCgg="
          }, {
            "num_cand": "U2FsdGVkX193iloSqt+sWo77AM5VROe9+GMo7idNHa4=",
            "cpf": "U2FsdGVkX1+aOWZCDT1bRIKvHyPdlJlnnvyl6bBCocw="
          }, {
            "num_cand": "U2FsdGVkX1+Sz9+kYLhjmZpxLgf5PY2kw/D6/9t2130=",
            "cpf": "U2FsdGVkX1+2I1adCbakVF3Y45y0RZRnHU0mb5j9guI="
          }, {
            "num_cand": "U2FsdGVkX19weCj4PA4OoF3I/Ec2hrNXlKKJ3oDkVto=",
            "cpf": "U2FsdGVkX18c6tehALxjj9VuACyXSM/LvuddySTYJYE="
          }, {
            "num_cand": "U2FsdGVkX19G8ukti6a+TL16oUYaM9dkWAY4PXrIbNA=",
            "cpf": "U2FsdGVkX1+M8ZPLxHwpJ1nwgC+2WCQ1ofEdn51JQC0="
          }, {
            "num_cand": "U2FsdGVkX18i2G/Fw8I5skZRfjdzTP/tsg+Ju59y6z0=",
            "cpf": "U2FsdGVkX184XhjGM1+TD50wqvC6a/5KXP2Zaw1iJYY="
          }, {
            "num_cand": "U2FsdGVkX19Qm+K+7klvLrw+MFmLP0HzK1u+D4MRpWU=",
            "cpf": "U2FsdGVkX1+epIoX3QbV/bNWwsLetYjXDoEVLAKqGYE="
          }, {
            "num_cand": "U2FsdGVkX18ApqEgIiZk4DHN36zpT7XoGPUlBKodIjg=",
            "cpf": "U2FsdGVkX1+mjFB6wOPr1oXEfKBLnruvui3R+XLt9RM="
          }, {
            "num_cand": "U2FsdGVkX1+7z9V35hJ31jZgAE9fIKW5Y5zpW4RjeVY=",
            "cpf": "U2FsdGVkX18d0RgHwH9qOkBkAnV2OHtg/qcxbZ7xiXY="
          }, {
            "num_cand": "U2FsdGVkX19ydpYrzaScZMkT8Ws94lNp9bF4LRTPzlo=",
            "cpf": "U2FsdGVkX18MunbVZ/kftQjKBkGVAJ8d3l3w+x8lQJQ="
          }, {
            "num_cand": "U2FsdGVkX19pca4DxN0cUvVA2+mNw5JeVyilPMUaOO8=",
            "cpf": "U2FsdGVkX19X0MccvhI2/yR28U76syCNVQHBOMCyB/w="
          }, {
            "num_cand": "U2FsdGVkX1+T+hAnPDLVX7+ErKU4MIsbPuGIqFhZ+k0=",
            "cpf": "U2FsdGVkX19eiq7bDKF/XZXLHOJFNdJ/+tsTVAjZmRg="
          }, {
            "num_cand": "U2FsdGVkX1+tZsV6AngMeDT7VDWGgDKjupOlKgFChv4=",
            "cpf": "U2FsdGVkX19nh66yj/HLpw306Q75bNJOmZMGIMUdohI="
          }, {
            "num_cand": "U2FsdGVkX1/gPXKikaExMmicCDRbbx3bkAFG1TrM7Yk=",
            "cpf": "U2FsdGVkX19XMgvXpQ1BPFCKaeqD7SGaHYKksORE1kw="
          }, {
            "num_cand": "U2FsdGVkX18Vr1Es4IruosXB3/GhYVznaOncJHvukkM=",
            "cpf": "U2FsdGVkX19o+oE2z1m2a4WbgEWpglI8qrEUdYMrDMw="
          }, {
            "num_cand": "U2FsdGVkX1/gxNrJLLNA5QimtlNv4DlLERaACY4czuo=",
            "cpf": "U2FsdGVkX1/ASssPgMlkWz+/kuaFF2suYseDjcQTLAA="
          }, {
            "num_cand": "U2FsdGVkX1/dq+IkejUCHobb+dPQgLuZMjzsEEf+jow=",
            "cpf": "U2FsdGVkX194cWheOYW91Klbm8Aeo4HHJdbyvg6VfmE="
          }, {
            "num_cand": "U2FsdGVkX1+IPFUho6ZeoiAjoJh2BO5BADgjEY01pOw=",
            "cpf": "U2FsdGVkX19SF9Fb3rjggS31jHf46qFD+tURuBxjlGk="
          }, {
            "num_cand": "U2FsdGVkX18//25V2j9ijqYJyFa9JWHTbkPHLq0RzDw=",
            "cpf": "U2FsdGVkX1/DVJd1uH6bY9cEr2WJiWO+73Dmz634e30="
          }, {
            "num_cand": "U2FsdGVkX18Ko6QJ9DszJFWdatiUb4kSwIQE4aJJcVA=",
            "cpf": "U2FsdGVkX1/hGtTrXutv1l6OiRJbsXxeEycipzoAQ4o="
          }, {
            "num_cand": "U2FsdGVkX194Xi9e6Z6eVMSKRCKbgzPPHeEAKcbw2WY=",
            "cpf": "U2FsdGVkX190I9VZZJNOcZrC9rwlN+udXDT0uWVeBJg="
          }, {
            "num_cand": "U2FsdGVkX18SIi7C9El9+uBhZIClU2lB4uljkMIN9P4=",
            "cpf": "U2FsdGVkX19v+JZhzRIZsaaZVSyoF9Na8gZOZfGC/co="
          }, {
            "num_cand": "U2FsdGVkX18ENahMAN//oUsu67hFsAixXGS8XEAIUQ0=",
            "cpf": "U2FsdGVkX1+vubKWaxHCfruKrOZLcKkiHe2wNERzsQU="
          }, {
            "num_cand": "U2FsdGVkX19GrklTMFq4nZHq+xD87bKrCm/x84E5pfw=",
            "cpf": "U2FsdGVkX1+8fTi8uJnjj/m+eiybVRlnXWpb6dBqkWo="
          }, {
            "num_cand": "U2FsdGVkX1+IoGn67ob+rj3yW6QyzKGIW/7InHsdM1U=",
            "cpf": "U2FsdGVkX1/SGFre7fOzBz89S53nVOZ2ic/oG/UXcn8="
          }, {
            "num_cand": "U2FsdGVkX18pyyRCcrSBlnE5t/4CY5aM6oigEAhhp6I=",
            "cpf": "U2FsdGVkX1/0nlgcbibrFdbOKghvCd9tOngMbTdfkJw="
          }, {
            "num_cand": "U2FsdGVkX1/GMe3JBe7p1hSWjFSimlnvSpMOMmEkk7s=",
            "cpf": "U2FsdGVkX19n/T8286YoNyG7r734Nx1/PdXHq4RYMlg="
          }, {
            "num_cand": "U2FsdGVkX1+nGDdos668P/OiPbcTv95BzwFYa7Ejzfo=",
            "cpf": "U2FsdGVkX1+JzSmjRP0/ZhhR9iM4kEL6R/axnfzEm7g="
          }, {
            "num_cand": "U2FsdGVkX19LtV9Be6SHnP5t5zQxxZHqAG07pavkKCg=",
            "cpf": "U2FsdGVkX18OrihysrLutz48XOzAYw4YXNElZbgSFik="
          }, {
            "num_cand": "U2FsdGVkX18GToynuzyzeMik9Xqau29JrIsTN+bfwbc=",
            "cpf": "U2FsdGVkX1+Qhki/I5Cnuk90sNOvzO3Ay3XaJQRQbeg="
          }, {
            "num_cand": "U2FsdGVkX1/N01KRpCGPqRVXVKD5inoF6WTgVybi8iY=",
            "cpf": "U2FsdGVkX1+WPLhRdYZJf4JeC7brCpZap6S5lnwsIg0="
          }, {
            "num_cand": "U2FsdGVkX1/RPyDlOjWNT1qA1hF2j0MhVR5sUwE/Uqo=",
            "cpf": "U2FsdGVkX18M8UplRXn7BT5t2UJ5NE5OAPLpaG67dJA="
          }, {
            "num_cand": "U2FsdGVkX19q3eANt7mVwvSHgTztu6gkikCbZ/VXkdc=",
            "cpf": "U2FsdGVkX1/Fu5WyeOgyXPAf3H+X2Xv8fKOdbEt9qco="
          }, {
            "num_cand": "U2FsdGVkX19FghRfP5zW0a/2XhcYEL7mZ0f6qKvZG1g=",
            "cpf": "U2FsdGVkX18MSfLuJXLibCEn+U8Y82etRbaaN1g/PKc="
          }, {
            "num_cand": "U2FsdGVkX1/fXRNWwDm6YWNGI9S4xZZBWA+u5mGn/v8=",
            "cpf": "U2FsdGVkX19tUkUc/zDDYVApNY8D0HpljNYy0sZ0Bgc="
          }, {
            "num_cand": "U2FsdGVkX180XmLK51snpBd4wTE0mce1HtJIFLl5C40=",
            "cpf": "U2FsdGVkX19ff4GasGZ3WEpjkZcOIVT0lFryFIBwQlU="
          }, {
            "num_cand": "U2FsdGVkX1/NQE8R/oDYiF+J6HZdPHosw6MIRhIlrec=",
            "cpf": "U2FsdGVkX1+lcASWGJifzLp/tLja8Z00Cx0Bd+dxlrI="
          }, {
            "num_cand": "U2FsdGVkX180qMmuNOOG1HE/jEIpLrgqNSgNzcBcUz0=",
            "cpf": "U2FsdGVkX1/xid9nUiK/uCoZFzqsV7WOESSMCtpqq8A="
          }, {
            "num_cand": "U2FsdGVkX1+0xJztUklmeIzVgul7JDK2jrzKsBFA3Wo=",
            "cpf": "U2FsdGVkX1+OJAsAv2q6zBRVvkTHdaptuEXHCOObGfI="
          }, {
            "num_cand": "U2FsdGVkX18uxP7OCiiUeHRPf9fk+W0yZJ6qdlvcshk=",
            "cpf": "U2FsdGVkX19+beuwdo8T/jG3xOxolqMv2KZ67F09VJ0="
          }, {
            "num_cand": "U2FsdGVkX183isKOqYN/x+NWOv06ar+aajJWdFxTgdg=",
            "cpf": "U2FsdGVkX19tT+ozGIx2a5Pzkae1KONSAmXU2cb1/ko="
          }, {
            "num_cand": "U2FsdGVkX181BY2l8HQPfKoxHiTAEThlPL0eQZ6Cde4=",
            "cpf": "U2FsdGVkX18sgbyafKCWwlRw7Km6MAZltcEGpaPDPgk="
          }, {
            "num_cand": "U2FsdGVkX1/DhjaMYjLszOll18XsO+3hTtOcSPG0nWU=",
            "cpf": "U2FsdGVkX1/YXpoWEqCZ3BOk6np4WZ/OhCC9YvAl7PE="
          }, {
            "num_cand": "U2FsdGVkX18tZCftCOtfXT5IJMaK2oTX3TOi4KzTIfA=",
            "cpf": "U2FsdGVkX1/TBivRTKJAo3hARy7B1Qhg88p+hULQu0E="
          }, {
            "num_cand": "U2FsdGVkX18/8nqpSzP8bbXzTCg9jQOS+UHaDGXDpKw=",
            "cpf": "U2FsdGVkX18YnXp2VHfvAQjpJhc9e7rBgD3KwTxc31I="
          }, {
            "num_cand": "U2FsdGVkX1/lwta3es7R24AUcscFJ1m8+atVwfpT57c=",
            "cpf": "U2FsdGVkX188KZODDrOy3ELJqhX1oYP7EUXd9EkXvmQ="
          }, {
            "num_cand": "U2FsdGVkX1+TC2CXKoU1jvcWjw83NPsBDo8bvgrTA+Q=",
            "cpf": "U2FsdGVkX19iE2QZ8arCezkN1r1j+kDPc3mYtC7imck="
          }, {
            "num_cand": "U2FsdGVkX1+tIhUuwnTsg+g44K7KjzR13IvF678Z+DA=",
            "cpf": "U2FsdGVkX187SlxPE7HaVph/elCyIFHd/qAF4c+gaao="
          }, {
            "num_cand": "U2FsdGVkX1+IupPHIBUE1jA9e+d1BRpKqNM/BpbpLtM=",
            "cpf": "U2FsdGVkX1/Md+XhxloUWD7BLmaC7F9XZgP+LYCUTvk="
          }, {
            "num_cand": "U2FsdGVkX19M0hMvWWV3up+LXLGQ+h+12G8KncdijeM=",
            "cpf": "U2FsdGVkX19dEdrlflk8m8t0/cIbHbAqcx/K/IOiOqQ="
          }, {
            "num_cand": "U2FsdGVkX19Sr/evz4nSn9xadfbzaJcXlUSRJyp5qi0=",
            "cpf": "U2FsdGVkX1/z/qI9XIxfwhMaxXi52Dg9bE/7VP6eg6s="
          }, {
            "num_cand": "U2FsdGVkX18AuXdDxf4SqJfxpjudA88ZnXNgFs0aihw=",
            "cpf": "U2FsdGVkX1/0Fxr76Q4balT+axANs9pYXz2hsrHJBZc="
          }, {
            "num_cand": "U2FsdGVkX1/w6PBEfZY5DWqzyHVcggHzpwTv1+VbQFk=",
            "cpf": "U2FsdGVkX19XkPiAmKvxEcq+6FBexqZNPQZt1PVR/8A="
          }, {
            "num_cand": "U2FsdGVkX1/IDfaKJfdh9e8ya3sFSc0lxP5cLOLu9Oc=",
            "cpf": "U2FsdGVkX19KPQsUOY0RUJsW5NC8Lj+Qs9Dt1m1vKeo="
          }, {
            "num_cand": "U2FsdGVkX1/u9Eq5dSS/sNa9FpVvtcnX2qws1GNM8Xk=",
            "cpf": "U2FsdGVkX18lvgbRRzQdCzXZ/kxcRpMQvGyrZgn+19A="
          }, {
            "num_cand": "U2FsdGVkX18wS15gj6GNmQhEV8DwEzhSmOYJ1MjnQZQ=",
            "cpf": "U2FsdGVkX1/x1shbfcqyXDtoFnxgQ+harj1lYZzHfhs="
          }, {
            "num_cand": "U2FsdGVkX19A9H32KIqgACBZbYwFvE31HHyTFlw8Qjc=",
            "cpf": "U2FsdGVkX1+1i1JhoA/QhhPWMqIGRa87Bs2XbSsV5rY="
          }, {
            "num_cand": "U2FsdGVkX1/RB1tkxuEPKTWnP354fCGytWWXUHNDTpg=",
            "cpf": "U2FsdGVkX1+X1gGDKbM2ZilWRUmXfp2bYZvjO78EtIQ="
          }, {
            "num_cand": "U2FsdGVkX1+Wu0D1fKCvE2z9wBAiJ8uKOHWGcEh0TN8=",
            "cpf": "U2FsdGVkX19shMALttlFHZyqydbaolOps0JJovN+vDM="
          }, {
            "num_cand": "U2FsdGVkX1+CVpDqTnaJmoHg9OKO/TaN5F8ro1N2o0g=",
            "cpf": "U2FsdGVkX19kL86SW0TVMqDJNBd+oqrHahJP5VtM45E="
          }, {
            "num_cand": "U2FsdGVkX185KEg8ctJIlGy6I7rHFd5C6Zz79x4QHGM=",
            "cpf": "U2FsdGVkX1+IjAhXvH/v/+wUzTRXnMCxG03Z+Nk5CHo="
          }, {
            "num_cand": "U2FsdGVkX18BKM95rqSG54DjNJdI1fYuu3RCA0twph0=",
            "cpf": "U2FsdGVkX18TxXObXakhn2ybxBT955lhUSk7nTH3NFk="
          }, {
            "num_cand": "U2FsdGVkX1/rfjGb8y18GpuW6qkxMIjG5rkaBGsUiA4=",
            "cpf": "U2FsdGVkX191l5Rr3OEtSDdbIDfo6Rc3MiR8F4VWf6I="
          }, {
            "num_cand": "U2FsdGVkX1+lWwYdHXB7nhTvooBQiOd320LKvoiuXt8=",
            "cpf": "U2FsdGVkX193NH98SCP4hxjXg9aDxWEBbzXF0G+euw4="
          }, {
            "num_cand": "U2FsdGVkX1/qpHa60o0YaUca6IMhxYQm/K5VNjwRcJ8=",
            "cpf": "U2FsdGVkX19q38TGrPAL/jOaNg8BmINWdYNfBVMqfAY="
          }, {
            "num_cand": "U2FsdGVkX19UT6nURDlJKHfFmD6gZ1ULNnsJK7ZyPiQ=",
            "cpf": "U2FsdGVkX1/0/36LVu+4dXV4nhu24V5c1sok/sZldVg="
          }, {
            "num_cand": "U2FsdGVkX1/MNGDQJU58diXfN3fuhkypf4aLHEQdTe4=",
            "cpf": "U2FsdGVkX19fFGDq6FYO2oiLLkjEPL+F1YhaE0r2K0k="
          }, {
            "num_cand": "U2FsdGVkX1/h8S3tAFZKPLhTtUUwzkgwN5qUhXXxlm4=",
            "cpf": "U2FsdGVkX1+g8di6jGlknYLOoSm1wybJC9D79QB7jK0="
          }, {
            "num_cand": "U2FsdGVkX1+Kcnp9zSSe3FMHEgb+lzBK11A/w4arYfk=",
            "cpf": "U2FsdGVkX1+uLabR7spgMz6w4VnwItsrt6KfrJpo54g="
          }, {
            "num_cand": "U2FsdGVkX19SzaazdUEv8gsomzO584ZgR3CXcb9Mrks=",
            "cpf": "U2FsdGVkX19smz8vXw2dbmRtJ7ikE6/FDIlm2/i+RqQ="
          }, {
            "num_cand": "U2FsdGVkX1/ECqRkBpVzxubZHqvMlC8DgKOvMF5He6c=",
            "cpf": "U2FsdGVkX1/k3cIFdxTvsUAWIT6Zkn8ZXESU86n55hU="
          }, {
            "num_cand": "U2FsdGVkX1+sbDYsTj/QOTqHElbjj1ZTLuypOL2D3F0=",
            "cpf": "U2FsdGVkX1+b1eyAKjqyy3ua1I2nnzH51tAxDwL5J2s="
          }, {
            "num_cand": "U2FsdGVkX19K/HuJOoexCmCzuSr7RYheKG0k3hVW1XE=",
            "cpf": "U2FsdGVkX18irZzUTSMuqDRwY9h4JtOMDGTqPhmyHl8="
          }, {
            "num_cand": "U2FsdGVkX1/zWahNemswxPsE+NexKwb3kit6oQ2DyCY=",
            "cpf": "U2FsdGVkX18kq64KR5JegekepmxE+f2tx1F4EyU7SvM="
          }, {
            "num_cand": "U2FsdGVkX18CGkG75Ll5dlV1lyQzyWZq7IBjJtLI9WE=",
            "cpf": "U2FsdGVkX1/DUa6OlpNmCOSj/biwE+sB6UXZ0plLJaI="
          }, {
            "num_cand": "U2FsdGVkX1/2cVq5JjVlxrhXzot7MBxQAxHKwezoi40=",
            "cpf": "U2FsdGVkX18/NZCjE/TXbwoo7lBwr4xD6kGkzW7fQ84="
          }, {
            "num_cand": "U2FsdGVkX19k4tqcK1k2eUqtiOCRuiddJektWX0ZlJw=",
            "cpf": "U2FsdGVkX1/J0N6lNwk4VOnFMKjqKtZu19pSLRtplaU="
          }, {
            "num_cand": "U2FsdGVkX18DiLzb/eaLGWRJkoYFqr6iP6Jp1ugmnFA=",
            "cpf": "U2FsdGVkX18sSGLhU0ab/m45TfskbnZF/0Q9XuW5SDE="
          }, {
            "num_cand": "U2FsdGVkX18kJLKsuYacHORmwOCrE1XFTyiv0ZzHmG8=",
            "cpf": "U2FsdGVkX1+pw8fjtIvjqX2xbPXBcdsG5bumiPqvBj8="
          }, {
            "num_cand": "U2FsdGVkX193k4hQHQHRjuEM02sIKlmoBWiH2s1RA9s=",
            "cpf": "U2FsdGVkX1/Y0uso9pFF8W03Jyii6IDaP9LUYHDx1HM="
          }, {
            "num_cand": "U2FsdGVkX1+ilMSMivKJAAzh8Qnvr8CIZU5nGxU9SUE=",
            "cpf": "U2FsdGVkX19D4PESEz1cbTeyItTOQP67IlrIzSpVKX0="
          }, {
            "num_cand": "U2FsdGVkX18rafU4bVpkpSA8hz1RkURHmqvcRC4OfFM=",
            "cpf": "U2FsdGVkX189kq1RFtc+JU+5Y+pV1vI0LrMnvkTIVHc="
          }, {
            "num_cand": "U2FsdGVkX18cn6ZKRike5+N7wUXFSKyE4EWwzrhmcuo=",
            "cpf": "U2FsdGVkX18Bhphh6Wqh+a5bvkBQBiuzOG5FjCloVHc="
          }, {
            "num_cand": "U2FsdGVkX1+oiFoAjOtppsJk+3NvKINNpBdQVtO04sI=",
            "cpf": "U2FsdGVkX1+ryy9dUQPg4/h9Jif4at+ZZd5uYK2UdWw="
          }, {
            "num_cand": "U2FsdGVkX1/yjikeVcJccBkaKafuiD616DSvXbpqqII=",
            "cpf": "U2FsdGVkX1/MzH4As296EQtvpwQVwvO5WBMHpXTbCGA="
          }, {
            "num_cand": "U2FsdGVkX1+qNyAOwx0y8anI8AIJXQ34B9C7eARQprA=",
            "cpf": "U2FsdGVkX19Isb697PmttkS/1Cp31+eC+jE8jay12aE="
          }, {
            "num_cand": "U2FsdGVkX19w/Dm4mt41e+X5oLR0uQE9JyDnbGxZWGA=",
            "cpf": "U2FsdGVkX184qVQ7CoU38ha05+HsrlQc0f2LyROxM/M="
          }, {
            "num_cand": "U2FsdGVkX190oyq1pntvpz2EUE2igGmKWRxj8k9yO6k=",
            "cpf": "U2FsdGVkX197CuryD4GbTEJX6PDBo/74zvPNXtHenBk="
          }, {
            "num_cand": "U2FsdGVkX1+rH3OAp+EM8xzz1HRhmjIH6EMRAWf+Ul4=",
            "cpf": "U2FsdGVkX1/sr8bJRcX6rO9AXWZiiDkaihg87rdEUsY="
          }, {
            "num_cand": "U2FsdGVkX1+SF3L3bApXZlQfO2aWyGWI4roxltczKOA=",
            "cpf": "U2FsdGVkX1+5ujka83cmH/eF/9HlfSv/YceJdFQUkPc="
          }, {
            "num_cand": "U2FsdGVkX1+7AeXPQQhJWaaMgVtnvwJi8tJZh5Zv1ss=",
            "cpf": "U2FsdGVkX1/nQmrbOupD17Pbx3u8dkp+MlQG8xcbuHI="
          }, {
            "num_cand": "U2FsdGVkX18YBabV926g5rZs/XiUUpS1okcuXR9h4ms=",
            "cpf": "U2FsdGVkX19UfM2/SLycB9s5rPASL9RVr98hVaBrBNA="
          }, {
            "num_cand": "U2FsdGVkX18ss4BQ7CxhJoS95SIvB988Zwzxsl6e6WY=",
            "cpf": "U2FsdGVkX1/pSyZECmlkKzbI1BVf984lAJWBM+giylo="
          }, {
            "num_cand": "U2FsdGVkX19VptgKTQWX2o6hdvKg7TSebYUrqvDbf1k=",
            "cpf": "U2FsdGVkX195gDzxwGXxBVUrreK+G4Jt+8WZrStpMZI="
          }, {
            "num_cand": "U2FsdGVkX188cw7r5VlKeT7UA6L5E2KtKStQtIMBRvw=",
            "cpf": "U2FsdGVkX18wPkM1XlZ98sJ8xqMD9D5rVX1axKfOOik="
          }, {
            "num_cand": "U2FsdGVkX1+rEVt5DKKmSU4KRBIZq3/fQAq7cFVXtXE=",
            "cpf": "U2FsdGVkX18uEsjvIAZisqVUoaFCovS6xF0IFRb2fUo="
          }, {
            "num_cand": "U2FsdGVkX18Y9zR9qZSEpcY9CyXnXygdEcpOTAuJwPU=",
            "cpf": "U2FsdGVkX1/GVCcW136kuJHh0K26SdQymXiS/qz/uOU="
          }, {
            "num_cand": "U2FsdGVkX1/Hlp6Y6PHS7u/kFKu2jdUQRk2gzUyQ6Ec=",
            "cpf": "U2FsdGVkX19Yeqm03ms7OWE0ZS0vF/jvBUVzO4ri+IA="
          }, {
            "num_cand": "U2FsdGVkX1/4msFNotpqH4vKTA6HwTRffexsZ5bkPW0=",
            "cpf": "U2FsdGVkX18kCvAdKM3mrltpiDBY02R9Ma5+YqsJJns="
          }, {
            "num_cand": "U2FsdGVkX19dUQaYYJr9E9mMU81FWSBXpgBxGluwNC0=",
            "cpf": "U2FsdGVkX1+8RR2p4JzC4W7XWQsj7li9J2FlWRKJ/Hc="
          }, {
            "num_cand": "U2FsdGVkX1//3aeKdvi6boe8AoZOp2Jlx6Dnq9c+MsY=",
            "cpf": "U2FsdGVkX19NFEgU6snih+xUWpGhV0dab5cfF94DUy4="
          }, {
            "num_cand": "U2FsdGVkX18s1nWUPz6AK0cDhLXulyIrLDtJN9TbLmU=",
            "cpf": "U2FsdGVkX1+W7b7EPUPZeYHIsprKwOGFCXDNHxIsqIE="
          }, {
            "num_cand": "U2FsdGVkX1+Qdy8PNIDdI56fZE3eLDl+Loy3vpnFDW4=",
            "cpf": "U2FsdGVkX192P5a2ea6Vu3emfDtT1kfR9DL/H7ilqVY="
          }, {
            "num_cand": "U2FsdGVkX1/2UA8rgnx/Xc21L9Ah7f1UFHkDwy1HwOc=",
            "cpf": "U2FsdGVkX1+ikQwYqN+5QKq42bbop3ybr/hOQ3NvPSg="
          }, {
            "num_cand": "U2FsdGVkX18aiQiJZXYGEScU9wJ8xULupTMYxZvFGmk=",
            "cpf": "U2FsdGVkX1+Xg7V2KpReRSgAR/FJbnl7/C9g/up/SWM="
          }, {
            "num_cand": "U2FsdGVkX186jPOaWyfWVDikiPYU5kZ3QKOy9hTMgZs=",
            "cpf": "U2FsdGVkX1+ACOdGLyPNKvUP4AFmqsvMYVN0lcK+PWg="
          }, {
            "num_cand": "U2FsdGVkX1/3KRe2MVmeiL3monlxuG7UpHGtirc6kSk=",
            "cpf": "U2FsdGVkX193WmLyDj+yLjNZNCwE+k2x7D7iaYOFejA="
          }, {
            "num_cand": "U2FsdGVkX18ZY7SyA+pa42+ACw3pRLcmkajkAknICUI=",
            "cpf": "U2FsdGVkX1/WLQq4gStbfPNJrZGBScSFrdG+hvkWsHQ="
          }, {
            "num_cand": "U2FsdGVkX1+Mxg4jw8/iToKKRCg40btc8sfwyxUTVBg=",
            "cpf": "U2FsdGVkX19C1MXLMDmjj9FTNgmkVMnF1OMpYAQVR0k="
          }, {
            "num_cand": "U2FsdGVkX1+Dd+nZ9CBpBFmGRU3uE86DDpUUOsoACRI=",
            "cpf": "U2FsdGVkX19FK+RvH48KYzkMm2grk2JiGU4Z8ubjuA0="
          }, {
            "num_cand": "U2FsdGVkX18B/guuPrkEV1oTY2eO7oPpJC53NEN1EIo=",
            "cpf": "U2FsdGVkX19V9LbbcjSbfypnepV4KKi3De8NDCoaCC8="
          }, {
            "num_cand": "U2FsdGVkX1/s3CthcTjp7l9vCAukCC9ebpQozlDn55Q=",
            "cpf": "U2FsdGVkX18qAGMZaZdgqMhCVh4VoJIgsV3l3T85bzs="
          }, {
            "num_cand": "U2FsdGVkX19RW6FfDIjlAH84grdzZoYo5+LoJXiBhVo=",
            "cpf": "U2FsdGVkX1+nhRPdnCX9ak3vm8UoHpm61VyB7Ahyt3A="
          }, {
            "num_cand": "U2FsdGVkX19U5wDb8XUHoXzU03uvtqRlH7eHBErQnno=",
            "cpf": "U2FsdGVkX1/R5H/o9fSjyUfJ4rbOElkcard9J9h+ES0="
          }, {
            "num_cand": "U2FsdGVkX1+NjbJEBAM+mkjor/CtZztcun266qvTHAQ=",
            "cpf": "U2FsdGVkX19foV4+na9yIvghqbFUaGRgMJgHm+Gt0FQ="
          }, {
            "num_cand": "U2FsdGVkX19/Xa4Coai/9F6jipmhovOFdXX/Uqeg2lo=",
            "cpf": "U2FsdGVkX18p3uJ6a3u7tJacoY+cfWJC4ptKil3ef5I="
          }, {
            "num_cand": "U2FsdGVkX19S3rs10Fe63hGswanAm3YBulPB5K91tAc=",
            "cpf": "U2FsdGVkX1+dX99IEwnala1KZbinAuU0oEyyxgsF6RM="
          }, {
            "num_cand": "U2FsdGVkX1/7QU+BPNRKSjy9FLQsn6R48vWa3naq+pw=",
            "cpf": "U2FsdGVkX18CNExCSNihYvZEDZEa2iDzRIF5jprLEMA="
          }, {
            "num_cand": "U2FsdGVkX1+1Wqo1unVH1pkRoKaKNaWyqNu0gYBHKQU=",
            "cpf": "U2FsdGVkX19T4ktPlTmRDntAWw++2hB1IQ5cq1XLcRw="
          }, {
            "num_cand": "U2FsdGVkX199McW5R1kuo5PLWD8UnvCm/36I5hnGqUo=",
            "cpf": "U2FsdGVkX189JYPgohrDuXghkqw1QLCwd4QtJsqY1BM="
          }, {
            "num_cand": "U2FsdGVkX181zWS9fN2W1biV+9mMbMvXhWtJewKvzQM=",
            "cpf": "U2FsdGVkX18T0/lt1A/eYjUbDy51QdzUd0bkfsV0+Jc="
          }, {
            "num_cand": "U2FsdGVkX1+3wv8HGwWZGLUS4Z1/kP48DA+2rnkdiC8=",
            "cpf": "U2FsdGVkX1/5J7FtuasHYZa5HY4ltrQpYjV4cn6sVbo="
          }, {
            "num_cand": "U2FsdGVkX1+1ZjZD2+bvkoiwKB0FeE7Lq2TRT+s2/1A=",
            "cpf": "U2FsdGVkX1+eR+ZJwAmv+CY/LdGkxLlFztqGejNbA1I="
          }, {
            "num_cand": "U2FsdGVkX1+nsJ5EdRHCjH9iMCBOh74Jin5t+BcMtrc=",
            "cpf": "U2FsdGVkX1+A3Aq3OkH21ktkjJVuz3D7+y0BNiq4kaw="
          }, {
            "num_cand": "U2FsdGVkX18WWKJWzLrtIkY3PrUO7vRrfvVSIzwkMVs=",
            "cpf": "U2FsdGVkX18oJBFwtqzSYJjxYg37XaCrmJUGMxeVO8A="
          }, {
            "num_cand": "U2FsdGVkX1+uT+NMGHUybvaJ/2Mqm1ZRzukHAO+ijlA=",
            "cpf": "U2FsdGVkX19uVPkrv7LYtUxKpkZbjnSRnX67tyMyats="
          }, {
            "num_cand": "U2FsdGVkX1/Z8eMWr8xMCVpCMCg3QyPltLNnPHAE6oc=",
            "cpf": "U2FsdGVkX1+EvPyNP1qz9E/60eapKcOU42u5prx3XKQ="
          }, {
            "num_cand": "U2FsdGVkX1/6pVTnZA4cHLuH6c9Yj10oc1l+4/VKDNM=",
            "cpf": "U2FsdGVkX18ywfTQfbOlW1h6nPQIgAqkRNlQxD11we0="
          }, {
            "num_cand": "U2FsdGVkX19ed38IfP2Q6FRutlLFod7NwV0qXeV25Ig=",
            "cpf": "U2FsdGVkX1+Osd/s9LblvzRPlU4Bc/D42jhxRxSIWdQ="
          }, {
            "num_cand": "U2FsdGVkX18TZ6uAmB7F/Q+AhGQe+9ysvzbTxOt5ycs=",
            "cpf": "U2FsdGVkX18DkCESXe2YbRJuEZtbXCdzWlwTXjN/tJs="
          }, {
            "num_cand": "U2FsdGVkX1/Ka7UCECdDg0wq6oo3/pYCCoHNU3Irq74=",
            "cpf": "U2FsdGVkX19tlv8tZ5Cy5JD+ogQF7R511Q4TLIM7P5U="
          }, {
            "num_cand": "U2FsdGVkX1+dsTsEoAu76tDa4wT5bv8z+aSZlwwmebU=",
            "cpf": "U2FsdGVkX1/yRzrSMdxhmuoeuNnKbX+U0K1ZMWxh+xE="
          }, {
            "num_cand": "U2FsdGVkX182YL1MHjFvzUYI+Z9/eW6ce+BZA+TPYTA=",
            "cpf": "U2FsdGVkX1/8t/E8xVKOW46+CeAKZ9rfezQyLxvcVv0="
          }, {
            "num_cand": "U2FsdGVkX1+ypiG2sqyyaqVepoROSEEZ8pKEnhu6wOk=",
            "cpf": "U2FsdGVkX19arO0YTYq1ZttBBzrGtWOkUHHc1Bh9lf8="
          }, {
            "num_cand": "U2FsdGVkX1+MwewoPb7KBeqWyqxwelsMKlVo6YDfQE0=",
            "cpf": "U2FsdGVkX19ooB9fJqZ1uZQ1p9V1NDr3hCr8oIOl/Zc="
          }, {
            "num_cand": "U2FsdGVkX1/jvmfrYPv+4la7Jz+it4mHGz95q2EfFq0=",
            "cpf": "U2FsdGVkX1+NyL8Mxhbd3R7TDX1734m72ulfETcBMk4="
          }, {
            "num_cand": "U2FsdGVkX1/OyTKtUqImreKpXHV6gXrNRg6RtOcmOXY=",
            "cpf": "U2FsdGVkX1/x2W1fP7rG4+2SyTQinkNC5MG/5tKXKMM="
          }, {
            "num_cand": "U2FsdGVkX19calFOzap38iJlUgZHmTLUtDneORruxdM=",
            "cpf": "U2FsdGVkX189Yf0NvaIPctQeY1Pz7sshh4O9bUuE0B0="
          }, {
            "num_cand": "U2FsdGVkX183TTHFI+1Xj9am1ASMmBQ8HYMB9GepEM0=",
            "cpf": "U2FsdGVkX18bUF/FA9FoCYZIstOcyGBQBIZlQ2CVxag="
          }, {
            "num_cand": "U2FsdGVkX1+2Yleet8FdLl2e2wROLLAEiwWiV0C6FA8=",
            "cpf": "U2FsdGVkX1+f6UNMMMwPEv0caznEw5Si/ZGJJVS66Cg="
          }, {
            "num_cand": "U2FsdGVkX1/1VhEGgp33K9r6SPfFNVZ4oYsfawNYIog=",
            "cpf": "U2FsdGVkX1+3UMa/BtLRFnxKlpixfIfDmItol4gaxCE="
          }, {
            "num_cand": "U2FsdGVkX1/mevt1DMcPVoEFBOPE6WPArhrajMNjc4I=",
            "cpf": "U2FsdGVkX1+8lCvIjmrVqQr7kMXTu9+rTIwRC5bcxxw="
          }, {
            "num_cand": "U2FsdGVkX18YsclIwLWOIOuJVmYcvfiQV0tBSsc30io=",
            "cpf": "U2FsdGVkX1/+L6UgW41DYcYZ13aoyFiJoTjZQRZdiWY="
          }, {
            "num_cand": "U2FsdGVkX1+Dq3PaurSeOYIuG3ABrEM5ZAcSH+Z9Rgc=",
            "cpf": "U2FsdGVkX18fG7IKwRhph921DE4JGultp5uSlh+AjbM="
          }, {
            "num_cand": "U2FsdGVkX18EO3TSJ2nXjFTl8GtCRe2AphzUONp92PU=",
            "cpf": "U2FsdGVkX1/A/Nzghp1/vkpFBt1sB15GP6GfMAoAf7Q="
          }, {
            "num_cand": "U2FsdGVkX1+T65ixAEyrQNFi39mFchYLGdjFBukdVhg=",
            "cpf": "U2FsdGVkX1+1E3bzN7TKW9VrHtYoA419saaHHOVpPVY="
          }, {
            "num_cand": "U2FsdGVkX1+p5URcm2cbgx/Hmm9zRfYg+jdNprdfXMM=",
            "cpf": "U2FsdGVkX1+7ycXCzdeGnaZOoTOvMCiRj02oWzQLCYg="
          }, {
            "num_cand": "U2FsdGVkX19GjqDAXkXINYBYamWdUTCQg91oXUlkEIk=",
            "cpf": "U2FsdGVkX19GTcGiwszgeB36ImBD5ZNNZYpz3rhbVRI="
          }, {
            "num_cand": "U2FsdGVkX1/VGjjWxeTLD9kog3tniSI6Z2iRKYOREu0=",
            "cpf": "U2FsdGVkX18PssHeUsQd5XdvUiJkJ+Bs2rztHeiRiCY="
          }, {
            "num_cand": "U2FsdGVkX1/7ARbW2DLOrskW1r+WqZoO4O6WJoL1h+M=",
            "cpf": "U2FsdGVkX19m6pQYRIUr0yx+B8Aa3Bg7mi8luZpsOog="
          }, {
            "num_cand": "U2FsdGVkX1+9GfLIMhSpwmh/5uLWLS3aXVJCXrLuCms=",
            "cpf": "U2FsdGVkX18NVJeQfrSnfiakLuOe4ycyFX+virsT2u8="
          }, {
            "num_cand": "U2FsdGVkX1/ghDNeKcamw99f3eCuKcKDkLWLDU+TndA=",
            "cpf": "U2FsdGVkX1/l6rXidX+SKS8A2n1K2zFQZJQq2R5YbBA="
          }, {
            "num_cand": "U2FsdGVkX19X9+M0BQEToWNsYaV76PV6M/TY6xYMTew=",
            "cpf": "U2FsdGVkX1/MOJ7sA1kM3FAi3rhE2N0up0C0FYsHrug="
          }, {
            "num_cand": "U2FsdGVkX1/FLQDvmpUIUFkdpqZMVIgptOe/rAKmcog=",
            "cpf": "U2FsdGVkX1+XgQ2CmUlSmWa8CqVWAXNSORS7ePDZiuQ="
          }, {
            "num_cand": "U2FsdGVkX18vv+1oZIryg1KE/QzO2HpKN4Hqj706pMQ=",
            "cpf": "U2FsdGVkX18SFl5KRSfeE9qRbTeQhV66ImRBI+Xfz/M="
          }, {
            "num_cand": "U2FsdGVkX1914Vf1Xos8MJORr7EtL0960rdYdSyGijs=",
            "cpf": "U2FsdGVkX19Afj0MVv7GdH1ATwQsRTmPxUVL+yyFhag="
          }, {
            "num_cand": "U2FsdGVkX1/XEW+yloMnix8FRg0yocmZn/XnA+7jChA=",
            "cpf": "U2FsdGVkX19502jQ1uqTQU9SHnyIAACe9LZiIy5ql3Q="
          }, {
            "num_cand": "U2FsdGVkX1+f81Me5yCy8oFfbB5igWlIj3K9bWxXHGY=",
            "cpf": "U2FsdGVkX19aEqFSFdyU1X+jlBwMeRly4+CDUS5wraE="
          }, {
            "num_cand": "U2FsdGVkX19ChCyc+Vz9Vbs6TMIaHu8E9ewUj7egNk8=",
            "cpf": "U2FsdGVkX1/O7XFH1+70VkCUAVo3jbzfZfu5QlnGRd0="
          }, {
            "num_cand": "U2FsdGVkX19JyMOa3Ub8/0p9TtAxu3byp7/1NH1JKm0=",
            "cpf": "U2FsdGVkX1+iHFlw0FhjsdaXgSlfpNzuVQuOXXcFF+w="
          }, {
            "num_cand": "U2FsdGVkX19qzfnSCt08rSad1PytB1HqBooO835T3jA=",
            "cpf": "U2FsdGVkX1/dht7ddJhKiOaChLRA76cdXGziAsaA8+M="
          }, {
            "num_cand": "U2FsdGVkX19G7ERZRkuDpdEEYZKJj0KPsVkFZFtb8Ns=",
            "cpf": "U2FsdGVkX1/rG07uW2+27PFr8DbxOAHTFSC3HVumxws="
          }, {
            "num_cand": "U2FsdGVkX18HARi6iiTmR8mwhFfdpn+KP3Ylza6jwz0=",
            "cpf": "U2FsdGVkX1/9PEc8MMBiMh6XxxrxpNQsQmmFmkl39C8="
          }, {
            "num_cand": "U2FsdGVkX1+1d93OZ3gEVrPcbHZSFmVtDrBrKhZ8oJE=",
            "cpf": "U2FsdGVkX19vas9YPAnvNMWhYdqtbxioSH9KDZ3jsxE="
          }, {
            "num_cand": "U2FsdGVkX18AK2PgR9dUIEjqHU9Je0qnVskKv1yB02E=",
            "cpf": "U2FsdGVkX1/lFLPz3AYJrBhmgFcQ8tRwiJjxFr8UPp0="
          }, {
            "num_cand": "U2FsdGVkX18HTMxp1Nk0PWzpO6BoWARsfqUGR9YuFN4=",
            "cpf": "U2FsdGVkX19EYJowoSxTIc60SvZRU3bLYfSDT875hDo="
          }, {
            "num_cand": "U2FsdGVkX19g56ZcNUvcEkqI4tKZLj53+S4RrkPL2v0=",
            "cpf": "U2FsdGVkX18qy0gh4jx6Gf78K0rfVIJ6rdSi6teHrLc="
          }, {
            "num_cand": "U2FsdGVkX1/TDDYxx8OB5EGGsiSuVnRMF7naY3tnbKM=",
            "cpf": "U2FsdGVkX1+/tEWXNKLq7huWBGS062+KgQ+v9+2WRtQ="
          }, {
            "num_cand": "U2FsdGVkX19raEuzAZbgkz5Z82JEgDpg3JMXWvvhGBw=",
            "cpf": "U2FsdGVkX18ryp5k5Adh9RuP0j+uOU2WIiu0ZaSwjMI="
          }, {
            "num_cand": "U2FsdGVkX181909W12xBDAK0xdMlxi0mhK2YKYLVjfU=",
            "cpf": "U2FsdGVkX1/vXrWnYao7OXcLN/s3hzx9RgEu7eojyBQ="
          }, {
            "num_cand": "U2FsdGVkX1934E4JlPm8tkgzkKJALmu5JGYqeCerTdg=",
            "cpf": "U2FsdGVkX19jdsrCWWpIYO4ASvMyoCoDGlIJBjo87/Y="
          }, {
            "num_cand": "U2FsdGVkX1+oivdb8dVIEXh8dRDXl4Ckb5HibQuh480=",
            "cpf": "U2FsdGVkX189F2DObHtER4fZmg2G0hz2wVICRs1HbFw="
          }, {
            "num_cand": "U2FsdGVkX18QgpT4ZoyA1+f7rdY4cFUaN1E0CG2t00w=",
            "cpf": "U2FsdGVkX199uc3oDbvQqU9odXPNxFmW72P96kn/VgU="
          }, {
            "num_cand": "U2FsdGVkX18dSeBSOwZ5nZDyqoKMYoDEm1sT01rtRPM=",
            "cpf": "U2FsdGVkX19wfv+oi2GO1r4snmlo+S07hKJeEHGORtc="
          }, {
            "num_cand": "U2FsdGVkX1/OTZ1+XZ7deoxDcMI2KrADBD6wDSgaVfA=",
            "cpf": "U2FsdGVkX1/Dmw0tIC8Uk0dTagLbod7XKaz1Tl0Cm4c="
          }, {
            "num_cand": "U2FsdGVkX19Dx2Zv9Vm5RxV3Glmk18ZMKh0WBF5kZRU=",
            "cpf": "U2FsdGVkX1/C1TlE8SN3olcZDkEQlFZgYLPAcrBXIGc="
          }, {
            "num_cand": "U2FsdGVkX1+S4TVFrxAn6MKEbGziraWH5ZmEeKoCqNU=",
            "cpf": "U2FsdGVkX18L3pu4WtsWQ68EpWepkVLXTthVMNux5W8="
          }, {
            "num_cand": "U2FsdGVkX198+NGgwgQljbtLgFoRLzduC7MV32919tI=",
            "cpf": "U2FsdGVkX19LaMWvoobE+OVOavGv18sBdS0wETcWZis="
          }, {
            "num_cand": "U2FsdGVkX18b5N7y4Q05pdAsLvxf7DO5Ei0Lr0ggIjo=",
            "cpf": "U2FsdGVkX1/7lZZVFUB/WfJnG9oI9J/JSUF7KIu/YnQ="
          }, {
            "num_cand": "U2FsdGVkX1/nrFPjC5wL2xMmqvxNfeUcIfqFlbNiWp8=",
            "cpf": "U2FsdGVkX185KiLXXFYeQ7lawC/1BPUzxi5kAY4aazU="
          }, {
            "num_cand": "U2FsdGVkX1+ZYzu0DcyQFXww077iZZAJFW1LkYzt7V8=",
            "cpf": "U2FsdGVkX1/UXpiGLXJmer0HDnu7vibPYQHkLw7hNZU="
          }, {
            "num_cand": "U2FsdGVkX1/LOPSq0khczdYF1l+c1IOJI8miyTJSE5A=",
            "cpf": "U2FsdGVkX1+47Z69CsIRGbUi/WPZu1qEIgNjGnvDYek="
          }, {
            "num_cand": "U2FsdGVkX1/Chd4t+8RRYciwhKZ/aUlAnwNIz5CHlCY=",
            "cpf": "U2FsdGVkX18wTKSrf2UQN377CUUdZ9FswH8lhKwCmdQ="
          }, {
            "num_cand": "U2FsdGVkX1/YwHvhRhOZtrClU6TkUQJ7AG7/LkHBEn8=",
            "cpf": "U2FsdGVkX1/vwfOqH4rCgoSOaTZM8t12KfOhGwevjVM="
          }, {
            "num_cand": "U2FsdGVkX19wJ29EeyeLtBBJa8DHluuIth1ZJPHZBlI=",
            "cpf": "U2FsdGVkX19aqL8VVP93QlGb4dvlzxn49R/ngn60Io8="
          }, {
            "num_cand": "U2FsdGVkX187rsoNrPKToUnd+uwHrOzLvFFrJNpgBAQ=",
            "cpf": "U2FsdGVkX19MiUOTaRtCa5m7F3GskbJCuM6Ee00LI1A="
          }, {
            "num_cand": "U2FsdGVkX19sG++xPUrcnhVuYXBlcXSnm+iDAVjg+wA=",
            "cpf": "U2FsdGVkX19CPm9jtbElGQaTs2nrjbCpXbnrVP4hhwI="
          }, {
            "num_cand": "U2FsdGVkX18I3qlqK+COr6G8RYwJvF1QoBbAwGdGVeA=",
            "cpf": "U2FsdGVkX18xND69UJScRZUgRLcUAtT3C808PLUB9OI="
          }, {
            "num_cand": "U2FsdGVkX191On8ctwNp6LZTkrvnu6lDH029mg5CsFI=",
            "cpf": "U2FsdGVkX1/iYJ3RcvpU4U3/2ODBG1p97fgg+l+K9XQ="
          }, {
            "num_cand": "U2FsdGVkX18Y9D59R0GDvr8xAwCQrcV1hAVk8oOPCXE=",
            "cpf": "U2FsdGVkX1+j3pLblPqk0RAkpZwdGOiUmatDGr76Hsg="
          }, {
            "num_cand": "U2FsdGVkX1/1npYPM/cUtwxdCT7qiGsXQPepgIjqG88=",
            "cpf": "U2FsdGVkX1+I6czPWYqGKdEFV4set6yPioU46+pZECc="
          }, {
            "num_cand": "U2FsdGVkX18/6ISrKSKm069B9Kn0mc9Hmy6UksPgNZY=",
            "cpf": "U2FsdGVkX19G4+Wui98xJsT1278jjFvzgusTVcUys6c="
          }, {
            "num_cand": "U2FsdGVkX1+vCllBmCxHnrMIOwYyq2NmX69uiPvecw0=",
            "cpf": "U2FsdGVkX19rx4maa4Afb7Al5eIvNhc+tGIqkv256UQ="
          }, {
            "num_cand": "U2FsdGVkX1/W3OwgevBXJ/Kwwh4sqc9FRuBNCNELRR8=",
            "cpf": "U2FsdGVkX18KdpYZcRUgIKUFW1u8tV6tevlAHKxhg/k="
          }, {
            "num_cand": "U2FsdGVkX1++NxPwC9qhvCQ6SioSolfqQoeHTrr4fys=",
            "cpf": "U2FsdGVkX19VG+9yJXIjyDXjMAr/p3GDjTy18OniRW4="
          }, {
            "num_cand": "U2FsdGVkX19QzUS219xPLQ449c5PqwoV71bQf+ZVuwY=",
            "cpf": "U2FsdGVkX1+x2j+AvRFPzE/ZwsBjqDtXOZWkE0HqFNU="
          }, {
            "num_cand": "U2FsdGVkX19ucyqkvV9q7x7uT4/+vH4Xl05UqWcAsf0=",
            "cpf": "U2FsdGVkX18ukqlDwKAJHwSq1AlZH7pjibusJtPajnI="
          }, {
            "num_cand": "U2FsdGVkX1/5b+NULgwk81wVgC/qTVGEHUzOdfzZ/jE=",
            "cpf": "U2FsdGVkX1+8sGDM7GB0MiHMGjEed+eOkevtNtMUWus="
          }, {
            "num_cand": "U2FsdGVkX19zJJLmLcgt3BRCnCMXTc8JqbgcBk6JbTk=",
            "cpf": "U2FsdGVkX1+G2Za/iFwLhW0mbV+P2Ih0s552fBj+pJs="
          }, {
            "num_cand": "U2FsdGVkX19O/4v4XJp16wFtLA3t1g/9ehMmLLYh5TE=",
            "cpf": "U2FsdGVkX1+0s9JpWoVPTYh6F/rFz46B0p/JwJSmLDs="
          }, {
            "num_cand": "U2FsdGVkX19bM1P0OB+dvGQfnDK8VCb+tbBhpIEUqO0=",
            "cpf": "U2FsdGVkX1/uMmujwnVvPjdf681cj0mhm2rTYoVGxv8="
          }, {
            "num_cand": "U2FsdGVkX19tIgv2/0fPQDwZTFIrxuCa4xsGFH91kU8=",
            "cpf": "U2FsdGVkX1/TjZQwmPAdO72ZSxVGyKiUFX6Xi/JjAtA="
          }, {
            "num_cand": "U2FsdGVkX1/4ciGBHtXHspvNM5ZsYZu+3kIvX2/zZ0I=",
            "cpf": "U2FsdGVkX189AyVbEZX17Fm2xDNZ5buL3gNbQ++2S1I="
          }, {
            "num_cand": "U2FsdGVkX1/36ngP6HtdBPEG0fRohh3G9JZt3r0V/XM=",
            "cpf": "U2FsdGVkX1+1Q9na2HsWyUGHls11PVnKaCiaV/r0KqY="
          }, {
            "num_cand": "U2FsdGVkX1/2ddCGUS6kSd/jo51fIGWLuZeO5trxV68=",
            "cpf": "U2FsdGVkX1+s1eOIsgwbcr5eMC5xII6zlbrDaeqiB8c="
          }, {
            "num_cand": "U2FsdGVkX192Mv6wV6LshwU0xoXkHeSuiDs4x0Y+uq0=",
            "cpf": "U2FsdGVkX18Nor9wfR/Th7+6L5OmH1A3TJLCPDP4GSY="
          }, {
            "num_cand": "U2FsdGVkX1/BIOll2c8OGYIqgeH5YqOaZcBBImjuOdE=",
            "cpf": "U2FsdGVkX1+0hv3mj4sbG2Q6sVltqYiyGhce4Tsj4VY="
          }, {
            "num_cand": "U2FsdGVkX18CcjQe+metm88Z9Rqt4W5RyJZ3/xGt7AM=",
            "cpf": "U2FsdGVkX18EO3H/u25KnGsqaZJU/p7krBScOsS/C1I="
          }, {
            "num_cand": "U2FsdGVkX18cs5AAUm/lE8HSZChdAqKdLkFrdAO+kKU=",
            "cpf": "U2FsdGVkX192kJDTFmiqpLbU2kzazK18eSLYAIYOoxE="
          }, {
            "num_cand": "U2FsdGVkX18hWb0PUxeog3mjp0F1gZA2tmAXGinKcA8=",
            "cpf": "U2FsdGVkX19bHDh/YahrLRzuTAd47OfNnOEFsBKMCg0="
          }, {
            "num_cand": "U2FsdGVkX182bisFzQxxE5ZsxavJIbOlgRcTRpENySE=",
            "cpf": "U2FsdGVkX1+xH9qzQs/I0LvrHPql9/jZ+XnghW/LRx8="
          }, {
            "num_cand": "U2FsdGVkX1/UHPDA5s6ng1DorRY2qlnLKSNsx6GhFxE=",
            "cpf": "U2FsdGVkX199pvJbaIR0uFJ1CFRVDw6R2JPN+0eKE/Q="
          }, {
            "num_cand": "U2FsdGVkX18bjZOgnKDj6tp01t4MhgMJMIYIPdrL4xU=",
            "cpf": "U2FsdGVkX1/voOQnbH2drlceGlc95n+XIpzjv5dAIPE="
          }, {
            "num_cand": "U2FsdGVkX1+iEutNcT0kosGGvuUU0Dt0ldPjuzeOu6o=",
            "cpf": "U2FsdGVkX18BubT4/eh/Aw/TIw3xns9MNniriM7qozM="
          }, {
            "num_cand": "U2FsdGVkX19pNjevC3BR414eb16Y3DRmJPe/v1/ECZY=",
            "cpf": "U2FsdGVkX190/hwbTWWISbZ/OkwzqNVL8w3ELXxjb/E="
          }, {
            "num_cand": "U2FsdGVkX19UH4mJt6h9mVvGqmCsFmtgYGLVq+aDotg=",
            "cpf": "U2FsdGVkX1+ztMJ0QZNFPyTTZecY2INyUrccIWjw2Ko="
          }, {
            "num_cand": "U2FsdGVkX1/5VMplLcFQUz+Su5tEemzRuqpcZhCfIfQ=",
            "cpf": "U2FsdGVkX1+A9cxVaVvPLfKl/QrXrUE5p4XWZTxUpb4="
          }, {
            "num_cand": "U2FsdGVkX18HZZA6rpvvzmia2lE0j1CUXbqI6gjVpKc=",
            "cpf": "U2FsdGVkX18oz4BGZBJ8Oa3ERFkYoBggPSGP2aGsUtU="
          }, {
            "num_cand": "U2FsdGVkX18ikMWvDYVEj5FYZIuO/WRlOIFh7kD0H4Q=",
            "cpf": "U2FsdGVkX1/8T/QQxRPc4yqcSs8vAlzFs35nD9iPACY="
          }, {
            "num_cand": "U2FsdGVkX19yo7pO9oInhcimm8sd97G5UOPHGTxlhvY=",
            "cpf": "U2FsdGVkX18r/UznfrssjVbUROB2emJdf5OPGmWm/Ws="
          }, {
            "num_cand": "U2FsdGVkX1+pdffgL4KNCzDWzVudo5JfxKxXtWl/ihg=",
            "cpf": "U2FsdGVkX190qzAALVjViX+K6XXvtz0Z/v+0wWDbA98="
          }, {
            "num_cand": "U2FsdGVkX1+9p5DKkQLpC1t/PqBc+yFx+5HZNqTXueQ=",
            "cpf": "U2FsdGVkX1+nqu+MKmFO+GRRbpXu6SSVFNsYfKrRURg="
          }, {
            "num_cand": "U2FsdGVkX19qx7uqcC5w50kjrlNa01dD9WEoDYhBxLQ=",
            "cpf": "U2FsdGVkX1/zdh/rMqCY6R8vo5tpx3oHecZ16XR9J3U="
          }, {
            "num_cand": "U2FsdGVkX1+ZSKJVizte6cIVOysxwGWaofuUnBAS2IQ=",
            "cpf": "U2FsdGVkX19PrQ1mCxgPt8BTb1Ye5W5HFXkVLlyBFv0="
          }, {
            "num_cand": "U2FsdGVkX18JT3YnxIWtm1/cMQZdyJG/oTtpXKreDIY=",
            "cpf": "U2FsdGVkX1+l4ygZF73ccmqtw/3eH1E9a4UND9MYcy0="
          }, {
            "num_cand": "U2FsdGVkX198Q7VYY1QGs3+/QjdXhZ4QxOOOH8Y8+pU=",
            "cpf": "U2FsdGVkX18t+7w7Tt9cuRvjQgSXUtweI+lHFb1PVwk="
          }, {
            "num_cand": "U2FsdGVkX1+yC95XW7sMccUHDinBuI08I8K1cX63LCs=",
            "cpf": "U2FsdGVkX18rZ0Dt9gtgdFsWronGv4A55E8Av/2wd7Y="
          }, {
            "num_cand": "U2FsdGVkX1/Ybzgi73ZXkqPELyArV8RsyHu5G07PjEM=",
            "cpf": "U2FsdGVkX1+dk+XePpr+MzAF/p57kmfxoliK2qSQoig="
          }, {
            "num_cand": "U2FsdGVkX1/Rk0yzENfs91oeH8TdyAGTyPdAsu7zzus=",
            "cpf": "U2FsdGVkX1/SmUwI+TDAaMCXZDblQ6F66mtnMjXxPiI="
          }, {
            "num_cand": "U2FsdGVkX18dWFTEIBM8uD739iuMGqrgznxBClcYQow=",
            "cpf": "U2FsdGVkX19964GrT9Jh1VY92hDOuUGWdlytzrF6sJ0="
          }, {
            "num_cand": "U2FsdGVkX1+a9qINO2PLRfLUOFEJxmoYHDK0EdgMFSw=",
            "cpf": "U2FsdGVkX19jTI7DcKOdAvEkUuIlQ5WoZdXR0I92G50="
          }, {
            "num_cand": "U2FsdGVkX1/LStc9a1w0WcVIJyKgNPyV61GVxDXCJYQ=",
            "cpf": "U2FsdGVkX182zvGg9jRClqBy7Egmd/hijSBDLZ+9Kkg="
          }, {
            "num_cand": "U2FsdGVkX19j7zt0RW0Dvb6LAFH8N2fLXWeZZ7cQ2kU=",
            "cpf": "U2FsdGVkX18pSMvYKr0CYqFZD0a5xSnxobwIjDQxX8I="
          }, {
            "num_cand": "U2FsdGVkX1+fYW6QVbBoJJqMK1nhBufprcG3K7bbW9A=",
            "cpf": "U2FsdGVkX19ZmpfuYLzdrvmuIw0ScxnrasO86w7Qy6U="
          }, {
            "num_cand": "U2FsdGVkX1+Ig1aSzse+Ay0dBXioD0jA67MYJoF1Wvo=",
            "cpf": "U2FsdGVkX19mlUYdl1ucEDlPPmpOQybgAfhfDDp8Fcc="
          }, {
            "num_cand": "U2FsdGVkX192q66GV+Upoc6/ahFvTzOyWkbtDY0mSBM=",
            "cpf": "U2FsdGVkX1/+OlxX52VsFL2bckzs7v9fxAsF8IRH8fc="
          }, {
            "num_cand": "U2FsdGVkX1+C5gY3wHRHaTl7nQiY3CS7Yu2PI2L2dn4=",
            "cpf": "U2FsdGVkX1/P6k5gATKLOgdOCHpU/56Sw1MMf/MSP9g="
          }, {
            "num_cand": "U2FsdGVkX1/EFfSJ7v70TrCInzUiyK9aabQuXbSBblw=",
            "cpf": "U2FsdGVkX1+6JAIcq4YlCG/7ReBuRwOACMljZoPxztI="
          }, {
            "num_cand": "U2FsdGVkX19Bm+G0VKMzBTUwL3P2xIyvJj2aAOrBLe4=",
            "cpf": "U2FsdGVkX18U4zpQEwuR5GK/LaQya2VJgr39pJEmAJ4="
          }, {
            "num_cand": "U2FsdGVkX19dqDtfo2kuAm/F2optYYh1PTBdXjp/+2U=",
            "cpf": "U2FsdGVkX18p60ZK/leZnr/TOSDz3tQJO/+3KpRVhYk="
          }, {
            "num_cand": "U2FsdGVkX19LxHB0FBnK4EngX2/yIOOkZioJOCK/us4=",
            "cpf": "U2FsdGVkX183KtWeG5USRiEBlPoAfKaoMHlvl1c6WPc="
          }, {
            "num_cand": "U2FsdGVkX18EPJcy+z4N97BkS9cn9bhM7IMQqm4/X/Y=",
            "cpf": "U2FsdGVkX1/P97i3kRNQCnFLFU4UFQM8qe1EzOySifU="
          }, {
            "num_cand": "U2FsdGVkX1+7xtQ70rR4xqAQLzwcwNwfhloG/dJ6q64=",
            "cpf": "U2FsdGVkX1+2ocpeTz7zNPB3AB17NQCzw1xxC+a9Gbw="
          }, {
            "num_cand": "U2FsdGVkX199ZMNcsgXebheYfkhLv2FpOWQDQ+HC6d4=",
            "cpf": "U2FsdGVkX18302d+k8w6O2mVOwEjo0j5C3q4amK8SUA="
          }, {
            "num_cand": "U2FsdGVkX19q5mas55nHsKeUSx4v4tGnFdyG4Yfg4+8=",
            "cpf": "U2FsdGVkX18DzkF90ScOQ0YLI/whPGBxkYg5mdHz4j0="
          }, {
            "num_cand": "U2FsdGVkX1+ANX2zaectStsK2epk5ZpXfsv81u1cjRg=",
            "cpf": "U2FsdGVkX1/7SFqRcm4wLFAXud2KAZ0OuF++r4HF0Nk="
          }, {
            "num_cand": "U2FsdGVkX1/kCh9BcNrZhIonRuME+ZVDWogLb2CQPqQ=",
            "cpf": "U2FsdGVkX1/UHe47T5EWoXWHBsDzuxMws5TfnueOm0M="
          }, {
            "num_cand": "U2FsdGVkX18ezO9q1tYWZ4/ju6GfuCiVrdNvKg7Kn2Q=",
            "cpf": "U2FsdGVkX1/bEB/ZvRk5fdxy9LpOuPS0EUG1sxri91Q="
          }, {
            "num_cand": "U2FsdGVkX1/YKN0mPeWmo8Ql6Uj0mnz2bgITEdMCO5I=",
            "cpf": "U2FsdGVkX19+Lt0vgcX9ATrO/BthLFF5eaoSBWApyno="
          }, {
            "num_cand": "U2FsdGVkX18nQtpTU7/bNtaH435Mo+kqjkM/9hvQetg=",
            "cpf": "U2FsdGVkX18RugsiYrVJ9pIm+80nzFvxphAxc/m3Jv0="
          }, {
            "num_cand": "U2FsdGVkX194DXo3zRk56HveFtOvaTjNvdOXxa3N938=",
            "cpf": "U2FsdGVkX1/ZJMG4yJqDTP46xby2z7pMPqaE/ZeYMuU="
          }, {
            "num_cand": "U2FsdGVkX1/X1j8e28+aBfJGxtCNQC6WqAREOiikcyg=",
            "cpf": "U2FsdGVkX1+hVUp0gPtrYxQbmwr3I3giB1YOpkbVfRM="
          }, {
            "num_cand": "U2FsdGVkX18wqMX3a2IGesAntjRVKPlowJi4uC3WhW8=",
            "cpf": "U2FsdGVkX19nCIOHrbqNh017Ga3vwAzL6Z69coTw0UQ="
          }, {
            "num_cand": "U2FsdGVkX1+ClrhFflv5bsu7/sRAeWFveu1H6brzR+I=",
            "cpf": "U2FsdGVkX1/pWe3SrXqwIY1Zh3eGl9zlWGn7dg8TOFA="
          }, {
            "num_cand": "U2FsdGVkX1/e3wvA/jB34Vt1sFSEjOR97Mr+ESoHrFI=",
            "cpf": "U2FsdGVkX1964mSxS9shRqgrhZpDN9kFN1ta/YXAdbc="
          }, {
            "num_cand": "U2FsdGVkX1/euBKNKWzTmIDNVLEI6/48gVAWQ/rLrrY=",
            "cpf": "U2FsdGVkX18B5b77kqAFlrK6vTrWAVK8kUj22FBAA3M="
          }, {
            "num_cand": "U2FsdGVkX19Kt61qd65xo3nYvfA4c/wo8419Io2okm4=",
            "cpf": "U2FsdGVkX19m7c/RjhUycsu38/cYG0ncX5MevlvoVZY="
          }, {
            "num_cand": "U2FsdGVkX180x+tTB8uDAO9CXKJJq4oMcMR+1nl87dY=",
            "cpf": "U2FsdGVkX1/rtDETAuo5vaVN7GeuAWk6wI8fRnmIrYo="
          }, {
            "num_cand": "U2FsdGVkX18pyYh6lXTdxcvIzH4lWMkZPHKWN6WnQ/w=",
            "cpf": "U2FsdGVkX1+03ZxbYZQkSE+G9XeYdW/pmWWGli1gQMg="
          }, {
            "num_cand": "U2FsdGVkX18uzOSamMXp3+CBPC1fB14MrQQ+NGUXCrU=",
            "cpf": "U2FsdGVkX1/IfEXksYcG8koQ1sF+UbNzdAWK3Wuj1AA="
          }, {
            "num_cand": "U2FsdGVkX18ubW0ybZ7KsRJUVgHTfguhX0AUDoVLemI=",
            "cpf": "U2FsdGVkX1/8RWAELfaVFV70QBCpazcg0wgEikARQR4="
          }, {
            "num_cand": "U2FsdGVkX1+T9atR4UT6iJfp267FZ81CUOhkYDwC+Vg=",
            "cpf": "U2FsdGVkX1/Abjjq+YP6Rdsf4tRNwiP+7ypfxSCjdeI="
          }, {
            "num_cand": "U2FsdGVkX191/XHeGc0x/vnX9Y4zyHBu37GutF/ZcN0=",
            "cpf": "U2FsdGVkX194+a6uXx7TSayQXKUlql99mSIIpPpmM8Q="
          }, {
            "num_cand": "U2FsdGVkX18W5IOB0+/RUQ+ypWJg0fWTul+C89EJskU=",
            "cpf": "U2FsdGVkX199NomUtatVgHL8I2wSw+X+0YJmtgKph+U="
          }, {
            "num_cand": "U2FsdGVkX1+VhO+UMqs9tl1pTspi2adhEHv7sUPawm0=",
            "cpf": "U2FsdGVkX1/KxSxxjaQdwvFBSA8TjHSGKkD03o1k27s="
          }, {
            "num_cand": "U2FsdGVkX1+tD8pk6I3lrzR5HLTfGiE2LvfuXNc75CU=",
            "cpf": "U2FsdGVkX19CykAv5X3KfRjERZ+nLMvihR6/hZuujEs="
          }, {
            "num_cand": "U2FsdGVkX1+7UM/jAFk1PKC9SAUDuOc07asuYdoHoXw=",
            "cpf": "U2FsdGVkX19NfkOBPKwkDOYjbSEl00GdJnYAJiEtZhg="
          }, {
            "num_cand": "U2FsdGVkX19LqRLQyV3qpVYXu8NzBMOSAaFdoUY+wVw=",
            "cpf": "U2FsdGVkX18XSWXc9vuX3EMJMTX/m+rAyqaY9/XoPlw="
          }, {
            "num_cand": "U2FsdGVkX18DIuengMcZAL+Sh5UXtuFlfoP/wrDhuDw=",
            "cpf": "U2FsdGVkX19b3Nu2jfKCAzN4RznhZKXZAww5/G34ZVY="
          }, {
            "num_cand": "U2FsdGVkX18V8+m7l1MjrdpNbksnfLEZkUgwzZolNvA=",
            "cpf": "U2FsdGVkX1/ZS0b4wnNmeIbSs8YAhe7QLzVirbQdhUQ="
          }, {
            "num_cand": "U2FsdGVkX1+n8TlOySkSNHqNR4p9FmqPntWZpaFetWI=",
            "cpf": "U2FsdGVkX1/Kc+WyMBRo2ZqlDFGMbOGB41Njo5dG25s="
          }, {
            "num_cand": "U2FsdGVkX1/y724eAytk/20AURrGVKz/n3H3f4aSqxY=",
            "cpf": "U2FsdGVkX19nv2iuJnDv52GTV9Ydd41iMsmlsdNRxRY="
          }, {
            "num_cand": "U2FsdGVkX1+ePKNl7w4Zw56ADbTe0VWKVbdKhKL9sCQ=",
            "cpf": "U2FsdGVkX1+nAv9rBwzLIl7RBYqe20WlTI6uEC32ldY="
          }, {
            "num_cand": "U2FsdGVkX19+la5vHYP3kIksV3u+8EbfcK6mAOdUbrQ=",
            "cpf": "U2FsdGVkX18TB2IWconERpukqBgPokHVmyxNJAxWdkY="
          }, {
            "num_cand": "U2FsdGVkX19KaCJ5ncONEf+WXlU5CKQy9PR215NGTqA=",
            "cpf": "U2FsdGVkX194FfFJofW/2hfh3qOEZIOKVDksVI+YbSo="
          }, {
            "num_cand": "U2FsdGVkX19mbBAf6uAxN84cwzQyhwbblSM/6G7iRK4=",
            "cpf": "U2FsdGVkX1/ijL758zbmHe+SC4G9SHRnyJaU2SmgC14="
          }, {
            "num_cand": "U2FsdGVkX18TlWoNAPcXC6XFOh1YztWbZB2txFKUV+Q=",
            "cpf": "U2FsdGVkX1/JEIDWzZob7wdtP/HaK+x09EzbCAW82Lw="
          }, {
            "num_cand": "U2FsdGVkX1/6U6eRrJU8qK/6kczo3buhKR/tILhfO74=",
            "cpf": "U2FsdGVkX19sFyM9pq27/ds1xW3YAtgAlbd/wYtrNmk="
          }, {
            "num_cand": "U2FsdGVkX19m+JCCKYnAL2onD/1H2XtbBIiW8Gdc2M4=",
            "cpf": "U2FsdGVkX1+GtlJWsU4AfrK4A8JSRD80z6wzADlKQrw="
          }, {
            "num_cand": "U2FsdGVkX1+gqYEkz8cZv7wrj5LAdIO4QM81Ons49ts=",
            "cpf": "U2FsdGVkX1/Nr/XzKzfKn9A+Mq+WrDnpXWF4e9lzbt0="
          }, {
            "num_cand": "U2FsdGVkX18SBLTYrZ7+dsVPT7pMlf2RbXakXTrTlCU=",
            "cpf": "U2FsdGVkX1/iuWxbUi2PyrmXbKjMAeC0O+VY2cetQLk="
          }, {
            "num_cand": "U2FsdGVkX1+Vhr0zPbSWng0i8729ss3t3XhCvO+FSLk=",
            "cpf": "U2FsdGVkX187GJVNI760ey8Fhivzl6jKmLstJbILDDM="
          }, {
            "num_cand": "U2FsdGVkX1/h88Ud358u106Y56KaHdMu9YCUFu3bKv4=",
            "cpf": "U2FsdGVkX1/e6bgxhSJkada87YzS7msye7ABuNFFZh8="
          }, {
            "num_cand": "U2FsdGVkX198XtfuQLlzWFna6Z4axPLynSxd5I1aikc=",
            "cpf": "U2FsdGVkX18Dak7St1jDwtThHLMs4tTjymyfJRPeWwg="
          }, {
            "num_cand": "U2FsdGVkX1/6wjOhhAndYW+3G7ACRLQYYpTUA3AenP4=",
            "cpf": "U2FsdGVkX1//L9qchg9t35hWvPIzsX/0+vCwSqD4xCI="
          }, {
            "num_cand": "U2FsdGVkX192b/fWWvw+N4jSWXS6BDaNgJ58TYmtUNo=",
            "cpf": "U2FsdGVkX18QGStpEfCEzZkCt8XfWq0xXi86xGHSaLM="
          }, {
            "num_cand": "U2FsdGVkX1/G2oXn3LuUvPu/AbcdgiY3955cjHog79o=",
            "cpf": "U2FsdGVkX19uUF2SKfGVeSUTiL4+J5ChAfcIaAJ6Btg="
          }, {
            "num_cand": "U2FsdGVkX1/E2oJS9pQuh0pGpZx6n965436GQu/qSbA=",
            "cpf": "U2FsdGVkX19J+022t3ufH4c3EkYhlwUgUgOqx+BRZm8="
          }, {
            "num_cand": "U2FsdGVkX19Fj9s6COwceXuAfSzkngwdNSNRyehFQxo=",
            "cpf": "U2FsdGVkX1+5rd0Qe/ifSJJGLpL3q5ZLvw4xnUaoxJE="
          }, {
            "num_cand": "U2FsdGVkX1/ciEhtmJ7jGf9gQwovqIC7Jr2+d9oChm4=",
            "cpf": "U2FsdGVkX199d7x7Tox0E/xaZFVNilUW/t0+C77rKg0="
          }, {
            "num_cand": "U2FsdGVkX19oUptlgBjSdEJz7xrkbkFtETzpvEgqyeo=",
            "cpf": "U2FsdGVkX1+TZpSBACcm8kHvIbiZW2SPTthcSJTHqWg="
          }, {
            "num_cand": "U2FsdGVkX18nLh+dfzCFO/r9PSKKQMOeYGlOq6QWero=",
            "cpf": "U2FsdGVkX1/Dc5jtpeyD03cLn65ygtC/glBGmA78DNw="
          }, {
            "num_cand": "U2FsdGVkX1+jUjafC9W0vzMLWwJ4mlwlLMiL2dkklpA=",
            "cpf": "U2FsdGVkX18aa18hbI4T/qCVboaaVPjYMDpzIaSN4yA="
          }, {
            "num_cand": "U2FsdGVkX1+snESYfoYm5UDK2ENZtaYvJQzi+sQwroY=",
            "cpf": "U2FsdGVkX1/67xPuf8K/J7N+Jx65jgum9amDcMZ8108="
          }, {
            "num_cand": "U2FsdGVkX19duTmiV6ZvyO1zthxmgYn2OQuXKD9zoHE=",
            "cpf": "U2FsdGVkX18Hup9a5D6MzZ/H+b0HwWLAVHDOJRd6LZY="
          }, {
            "num_cand": "U2FsdGVkX18lFUcNy5Y+C/SjowPfSxybV3DzEU6Yrpo=",
            "cpf": "U2FsdGVkX1+WhSeV0fLXZ9nfx8t3eHow1XpeoJjZ5sc="
          }, {
            "num_cand": "U2FsdGVkX1+UBXLU1Rn1TZcUnohmK5/7p1HQFVOdknk=",
            "cpf": "U2FsdGVkX1+ifUmc8vRQx6Zgap+G2eekQb2sol6Z0t4="
          }, {
            "num_cand": "U2FsdGVkX1+3nqtkb7a9D9flRV4oZmH6RQ4xvMaiZDw=",
            "cpf": "U2FsdGVkX18t0W+TcG0RRmUUuDQQ9T4jA52PSwen63Q="
          }, {
            "num_cand": "U2FsdGVkX18Xrn3JH4rjM/5sbjuCbgrAbmJ2gPsT9M4=",
            "cpf": "U2FsdGVkX18yT/ES6Vl/3g/ugZAuGwg2vAC9IiDHL0A="
          }, {
            "num_cand": "U2FsdGVkX1/Tg6i4G+KnGzEMBJu5UCiuRAzF1M7gH8U=",
            "cpf": "U2FsdGVkX19lzXUE83+cjeFgF91zPN2b9UiBz0WidpE="
          }, {
            "num_cand": "U2FsdGVkX1+NqstlfNhz4cDvKkHn4cmc8a/aBN043zs=",
            "cpf": "U2FsdGVkX1+T05IU6iypJSCk5Pd5HY6QK9wN3ruXNbU="
          }, {
            "num_cand": "U2FsdGVkX18WrFVEL/Rc6jL7JSNh/GkNcyLUQ1EWPWE=",
            "cpf": "U2FsdGVkX1/newYa+GiX6T6yAXvCPD/ER6vtKmPE6r4="
          }, {
            "num_cand": "U2FsdGVkX18UeKodF0KbiULTCWvojM0TsQl+mbA7974=",
            "cpf": "U2FsdGVkX19kNpNrxdImnORVsmgyUlLxo9rcjNvXyvs="
          }, {
            "num_cand": "U2FsdGVkX19QJlwfZYI+gBs3Uk4OElnNFNaTpIRspnM=",
            "cpf": "U2FsdGVkX1+0WlnL35NvstoCqz8Ygjq+3vIZlLVJHQU="
          }, {
            "num_cand": "U2FsdGVkX18m+V2mneOcEKpR3BlnaBGalcwqEmIZvek=",
            "cpf": "U2FsdGVkX19cew4+sXVn1wf/6DANS6AtfIA1eP0GxzE="
          }, {
            "num_cand": "U2FsdGVkX1/A4Utu6Ad2qq3EfGtbXc82hKnaKApXaY4=",
            "cpf": "U2FsdGVkX1/1LXF0fB4awXRwxjjRrn00w2PKRH7z024="
          }, {
            "num_cand": "U2FsdGVkX1+ck9HQ7UbqhnvFv4EePWYIn5/d0a+zGhQ=",
            "cpf": "U2FsdGVkX1+VOpsSbcRoK6yUhuA0Nua1A/cX/++aXpY="
          }, {
            "num_cand": "U2FsdGVkX182KZShBGxdvRBLezSmZ/ztSEGaanKOkqw=",
            "cpf": "U2FsdGVkX1/vRLB8se2pHO/lQhW5zBHuJoad5Xo1hQk="
          }, {
            "num_cand": "U2FsdGVkX1+QSWZbe9gpq5arsPc082DTjW7h8hNZFc0=",
            "cpf": "U2FsdGVkX19USw86y3EJL6N0gjnposp2mWl7HD4VzBQ="
          }, {
            "num_cand": "U2FsdGVkX19npSjEBJ6QgTJHCeBgrXnpr/juIzuF24Q=",
            "cpf": "U2FsdGVkX1/Ov51QbDj/Ugx66rPKlgh7WqtHMKLjxxU="
          }, {
            "num_cand": "U2FsdGVkX1/p9umE0RvXSuiZFsoXU48mvWqvxhhn/n8=",
            "cpf": "U2FsdGVkX1/p+ETiWyXyqhVWuq2Efgtk5heWKMCDuUU="
          }, {
            "num_cand": "U2FsdGVkX19ZQD6GVSReVHOA+GbP8rhM0M8QTa60KpM=",
            "cpf": "U2FsdGVkX19hqnMcdMfp55/uY5GSvLDj6foZRWCjCxY="
          }, {
            "num_cand": "U2FsdGVkX1+uTl1Reqt9d2fcO/6i9jzU+X12Lj7oKtk=",
            "cpf": "U2FsdGVkX1/YEHZ1siFRLFKaF6ACb2s3MrYLH41NESk="
          }, {
            "num_cand": "U2FsdGVkX18iGU9UpYv/of9iNK7ctg2e3g8wqupQQSI=",
            "cpf": "U2FsdGVkX1+tNKUNUrh6iyoo3QD4e8H0c2S+KpIQzds="
          }, {
            "num_cand": "U2FsdGVkX18JVexnwXLzWBYsJYsG1pA7/+20UbSI0Cw=",
            "cpf": "U2FsdGVkX19xgPQgyZKPgvSbwS7i0n7Zb84vPiQvdl0="
          }, {
            "num_cand": "U2FsdGVkX1+Op2htUMW7GFUOIuX/kmyzW32RH3wmdEM=",
            "cpf": "U2FsdGVkX19K5MDnmoX4Z7CXeFX74R95CNisjVXU69s="
          }, {
            "num_cand": "U2FsdGVkX1/52/vgGkBBfwkUCV/RGhRUXqQ19V5ahkY=",
            "cpf": "U2FsdGVkX19IdINf7ZzE58PAkJtdSvf7YeST8c5aDe0="
          }, {
            "num_cand": "U2FsdGVkX1986K65Wv0SutxzsgmBUVk6TBusGC9udIA=",
            "cpf": "U2FsdGVkX1+R/D8eLSiNQ6V9VXC9tNDALYaRRiK+Tgw="
          }, {
            "num_cand": "U2FsdGVkX1+J4Y8+rTB4/kwwrFyV8kFQmUhEJjl2rpQ=",
            "cpf": "U2FsdGVkX1/xh8NwFbjZDSBdzlAtOG+QfZD6aetwQ/I="
          }, {
            "num_cand": "U2FsdGVkX19mJRTHRRSOBfoEpjiURAv761Atj2v29po=",
            "cpf": "U2FsdGVkX18qXRJKBonIUHPl260RoLnM0iXXqXy39kk="
          }, {
            "num_cand": "U2FsdGVkX18Pdh4tw5lBVPLgfJR2xaIiU3O1ORZxQKk=",
            "cpf": "U2FsdGVkX19j2HjTJMVjuiEJRbanu1Dye0pMjfjfnJE="
          }, {
            "num_cand": "U2FsdGVkX19QEj5wii8Nv08tKXn5Jv9Rku2/ho8go/g=",
            "cpf": "U2FsdGVkX1+EV0eJNDHJBhVvJWzUlnSGiMqrIThLXgY="
          }, {
            "num_cand": "U2FsdGVkX1/zJFam1NcKozLjz0sv7CFzcyoURQINtQs=",
            "cpf": "U2FsdGVkX1+6GnfJAkT+WwZHBSdPUempmq7drZlPX1M="
          }, {
            "num_cand": "U2FsdGVkX19bytWD5EU+OiE2u+FDMrinD03nmAsdXZQ=",
            "cpf": "U2FsdGVkX19MseLpSvMmQ5+hP1H6bWh2dbWWZd8JPwM="
          }, {
            "num_cand": "U2FsdGVkX1+Gvo7bybipKuTUaOdAijusBDRM7aJHLoQ=",
            "cpf": "U2FsdGVkX195X2mrpndWuuoXNsIWU/bbTJJajhGA2bA="
          }, {
            "num_cand": "U2FsdGVkX1+3+UPcrSFNudfHf8vDZp7Y14PSwcrn2VU=",
            "cpf": "U2FsdGVkX1+mJbgQEW6J0DUJAK/bn4PSwVajzffDN4Y="
          }, {
            "num_cand": "U2FsdGVkX18pGA7//shwtt5la/cpffdmg9gnLkuP9vg=",
            "cpf": "U2FsdGVkX1+JjbSG0B/wWrJVPOm2zFcG3PmlO9Og8lw="
          }, {
            "num_cand": "U2FsdGVkX1+h/akzJCMpbYOi1Rk1mNlOdkAJG2FrFC8=",
            "cpf": "U2FsdGVkX18/9sZoUjz/NwRmEzm+LZvbmnWZ/4e966M="
          }, {
            "num_cand": "U2FsdGVkX18yfqOOnBvrtv1nztUyQqfZcXqIj55Af9c=",
            "cpf": "U2FsdGVkX1+DNnW65vjU8g9fqlTKHyuCgf448k1LrXc="
          }, {
            "num_cand": "U2FsdGVkX19opImUc7RyHpQ1XKnt4IKkMnDARx0CdqY=",
            "cpf": "U2FsdGVkX18tg/nZ3i2WGSM/xaopMctppRT++Qbq8O8="
          }, {
            "num_cand": "U2FsdGVkX193eJoKKNGk0Vni8UdAseWrQhM/yHBTTkc=",
            "cpf": "U2FsdGVkX18mQYv1Eg0jsqhew3OhripUePH+qk8S0Qo="
          }, {
            "num_cand": "U2FsdGVkX1/MSZOxyo7CYTImKeaQZGLz6hlQQ4AraMg=",
            "cpf": "U2FsdGVkX19jducNW6Qre6TrCZ1hQYJfFqAPg8fXnx0="
          }, {
            "num_cand": "U2FsdGVkX1+6GKDy0iET1Ur958sR0o98INubf1sOdrk=",
            "cpf": "U2FsdGVkX1/iQItXKIVrkd0q2TE6QTdv8WjNBtQYeFY="
          }, {
            "num_cand": "U2FsdGVkX18dDNfs68f77OVNPiL83EcXuaIXrIz7MEo=",
            "cpf": "U2FsdGVkX1/tsoF2pgT61jTGLACj6tNEbMc0QSAIMl8="
          }, {
            "num_cand": "U2FsdGVkX1/OXa9rgjXCZLTfzFLs/B7/XMjSzWr6DXI=",
            "cpf": "U2FsdGVkX1/dYNAoObCsRVtNeqe5KRN/fLN3IR3MBz0="
          }, {
            "num_cand": "U2FsdGVkX1/Rdd34YU6mO6Rep3qcbUC9NIWLa05q1fg=",
            "cpf": "U2FsdGVkX198RcjGGoaBH2rW5faEb/kqXN1VzYkZUVc="
          }, {
            "num_cand": "U2FsdGVkX1+i7Iqx0mdWe2R4CzSxXePGPpf7BzqaF1o=",
            "cpf": "U2FsdGVkX1+EvCZUsJzuRFF8AayASYxz+SyMOl/uu98="
          }, {
            "num_cand": "U2FsdGVkX18Av2wCoIrhF0TvJkju97+zwV6KD+FVd2I=",
            "cpf": "U2FsdGVkX1+QlH8RXyVNK/bDIbcurMHBSjQFqkPTHDw="
          }, {
            "num_cand": "U2FsdGVkX19rkWaNY3SyKo/5VNZQu1Yj7aM+pKU0r9g=",
            "cpf": "U2FsdGVkX180cwQ0K/RP+ZjZJMg5w22dd9ijDxV++n4="
          }, {
            "num_cand": "U2FsdGVkX19xh/fefuFIt2zuqhKrWu7+DxLfrSsDtrM=",
            "cpf": "U2FsdGVkX1+zpscKxg8tz+p5qGwgLJNnLP2EbRsIJc0="
          }, {
            "num_cand": "U2FsdGVkX19iGgEgcoE3RSLoB/pJQIeC9clWUhQ/jgA=",
            "cpf": "U2FsdGVkX19LU26KLS0LTBS8DUsUdI8DmIhqjNF1QB4="
          }, {
            "num_cand": "U2FsdGVkX19OfErEPIXblBk7U+hOUhdu8c+j4aT2l58=",
            "cpf": "U2FsdGVkX1+LrxWBxjVtXjR/0eHM7H7pqJ9dN+N6npw="
          }, {
            "num_cand": "U2FsdGVkX1/FhvT+Pc4Oj+KGJvkLcs3wQtkM8KTb4d0=",
            "cpf": "U2FsdGVkX1/hUcmL4B0NrEKmwQj/MwZpCZHGF9g2mN4="
          }, {
            "num_cand": "U2FsdGVkX19kKu7/YAuqAbxdJjmjY+yrD2d5ucrsi98=",
            "cpf": "U2FsdGVkX1+7Ss5LrnQUMY8RVvtzgNKKkyHA2d0XIbk="
          }, {
            "num_cand": "U2FsdGVkX19nCOO9XJ3zkbnfbTZ0Ew1W1GVp3HttIo0=",
            "cpf": "U2FsdGVkX184z+7bzzKfJlWppipl02R7+XnTR2U6XaY="
          }, {
            "num_cand": "U2FsdGVkX1/t6lS998NaMN+dSbd2yv5SeoggJWidL2Y=",
            "cpf": "U2FsdGVkX1+m/N5i8QQVCqD+sH1xFLQLQfZF7GoH4Gk="
          }, {
            "num_cand": "U2FsdGVkX19yjALKYGqsl9IkN0AEUEkxJ1IaH085Ptw=",
            "cpf": "U2FsdGVkX1+b9G2A0cS0x5dM2qixKWJjlonkR7VbntU="
          }, {
            "num_cand": "U2FsdGVkX19JVR9OvxY6sBIYsdN9QZZOgYgEjcYcgy4=",
            "cpf": "U2FsdGVkX1/7ebuRdftDAkArH2w8BvXztKvteVOFqq4="
          }, {
            "num_cand": "U2FsdGVkX19R/rm/OZOXoUmSl/O/YSperl21hqU2Gf4=",
            "cpf": "U2FsdGVkX1+q+ck0J/yyTwNO+mJ+3j5tlinHM7tERs4="
          }, {
            "num_cand": "U2FsdGVkX1/LmkQ/Ij/Gcjf0Mku6K6oMmmc/FQd8Xzo=",
            "cpf": "U2FsdGVkX18VivSSdA1qPSy5xDMnOWW9sshSzmrlBEo="
          }, {
            "num_cand": "U2FsdGVkX196lgFmfRdpmmeuSyZlb5I5WPL1py2bBgA=",
            "cpf": "U2FsdGVkX1+OU7aUKBC8iBd5uQeL4kN6yBupf4lmMsk="
          }, {
            "num_cand": "U2FsdGVkX18xkHdX87CeSgDSElKdL884vSJsdfl+JcA=",
            "cpf": "U2FsdGVkX1+OvBGIBS8tX+XiNUowxHN9VFM/0EgqYFo="
          }, {
            "num_cand": "U2FsdGVkX18Gzon+xJZ2Ymi3LODlUoJsXuoVrR5t2C8=",
            "cpf": "U2FsdGVkX1/oacEtzqIp9lDlR/pZHWo4p144zjFe97Q="
          }, {
            "num_cand": "U2FsdGVkX1/Dvi0ZzWYKJ4/NGjsNSweXDrzCQqhgRIg=",
            "cpf": "U2FsdGVkX18HdjXvuVTl+AfUw2thVNQ8fGssmyxJayk="
          }, {
            "num_cand": "U2FsdGVkX18qPXd6z4+MTfvwMflLPQeDelE+1lS2NMw=",
            "cpf": "U2FsdGVkX1/O04nPRTMIZSTTlXSxRcpIBks7ixjg7OY="
          }, {
            "num_cand": "U2FsdGVkX1/+PcG/0svwvJSprQJ0rQhF+8cCnJBVyD8=",
            "cpf": "U2FsdGVkX1+fRs9/WqDxfW4AoagwiJfHaWOb0Q9KpPw="
          }, {
            "num_cand": "U2FsdGVkX1/A0J1C3bkisqjiSXadiQXaszxuG1FX3CY=",
            "cpf": "U2FsdGVkX18hdcgKw+Ka1z1N6HcR+aHjznE0+5EtyWY="
          }, {
            "num_cand": "U2FsdGVkX1/bw+F6VstalBafOqH5itfAiqpGWz88dMY=",
            "cpf": "U2FsdGVkX18z3NnnlOuDad4ZDF/+A4CrS1v0NVcL21w="
          }, {
            "num_cand": "U2FsdGVkX19PbV+T2Xw/zJ9Pf6xSlMYvghxpLB+s1QI=",
            "cpf": "U2FsdGVkX1/lUm1tkt7yDmodKBKnqtUogokqmgIytcI="
          }, {
            "num_cand": "U2FsdGVkX195/+BYB4nRJo4CCQ4bAOQ+Gq2DMrwSihM=",
            "cpf": "U2FsdGVkX19kK/uYIpp5I8pczF2WXl1yr3RHr+PUob4="
          }, {
            "num_cand": "U2FsdGVkX1/vM45z4XVjXAX8u3aOjr6wPPydsq65/J8=",
            "cpf": "U2FsdGVkX1+ZDi7wgZhEIQ8KPXRxgdMQr+3ea47dyBI="
          }, {
            "num_cand": "U2FsdGVkX19FCyqELFGpu85GMTxNHEMOLjLIZzvpRgg=",
            "cpf": "U2FsdGVkX1+rv87G3e8eaHLvtRtTYjz9G9q/Kju3Plc="
          }, {
            "num_cand": "U2FsdGVkX18bL6KPw5d9mrnZ+2n0qG/DAg9uQCtTUis=",
            "cpf": "U2FsdGVkX1/noZS5qZ9JZ8yns58zmQAbFia7YT7SsOc="
          }, {
            "num_cand": "U2FsdGVkX1/MOUkSSzRMn1JmXXNlxem6e/lui60lwhU=",
            "cpf": "U2FsdGVkX18/SIEugBSJFSjyIuHSOn0iSmF4JACp884="
          }, {
            "num_cand": "U2FsdGVkX19ERmWYQegFoG2Ok0LMLlPpnNv/Ofvlgfk=",
            "cpf": "U2FsdGVkX19ecVfMGWUuZMQ13SH4k4fcsoplJLfv0J8="
          }, {
            "num_cand": "U2FsdGVkX19WZSjb39kss5PqKMSm/sIASa0ENkjqfLI=",
            "cpf": "U2FsdGVkX196wiGb/P80uc7c7NMmp+4tWBujw6rZgEo="
          }, {
            "num_cand": "U2FsdGVkX19Ryx0onqQy6FCk4nWG3MuiIQ7jQm24+VE=",
            "cpf": "U2FsdGVkX1/8d8tCE8E6GZ0FK4A8XB/7CxsHhfJ8Suk="
          }, {
            "num_cand": "U2FsdGVkX1/z3U4igC7uIVeOEjZWvlHRJj4x0ovCCHQ=",
            "cpf": "U2FsdGVkX1/WcSi64Wz95ZSWpKuhXoO4+3e2kHJi5OM="
          }, {
            "num_cand": "U2FsdGVkX19+7CI82OoCq8yeQT5Up2RhJ5hCrntClgo=",
            "cpf": "U2FsdGVkX1/DW3211K/T54ogvYH/U90m+saytNK0I70="
          }, {
            "num_cand": "U2FsdGVkX1+mXiWE1d7eVQhEAEk9Cs2CIUdRrE1zGKE=",
            "cpf": "U2FsdGVkX1/XO/asLVrhP+TeAVh12JoLGeD3GVcTwy8="
          }, {
            "num_cand": "U2FsdGVkX19Te85lIIJkPm/g4Z6NmlmBQFAU4HwOyYY=",
            "cpf": "U2FsdGVkX1+xTX04eIp+FFnK+0QzxYScBJh7MtLAUsw="
          }, {
            "num_cand": "U2FsdGVkX19JEpBlhmESeASX618yaNO744JlZgEUpWU=",
            "cpf": "U2FsdGVkX18FeL2QE6rh4LhoWuAdaci8Fam3h5mLP5g="
          }, {
            "num_cand": "U2FsdGVkX18P5UOfqanrQ4uzuSi+v1nxG430e8C8cD0=",
            "cpf": "U2FsdGVkX1/UA/sKkro/fPvbfR1fFTsh9x/wN4QK7jg="
          }, {
            "num_cand": "U2FsdGVkX1+b1qpYdMmwjS6JFRvTviHmpu7/tt5Hbg0=",
            "cpf": "U2FsdGVkX1/RC0EUmibIJwayyf+r03V+rSUOQ+oN37M="
          }, {
            "num_cand": "U2FsdGVkX19x+h2pJWv1acldJSd/+6vVAfLaLRasD/Y=",
            "cpf": "U2FsdGVkX1/3OAXv11v3QJ89mVJHigm6bEOSyp4YtdU="
          }, {
            "num_cand": "U2FsdGVkX19R34LLXk6AaY52cxDNy/BSWFrMWeeCJhQ=",
            "cpf": "U2FsdGVkX18LBGYS6+KPEK8xKnjIvSSdEm5SWABjVKM="
          }, {
            "num_cand": "U2FsdGVkX1+cRucj/8DBuWTtMSxQgUMZxGD+0TsFCrE=",
            "cpf": "U2FsdGVkX1+koiUWsbG94ZDI99XumfgKhmR6wwb34PI="
          }, {
            "num_cand": "U2FsdGVkX1/BJhEOF2KvjYwpoRAX1Om7WKMCm5C3FPM=",
            "cpf": "U2FsdGVkX1+LTDMjRnzOdDsjZFpbk9BBlsv8eWJk25M="
          }, {
            "num_cand": "U2FsdGVkX1/YYJpslOiUHRTb9v1zanCJ5xFKcN3GsXg=",
            "cpf": "U2FsdGVkX1+OzYbLQ3/xDiQMe7iYDz2+XSMSeLwH7dk="
          }, {
            "num_cand": "U2FsdGVkX18koq4RePCSveGr43XPBI6MbLzAqdrEcRg=",
            "cpf": "U2FsdGVkX18sjohw1ETCa098jjOEMm04zmFI+O1xHH0="
          }, {
            "num_cand": "U2FsdGVkX180kQqZpkPRVJDTCa4niP0VnNPdjBOCZRE=",
            "cpf": "U2FsdGVkX19TA/JMtpUcKcIuUL0QY3SkGKdLVxkY/vE="
          }, {
            "num_cand": "U2FsdGVkX1+TfbU6CmW98tosGC3iqZ9Q0+bmQdXYdmA=",
            "cpf": "U2FsdGVkX1/6+3QjIQ5b0ccsVFPtO687qHWvNdvMo8o="
          }, {
            "num_cand": "U2FsdGVkX1/IiMynrJvwWiUIyLJQdaQ58/L0iYP8vwo=",
            "cpf": "U2FsdGVkX19FFpdBIreUxEjeYzPZaf2VkbiRMSDP1zs="
          }, {
            "num_cand": "U2FsdGVkX181z1m3GFfIlFOlg4cMEJlB4C1tt97q3m0=",
            "cpf": "U2FsdGVkX1/ZrBKynWiIiApRD6FlatT/5aQg2gfx0sY="
          }, {
            "num_cand": "U2FsdGVkX1/9YyXPveH3Tzwn9rarz59ULSyzJMe1m3g=",
            "cpf": "U2FsdGVkX18UL3U6k6L0cz7uQ5jYI1AzrEF+jqwvYZY="
          }, {
            "num_cand": "U2FsdGVkX19gfRKAj9U1PPpIS299N14OtO0/cd3WVOM=",
            "cpf": "U2FsdGVkX1+S7tLPinYQiDIcmKUxRZ9OZBGVPYEL5fg="
          }, {
            "num_cand": "U2FsdGVkX19WW6SqPx8gxWnXTUbGKLPF6KNjjqtjGso=",
            "cpf": "U2FsdGVkX18BHpIVgRKnTzQux4p8HHpKlqh99xa8n7k="
          }, {
            "num_cand": "U2FsdGVkX18yEbYxEBC/bw1TCba7ErupC8BUiJCKh7c=",
            "cpf": "U2FsdGVkX1/+7GfWPwwkKW3nmhtpHdTaF4/ags1IBes="
          }, {
            "num_cand": "U2FsdGVkX18TtfTOqwTLmrrMfRXydvqEWnmRccFh19g=",
            "cpf": "U2FsdGVkX19dv9a4ffQnSpkIWTZK7InyAuq3GSkRZxw="
          }, {
            "num_cand": "U2FsdGVkX19VxZBIOs3Vxqjmng5Y175faaEdnez0o2k=",
            "cpf": "U2FsdGVkX1+nnBKZbynojlZZhiktM5DlbQncGILpFY4="
          }, {
            "num_cand": "U2FsdGVkX19ylPXzreSEASh8wummDZiFz/m1eQWUvW8=",
            "cpf": "U2FsdGVkX18H/tZc5QmT/XrWehR+7LnmAUtym9UekxM="
          }, {
            "num_cand": "U2FsdGVkX1/zq3PVzq/FZsYAlvWVy8bExceJIQ1/6eM=",
            "cpf": "U2FsdGVkX19vxL7BD3yKzYEyqGiaGPjZBWabi5zgq1M="
          }, {
            "num_cand": "U2FsdGVkX1/MBQttS5cxiOwU6GGnIg59+ga8GVJ/Rb4=",
            "cpf": "U2FsdGVkX19f0pzccwc668TwUi2+98Ipxlm+DNTe/kA="
          }, {
            "num_cand": "U2FsdGVkX1+wCMMIhpaVYfH0FlVgN6bfdnhw/tNzyww=",
            "cpf": "U2FsdGVkX1/2CiecFYYR4t5yk4wLhdIUOIVP4l/A0LQ="
          }, {
            "num_cand": "U2FsdGVkX1+aJmXIpmgQ8XkosGiwt9zfQMmp4QrMEto=",
            "cpf": "U2FsdGVkX19Ut0sMIOQef/rDLOkkkZGHCrcEbIK0PSI="
          }, {
            "num_cand": "U2FsdGVkX1/oEzMUBxyTO+bEjobG8JxERcnu4I9cOFI=",
            "cpf": "U2FsdGVkX1/0I8Mi2SQGzyl8+6quOEaQZfz8Sn2ZUBw="
          }, {
            "num_cand": "U2FsdGVkX19pB576nMJPTa0w9tWtFNwIHIJzR9cu7V0=",
            "cpf": "U2FsdGVkX18IvpX2LQK5RXr+HGvJxWLTyeAYW8LTisU="
          }, {
            "num_cand": "U2FsdGVkX18W8+VO/tSeO4nrk3Nget85tgvbCVXfZZA=",
            "cpf": "U2FsdGVkX1/BS2VJ0OIK4iWLP5j8hTpo3jRn2wF2iB4="
          }, {
            "num_cand": "U2FsdGVkX18E4ncO2Krornzs/flcZsDkj/P/C2B50/c=",
            "cpf": "U2FsdGVkX19SSI71EIv8HW+7d29cW3HgP+SD1tghNo8="
          }, {
            "num_cand": "U2FsdGVkX18iGqVDrIAOeulQ4hhNb+SjgNHQ89WNnSQ=",
            "cpf": "U2FsdGVkX1/ChxpylO0blDJCs6Bzy9eTAAuZ6x6zDrA="
          }, {
            "num_cand": "U2FsdGVkX188sntsPrH6EedTq8qFd1J0wln6oJnqRmw=",
            "cpf": "U2FsdGVkX1+HuCdLuO1BEi2WitgzyxYxfB8IOggdySo="
          }, {
            "num_cand": "U2FsdGVkX1+wr/nQpfIfyxsqOqI2J7TDqN/yOLOEFxk=",
            "cpf": "U2FsdGVkX188zN7MCxH7QNDGVCrMpYL9lah/5QHGIZc="
          }, {
            "num_cand": "U2FsdGVkX1/wFwMHSHNPkKQSB7NoAbpiFwkdVa9Tvbs=",
            "cpf": "U2FsdGVkX18FqD2VMg4S0AAa3lUqFQHJhtZyIpNR+dw="
          }, {
            "num_cand": "U2FsdGVkX1+gEff2rE9qPJm3JfoM0DLTc3MtPxhwJ7Y=",
            "cpf": "U2FsdGVkX188rXQ7FjNEGP+OerpIVsGD1PKh1jFwMgE="
          }, {
            "num_cand": "U2FsdGVkX1/IGx8M7gz7qndUZvnSJ9dRcqE7cm5/amE=",
            "cpf": "U2FsdGVkX1+TgrMQdVqKV5ss17tzLAFRzBRkuOdtYNs="
          }, {
            "num_cand": "U2FsdGVkX1+9XVVMeyCLLqxSt+o8TNINeWr/6pBf9rE=",
            "cpf": "U2FsdGVkX197unAQV+ZEX3jXzGR+7e/yl7/moqiQzL8="
          }, {
            "num_cand": "U2FsdGVkX1/P+whq+/mxyDZiWkjkzOgwB7uKLvNgr5E=",
            "cpf": "U2FsdGVkX19qR557oFVNZ7fUW6M0UshZdBLam4I35NU="
          }, {
            "num_cand": "U2FsdGVkX1+mHO8fcAyKO9GFWg878YM1bJ4qfBaOZNA=",
            "cpf": "U2FsdGVkX1+x+aAiPmn0IgFMrMTnOg6rN4icSgbUH3g="
          }, {
            "num_cand": "U2FsdGVkX19p/pkhom/Gq0CgOrxxf+zIAE+Cico5GWo=",
            "cpf": "U2FsdGVkX19lfeRz9MvBPSBTwTFkruDuNt+yDwdSdR4="
          }, {
            "num_cand": "U2FsdGVkX1+Fj2Y7E9vv+V57dZ30uRWu4t98W+I1azY=",
            "cpf": "U2FsdGVkX1+NnZjUvJCQqQ62Oo0g9x3EhfoF/3HOows="
          }, {
            "num_cand": "U2FsdGVkX186u9sahhqD1IRvVrw02+ReuoRjf8I19NY=",
            "cpf": "U2FsdGVkX1/IWOlWzkITViOklLZ0qJRX8JXltlCqbDc="
          }, {
            "num_cand": "U2FsdGVkX18apavjP3ig6Vl07ylgRIya0g0mLM77sJI=",
            "cpf": "U2FsdGVkX1/3R79nnbWqRfb9uJXzA/BMEAGXJ8yCXeA="
          }, {
            "num_cand": "U2FsdGVkX19d7v8mCp9vsdHgHbabD3TmkC8Io/sseGo=",
            "cpf": "U2FsdGVkX1/U35FIv6AcNdSlkKPGNv/+oLQtsQ2FvbU="
          }, {
            "num_cand": "U2FsdGVkX1+UhcEhZYIpXfdykbxvKC+gdZ3XFv+1sV4=",
            "cpf": "U2FsdGVkX1+INNniRzSTmNKbLRX0NMS9y9MDhiYlgTg="
          }, {
            "num_cand": "U2FsdGVkX193OCL9LmEw5FT+KQjbWg48qXnnHCbf8v0=",
            "cpf": "U2FsdGVkX19uxu8+3HuHWIVHa3XMfJasmpK9RIqSln0="
          }, {
            "num_cand": "U2FsdGVkX1/lbM8YRBtVQCz4RqT6DDDwc6UflKNXn5Y=",
            "cpf": "U2FsdGVkX1+B3esPH5KP/xZjZw8PVfFWexgNQG6jvtI="
          }, {
            "num_cand": "U2FsdGVkX1+4OFeF71ciiwBfT0jM8QRFnztBvaMFNc4=",
            "cpf": "U2FsdGVkX18L5kh9hX0e6fsl3nPSw/79cMIYYQYGZvc="
          }, {
            "num_cand": "U2FsdGVkX19/Ujk76cPcOdLF+H78Dpr0zPyNxJIu/SQ=",
            "cpf": "U2FsdGVkX19UnF9M8TrVJKK7EQzQXLmjOyRU/uEEYiE="
          }, {
            "num_cand": "U2FsdGVkX1+q54++p5v3ZO2zHsMlIRrqN5PN5OsQ+HA=",
            "cpf": "U2FsdGVkX1/I5letKQDwPPG/PYmjEdj5cJbChjeGUj0="
          }, {
            "num_cand": "U2FsdGVkX1/uN1XPUNAsTIQJgimEqgY4dySOEvujDpw=",
            "cpf": "U2FsdGVkX188G8mca1DV8xMSA+cNSFtl6Bb3rDjI5lk="
          }, {
            "num_cand": "U2FsdGVkX19epf0nD+rjW6jmWZ8Ev46dHJw6qntF1uA=",
            "cpf": "U2FsdGVkX18ETGUMSUhpxXntHgpdaAXA5mrdzr4Axyg="
          }, {
            "num_cand": "U2FsdGVkX1/8vLAPCEaQY+A/xr46rofcjGN7F3bR3J0=",
            "cpf": "U2FsdGVkX1+gAUxDOxE/X20xUlQ3YDvITkXR+944KAc="
          }, {
            "num_cand": "U2FsdGVkX19vKFWxsZ+yREvKetMMNyhNbykAVDT+gzk=",
            "cpf": "U2FsdGVkX1+r/l3NcLeCJIvIae6GLMLMCFiKQf5/fZQ="
          }, {
            "num_cand": "U2FsdGVkX19iLiHU2KyzJ+KEo9yejAe1jdr1QJiGtVs=",
            "cpf": "U2FsdGVkX1++jITmBcw1rC0yzUIpKrPdJuR+aswLrL8="
          }, {
            "num_cand": "U2FsdGVkX18YRDKDKC6WMDfISM+Jzh9603jw+NBqMxI=",
            "cpf": "U2FsdGVkX188Ehz192EKEKXyEODZ5gR+JguSYn1Mtew="
          }, {
            "num_cand": "U2FsdGVkX18iuxtywyrhdQfl5i9cn3q59et/dX3BlkY=",
            "cpf": "U2FsdGVkX1/7IkBeAPtsJ4oStVmyiEPXpy4HSoXf2mk="
          }, {
            "num_cand": "U2FsdGVkX19D7idrOJkQjOGUfaQhBclIV0FX52MWRxM=",
            "cpf": "U2FsdGVkX192RxEsPiU7R7w57umZT0ETk9OKa87e65o="
          }, {
            "num_cand": "U2FsdGVkX19kNpWtmNT1H5ZvVvW5aM+1mkqr4R3cMm8=",
            "cpf": "U2FsdGVkX1+QDRdVgam2LTlTz/Hd/+Xm/g5bKZYewhw="
          }, {
            "num_cand": "U2FsdGVkX191O0lbMb4gthg9yVgSuwL3Wv4rdYXCbxw=",
            "cpf": "U2FsdGVkX1+tqJZh6M3OKlZQ5fVHEtVif4GA/EaPXg8="
          }, {
            "num_cand": "U2FsdGVkX1/HaF5eGehWTQhIWumO8QdswwkjxAKWN0Q=",
            "cpf": "U2FsdGVkX1/fBf1bCLUMZ+Bu/IQYSK8rk35St67uc+I="
          }, {
            "num_cand": "U2FsdGVkX19T/3wpa0JPtAUq7tUfR7ox70ECprnpSvQ=",
            "cpf": "U2FsdGVkX1+aebmnR2YwdYu3NjJESvJGAwcBOBI4j1Q="
          }, {
            "num_cand": "U2FsdGVkX1/5LoKAvMatDs5QvMbhBIoEs7UbG/Y24gE=",
            "cpf": "U2FsdGVkX18BGaWGff3Hp5ShTCzegt738Pc/9v6Ti2Q="
          }, {
            "num_cand": "U2FsdGVkX19ybuZf14dvEGcUVbrKHttnNOHcXiZStPM=",
            "cpf": "U2FsdGVkX1+C1KHBY/zehzNRNeK46+2DVofsU0vPy8I="
          }, {
            "num_cand": "U2FsdGVkX1858/4n/d7M5wQ3SxkKkaBcKGCwSm3yG9s=",
            "cpf": "U2FsdGVkX1+Mq6vWSsnCbBblBuCApGd1E0Xlo6QrCMM="
          }, {
            "num_cand": "U2FsdGVkX1/ok4rmHhPWwmw6EBAEBO5IuzT0yQC8q38=",
            "cpf": "U2FsdGVkX1+aBoBxNBr/ivfeCGzUvg3R9EChSlFrqQw="
          }, {
            "num_cand": "U2FsdGVkX1/GoRH0unej+cM+zjBwgEnbGSMZdgfLOYk=",
            "cpf": "U2FsdGVkX195OIjN1KQQADtS673xQqmn5uytxo9B+TU="
          }, {
            "num_cand": "U2FsdGVkX1+AK/UCAAe8E2/LMGwnpW7B+Teto0gelog=",
            "cpf": "U2FsdGVkX1+7mZ2eQEufaTUX20pV/4Bh4khZYb6klKA="
          }, {
            "num_cand": "U2FsdGVkX18BoMb7OPKL2YLT4PIyrL221rq+cAjYyYY=",
            "cpf": "U2FsdGVkX1+JCfm5jEGGVymaBT5ysBrfjjDf+kfx8so="
          }, {
            "num_cand": "U2FsdGVkX18be1SSAA3KTypRIj/D3Dr1iv9ZgvCfl6w=",
            "cpf": "U2FsdGVkX1+TwCPj0FuvU4HvUrg9SwhvqyqRJe+9sHY="
          }, {
            "num_cand": "U2FsdGVkX1/OYQxVpW7It+knHaCCroVel8ggR3Xv4jY=",
            "cpf": "U2FsdGVkX1+U1HxroeSyn/9HpVPIvKceiIUB/xxfhyE="
          }, {
            "num_cand": "U2FsdGVkX1+t0D+nbrNJWfzZ2qgNujEyJuDTEb2yWzA=",
            "cpf": "U2FsdGVkX19AcfZZzHqAWq3DwDlkrPs/nZqNpbSR9LQ="
          }, {
            "num_cand": "U2FsdGVkX18SOqI8Dz/m/jAZU+rAWTPmxXqlojWgWnc=",
            "cpf": "U2FsdGVkX19n7bhuWADFyyF2ItkvIkxPowKcVRMAuNI="
          }, {
            "num_cand": "U2FsdGVkX193QiJYWcVOmwilOG2+DFkfcTcRyF1kcgo=",
            "cpf": "U2FsdGVkX1/eP3VRBVKHBh4Uf2pTl/ADqy8fa4xMmBA="
          }, {
            "num_cand": "U2FsdGVkX196fgiSDi+dLK972ATrh2BgTxOIheWUemA=",
            "cpf": "U2FsdGVkX19Y4QcSiN18JhQofwCjmI16ptow6mx6jTo="
          }, {
            "num_cand": "U2FsdGVkX1+Hg7v7160qmHUQd3DJtPHOayyIOebAMt0=",
            "cpf": "U2FsdGVkX18K5pAWD8ZQ0MF8U7f/IW/j7LjoeTgB3wg="
          }, {
            "num_cand": "U2FsdGVkX19d1UDRSG27/3WTXwgI6gCHjsVB90x8lw4=",
            "cpf": "U2FsdGVkX1/jrTru8TnJHR4q59tDNT5A+DvcA0IK8e4="
          }, {
            "num_cand": "U2FsdGVkX18HxGRBRZA38p4JuyZKuiSmR+O9sblq77Q=",
            "cpf": "U2FsdGVkX1/QLW8cl+wB8JPHvuTCeze7ecUyPmCDOcA="
          }, {
            "num_cand": "U2FsdGVkX19eLUhRszvkCXCZiphyapgKvHjASuPKijA=",
            "cpf": "U2FsdGVkX181R3gbolghsn7FykIVc5outNpPRDvFFSg="
          }, {
            "num_cand": "U2FsdGVkX19DSl2X5cYil2ZgplpgHEz9blrLpRjpVDs=",
            "cpf": "U2FsdGVkX198zjQkwxa1oadyDDMr7pqqEqQBjfwwXxI="
          }, {
            "num_cand": "U2FsdGVkX19G9gRlWEsbV1CrcVKg89Dcvc/r35e/8js=",
            "cpf": "U2FsdGVkX19QLM0qjLb2oIPDZSiQFeRuqV9icJscqtQ="
          }, {
            "num_cand": "U2FsdGVkX18YGgkAOksGvFf6YSM+2wSsFwZ/K39yU+M=",
            "cpf": "U2FsdGVkX184CGYf422tPvbPaDjTCoT3yrqZPNVljJI="
          }, {
            "num_cand": "U2FsdGVkX1/vfIIVnqIm6jM9KRbtmuQFu6Pgr6VDjPM=",
            "cpf": "U2FsdGVkX19FAGprTmcAlXTlia8iu/FQJsSe94wURXc="
          }, {
            "num_cand": "U2FsdGVkX1/hJMSW272OzTGLCm4fYk6wAcLSZmVn48A=",
            "cpf": "U2FsdGVkX18TX2v3emeFEw3bUtkrzGCHE99F7UlivIs="
          }, {
            "num_cand": "U2FsdGVkX193nqUOEUTeK+OIdmTQnBBW64SYnke0mSA=",
            "cpf": "U2FsdGVkX18FxEGMoiQalTz8LhYz5QBi8gHP5ubhwVU="
          }, {
            "num_cand": "U2FsdGVkX19vZgbx7V+hkOf46jRJJjzpuDJz6WK7DEc=",
            "cpf": "U2FsdGVkX1/eZNYl4dCSds1lwA1NMakvMRaYrLz5mzY="
          }, {
            "num_cand": "U2FsdGVkX18StX49ckKrTagKM/lDnHBNiXNw8lcMzCQ=",
            "cpf": "U2FsdGVkX19N13UyjI22db9sCWL/pOyB0C9lWmhuNiY="
          }, {
            "num_cand": "U2FsdGVkX1/qgrg3BoUakq7715JUH7bVAFIYIsnjbjg=",
            "cpf": "U2FsdGVkX1/HQviE93ZPVSIbm/POWEViLLfljS9nZXU="
          }, {
            "num_cand": "U2FsdGVkX1+6ChdUf1DWOknces036Botdc8CeVPdexM=",
            "cpf": "U2FsdGVkX19EZSi+NNVnHGnRf4Pelb5YfAiDL+ZXOgQ="
          }, {
            "num_cand": "U2FsdGVkX18Ol8gv3XoYx9RLhQD9O2qZAyfgHWorCvE=",
            "cpf": "U2FsdGVkX1/GQyUsjXYOOUAlkgSLfdX3hDTbg5W3SBk="
          }, {
            "num_cand": "U2FsdGVkX1/Aqm7Fq0Dg3usNrBdBkiUDPEXZ9cwhG30=",
            "cpf": "U2FsdGVkX18ihFAxpv1rrRv52byCGFcsHibvaZPo468="
          }, {
            "num_cand": "U2FsdGVkX1/ihN2Ca76TbO0qKnvKxcwvwRZrXQw3yow=",
            "cpf": "U2FsdGVkX1+0TU/t1miKbf35PVjR0jRm17zgcasclus="
          }, {
            "num_cand": "U2FsdGVkX1859EaGf8fFPhvGVpRwQK9T9PPTyhLTvhU=",
            "cpf": "U2FsdGVkX1/l2lUIO2GwpYOLXZeJL+0LhpMDAeQPB5Y="
          }, {
            "num_cand": "U2FsdGVkX1/BVbWtkdgdLin4OP9VwZZRGPOQKKyQbUI=",
            "cpf": "U2FsdGVkX186E4xfkGdXg4M/pDT8pdOs5+3bSLJ8Wh4="
          }, {
            "num_cand": "U2FsdGVkX190/pvneKTIRQvRflyWKgWTHcWcZelGbHs=",
            "cpf": "U2FsdGVkX1/RYVCPf+RM6mBtcbwUhGtx+7QW/bOD5p4="
          }, {
            "num_cand": "U2FsdGVkX1/X7D3NnGRyx6BiqfTRiXmPaxxFHbeS3dE=",
            "cpf": "U2FsdGVkX19IUji+ksSnFB72cNPrTliJaT5sKdI3rH4="
          }, {
            "num_cand": "U2FsdGVkX1/5TzpwI/CCJxSOUB1xvyJ0sMPkkGNFKuc=",
            "cpf": "U2FsdGVkX18fEfa88UdHibPwP9cBJ+26Q0yfP8DRtlU="
          }, {
            "num_cand": "U2FsdGVkX19izdXShWjnIsBSj3Tf4sOOxyHHwynLVEA=",
            "cpf": "U2FsdGVkX18lhISojIvOE4jklZAZauVNBAWZoxc9ob4="
          }, {
            "num_cand": "U2FsdGVkX19VEO0GRChXRblkgSNBVdQgmBOf3e1TH7g=",
            "cpf": "U2FsdGVkX1/VvN0pEjRz6nrCjGUEddtZAcTtua74Gt0="
          }, {
            "num_cand": "U2FsdGVkX1+K200SLkauFUf+TMn5ho0IvWmnBEeoras=",
            "cpf": "U2FsdGVkX1/nyXUpkV+qHpZmc2MBH9T51o5xYBaQPw4="
          }, {
            "num_cand": "U2FsdGVkX19GbXSMferQnmIPUdLKQ8a9i65uhyrZDG0=",
            "cpf": "U2FsdGVkX1+4QN99RLCk+Qv6U2K0j9wDmKrQXS8Ob8o="
          }, {
            "num_cand": "U2FsdGVkX19QxdroI9ezsFG5PTEycaH89190Xt0NEGk=",
            "cpf": "U2FsdGVkX1/th2OVLvBkA+ssD4eYLtrU/8QX/5wkEIo="
          }, {
            "num_cand": "U2FsdGVkX1+ZdakWUOqUtGCPCC0e7GAzanMIflY6VLQ=",
            "cpf": "U2FsdGVkX18axrz9b+0mtDQi06sRGBUVGNUAky6rzX4="
          }, {
            "num_cand": "U2FsdGVkX18sCRzntLDeAg40kgAfem1bskegDdbCq8g=",
            "cpf": "U2FsdGVkX1/Z1i/2VKUSyFDSL7aiqdjXRptMxGXzsTo="
          }, {
            "num_cand": "U2FsdGVkX1+S1DLQ/QCIaaxuNzK6dok66AAmSE33tcc=",
            "cpf": "U2FsdGVkX19rGu+2vG3NNP7+aAByJ8V7BuG96cn4xA8="
          }, {
            "num_cand": "U2FsdGVkX18t/1PQJahimROtKb4R2UOoxr+1NPwQprY=",
            "cpf": "U2FsdGVkX1+Px6aUcL4FHygoZ3ZFyDHj6xRsLbkcNB4="
          }, {
            "num_cand": "U2FsdGVkX1/61K+KzbksqGZlC441CX0VtJ9w/UGEhHE=",
            "cpf": "U2FsdGVkX19RPeDgGU75CQaOoYWdn5DWOXVHD237Jf0="
          }, {
            "num_cand": "U2FsdGVkX19Xipcay6zcOCSlZwgyFYGcx5jlVGYE8YM=",
            "cpf": "U2FsdGVkX1+RxFtIEAD+2L82N7ZrlPYbBjPnl3xuEDk="
          }, {
            "num_cand": "U2FsdGVkX198gcdYwsWNPbdd7YBdvwwejF4CzQ5YehQ=",
            "cpf": "U2FsdGVkX1906Ip87QZqhnqBwFNBlO1CN2jwnWH+69w="
          }, {
            "num_cand": "U2FsdGVkX19b1JovPJ7F2Q7DcNVtmx1ftKiq5y0s+mo=",
            "cpf": "U2FsdGVkX189phMRmXu9ocZC9b5E3AO8MO3B6rxyLSQ="
          }, {
            "num_cand": "U2FsdGVkX1+G8hwQFvL6EB2srEs/QtYfECbWxIWehiI=",
            "cpf": "U2FsdGVkX18hCGDBN7R+eji4dL4Btig3Q7G3UmmyUyU="
          }, {
            "num_cand": "U2FsdGVkX1+NY+6grajfivSAzPRvCnOEBz8i+dcu9Z0=",
            "cpf": "U2FsdGVkX1+FI3+J80U6iWkcJLFn9JXNWNyb2eFlAYw="
          }, {
            "num_cand": "U2FsdGVkX19dQ57w2aXH/OmYFZfMbdyMHAMmrzYD81g=",
            "cpf": "U2FsdGVkX19c3OD7NW8qcdWMyzqn30h1dSi60b5NGdE="
          }, {
            "num_cand": "U2FsdGVkX19CIslE90NQCSK97gjlvEHcXO8Ho+8NE1k=",
            "cpf": "U2FsdGVkX1+VCpfSxMBaIJDCVEE2C4xikzQk9aBXSBs="
          }, {
            "num_cand": "U2FsdGVkX18Da/CaJosdkGIKe3JDpm34dWnnGsCrEa4=",
            "cpf": "U2FsdGVkX18mPed3pA9YE1ISgqyayfXXkotmd0bqVsg="
          }, {
            "num_cand": "U2FsdGVkX18jwg+5F6E2mC8340+4VE1v+Pk3m2zqIZM=",
            "cpf": "U2FsdGVkX1/7N+d09Lbanm7llwMhYZxLdwhMAtEciFk="
          }, {
            "num_cand": "U2FsdGVkX1+51UEO94bGsQ0llFtO1fXmocYiNuTxMTg=",
            "cpf": "U2FsdGVkX195Ek8z/76qmKrV6RVGtBFqxSERWzFgEGs="
          }, {
            "num_cand": "U2FsdGVkX1+3mcOQ26PlfhpxRTJt3s9AF3rvUES2ltc=",
            "cpf": "U2FsdGVkX180uxXI6TAJCkG0o7IIUgsALY2GRPvajn4="
          }, {
            "num_cand": "U2FsdGVkX19FyJ029S7aHNaJhFpEDK7XzRX3HvxIjxI=",
            "cpf": "U2FsdGVkX1/UIpul/2GS/8/f3RCGbLoViVwyD2LKj6I="
          }, {
            "num_cand": "U2FsdGVkX18+Q2Gb3/wl1Tb31OpdOofpkCtaD7O7ZCM=",
            "cpf": "U2FsdGVkX19cm1rvzrVz2S3cIwHS3iUwOrqom+vllE4="
          }, {
            "num_cand": "U2FsdGVkX18iM/hcQGPRgN6OfsJa45midJdH+fX3YMo=",
            "cpf": "U2FsdGVkX18oaJrjHCel8ZtdMTJrgg4Mzv1EguKEcCQ="
          }, {
            "num_cand": "U2FsdGVkX18YTHO5pZiG1cQ6J/Rwty+uGXs3DodYZjo=",
            "cpf": "U2FsdGVkX19I7vmbCvprKNUCTQ8r+QRrfE+PzFRCdfo="
          }, {
            "num_cand": "U2FsdGVkX18fz2Swx7Nl8flMXFfFJkHzJkSDsembRe0=",
            "cpf": "U2FsdGVkX1/pOHWvYgf42I4FcsA9GDn0K6eY0HxCCgs="
          }, {
            "num_cand": "U2FsdGVkX1+SmfSGMQa3DzTH4QGZPc1xlYSV3YBLrKA=",
            "cpf": "U2FsdGVkX1/eLKzhA0AQ6PW5B3LxZykjyJtKOvdz5zc="
          }, {
            "num_cand": "U2FsdGVkX1/xm1MLMVQnoz8duM8e1JtoTnt91vXgyYg=",
            "cpf": "U2FsdGVkX187y5dSloEoZHnaNCQOzLbSh5MM+G79JOg="
          }, {
            "num_cand": "U2FsdGVkX18HuPLS+zKEOX4pSNhc7GDRqJrWotlTKDw=",
            "cpf": "U2FsdGVkX18GEOTG5B4wLlB3wPW/bz2s/y818lSnkgs="
          }, {
            "num_cand": "U2FsdGVkX18KQ6bL5hkVNqn81Q56/EBaHpew5G1ZqDo=",
            "cpf": "U2FsdGVkX1//iAqq7/M4X+5fkTXAfvkYwmV8wqWyn6s="
          }, {
            "num_cand": "U2FsdGVkX19xSy0RU0saF7xS95PxlDiSwBmqWAYJ58Y=",
            "cpf": "U2FsdGVkX1+p4N9TnF5+sk1t9+7y8VfiVE3LovhaTTI="
          }, {
            "num_cand": "U2FsdGVkX19TyxGuImtDxom3z174QC0YnLOUI/S9X28=",
            "cpf": "U2FsdGVkX188GSk+IKVXTBnor7rvT41EeoYWQd6mM90="
          }, {
            "num_cand": "U2FsdGVkX1+7DNr1Kjd3U6qOSWk++Nm6rxOCANQqeew=",
            "cpf": "U2FsdGVkX18v1P01P7F5NtdHi63zEAuYMBsOORxGVnM="
          }, {
            "num_cand": "U2FsdGVkX1/A1vDdlcnyd0aIpkzQXIDAVP0GGjOnq6I=",
            "cpf": "U2FsdGVkX1+3+BsPLc9wtw3/h1hyCouZ9h5+rOSpVXg="
          }, {
            "num_cand": "U2FsdGVkX1+UB0OXNuWKzyD9HZVXRj6JKIhD2qDQOCE=",
            "cpf": "U2FsdGVkX1/KVJJG7BibQee8uYk7nw7MtOwCpu/Y7Tw="
          }, {
            "num_cand": "U2FsdGVkX1+xTi4RDD5tM2J37j5s+u07Fj92cbTXNtg=",
            "cpf": "U2FsdGVkX18E2mmuz9sR+cru5gbTxffLA3RU4ZvSMKY="
          }, {
            "num_cand": "U2FsdGVkX1/7m/9Y4xx7/Cs4zTN5LZ8XggcrYkmc/jA=",
            "cpf": "U2FsdGVkX18ufQZlpJd8eSdPrwmxeiL7v2j8NLNvksY="
          }, {
            "num_cand": "U2FsdGVkX1+1iyIsB2thGvsbjwCZXyj+4rV3KxdM3nk=",
            "cpf": "U2FsdGVkX1+ycXQQ/bHSA1pIoWuLp8adXWXrh2Pvgp0="
          }, {
            "num_cand": "U2FsdGVkX18kMccNrPWaEYMhdpNvyQxDmNkGsdhDkQg=",
            "cpf": "U2FsdGVkX18He6cXaftKnHa0368V2FFPjdEoNk1Ek4U="
          }, {
            "num_cand": "U2FsdGVkX19WJx3KzxGqgefoDnhGnIGLNnKLIxgn3W8=",
            "cpf": "U2FsdGVkX1+HI9FNd5tj6m5Cf0F5DNlPmUf76abBybE="
          }, {
            "num_cand": "U2FsdGVkX18Ta52lPZCKwEejlIukPP+oatMBAAhL7ro=",
            "cpf": "U2FsdGVkX18EYnch8ylBNIMtHKssi2j51qAU5PvIcy0="
          }, {
            "num_cand": "U2FsdGVkX18/RA9Uy5uStDdJnEiWHeGyMT+E7bR6Da8=",
            "cpf": "U2FsdGVkX1/Sb4zbxzk1p3lhYlqNIGr3inYrhJqSiuM="
          }, {
            "num_cand": "U2FsdGVkX19qO+o5Fp0iNUdXYFS2sBc6ifuLXKhvV3k=",
            "cpf": "U2FsdGVkX19lw3EnBI/q6Rzaxu2jC/n/gjfDdFu9B4w="
          }, {
            "num_cand": "U2FsdGVkX1/1fza2MkMGxjOXV3+/4CgPRkXvXPml36o=",
            "cpf": "U2FsdGVkX1+xqAWDp4j+SVz+eIiRhCRjWgQk4KPpWnY="
          }, {
            "num_cand": "U2FsdGVkX1+qnj8frN3B871j3/AE7GL/SeJi9kCxwbY=",
            "cpf": "U2FsdGVkX1+yvTR2lX5Cc8H4C9iXuGVmefnLGkWFljY="
          }, {
            "num_cand": "U2FsdGVkX194JV0289KXjUGmMPleMuKdNSXjF0juRAk=",
            "cpf": "U2FsdGVkX1+kJ+IQDT/NccmlVHTtk9GF8FVV6sAsMn8="
          }, {
            "num_cand": "U2FsdGVkX1+Itwj3EzmEq2uApOKBFNl6LqP4xTBaA24=",
            "cpf": "U2FsdGVkX19ZRjXSZAVjdP1mX0spHF+BnJt9G07Bw84="
          }, {
            "num_cand": "U2FsdGVkX1+c2BQJI2gTaBVoTYOtxS969azMQoyl4Mg=",
            "cpf": "U2FsdGVkX1/lDWdXAfSqpPWieHD7JJGIlxGcXv605Sg="
          }, {
            "num_cand": "U2FsdGVkX18JZ1L2Vp45sklbSDZqTpfJlLKE8+dgoZ4=",
            "cpf": "U2FsdGVkX1+PIaGjbm0x8MaG82kYYT2sawe59RzwvOQ="
          }, {
            "num_cand": "U2FsdGVkX1/QKhS32L2cvw6u6ONBRaPjSGZUGaEWaq0=",
            "cpf": "U2FsdGVkX18Ornl1VbpCxObGskevptYo45VcZNFskVU="
          }, {
            "num_cand": "U2FsdGVkX18/MXE4tiT2Qo1QV4xwbjqXh5laf4QA3JU=",
            "cpf": "U2FsdGVkX1/DXw+sjQNN13oZFQGmAC7hrtl1RFdnAKc="
          }, {
            "num_cand": "U2FsdGVkX1/65HYX7fH/ETSGU2sROfGn8n6VgpPubKI=",
            "cpf": "U2FsdGVkX1+t47t68rB7dZ2fbSQdkn6p9tEGPoYOkbg="
          }, {
            "num_cand": "U2FsdGVkX18UCqbHfNNHkccfKP92DOHtd0fZKtgow2c=",
            "cpf": "U2FsdGVkX18NaeF1L76YG783wGFKXyfwEFE6/k2OWVg="
          }, {
            "num_cand": "U2FsdGVkX1+RcEuunYBy68ZXWLh5+J4i+anqcJ+R4L4=",
            "cpf": "U2FsdGVkX1+G3PNPvhS2vlH9O/+/nA0OnRVvrXm+NuI="
          }, {
            "num_cand": "U2FsdGVkX1/C6bJjVsynLsClgnvX+Z+ArAU3EJM7iDg=",
            "cpf": "U2FsdGVkX19Lx45kF4F0SBPnE47v9bWusqhzT/Of6Cw="
          }, {
            "num_cand": "U2FsdGVkX197DVpxo0jdgXlCfdAASqi2q2XAUEv/t6o=",
            "cpf": "U2FsdGVkX181c2ICP/IFlG7ueToHoQ69/KqihGzDtzg="
          }, {
            "num_cand": "U2FsdGVkX1+2iqcsrhGOGONQemAUvRQCyzz9hZlEgwA=",
            "cpf": "U2FsdGVkX18ARSiOOW27Ocdajg19G+eHuzqOvfqArAQ="
          }, {
            "num_cand": "U2FsdGVkX19/I6ahLXp4jqh3085xBmitA3bMWT5YY1M=",
            "cpf": "U2FsdGVkX1/Y904i+pgW2URU6eHIqQMZrXNKsqYlXPM="
          }, {
            "num_cand": "U2FsdGVkX1+ujKv/CaKxUJK+IO2WL0FutJzKOC5hJX0=",
            "cpf": "U2FsdGVkX1/kd/z1FnEQM9pOje7hY7/A35oo9geq/go="
          }, {
            "num_cand": "U2FsdGVkX1//Msbfd0e7Rt9pHLaROm6Iy6FjHSj3R/Y=",
            "cpf": "U2FsdGVkX18Z8GJ933jB/hatQE2F4+5LO+KIidOu6Ls="
          }, {
            "num_cand": "U2FsdGVkX19lXVGitAtXKD4v5MxPk6ehk700ZG4pDEk=",
            "cpf": "U2FsdGVkX1/R6dFP3jX+Jj23A+CmtfZZ3dRzKPArE2w="
          }, {
            "num_cand": "U2FsdGVkX1+60nJK0hJWnOu/0u7jtNB4qvmkqQgPGxQ=",
            "cpf": "U2FsdGVkX18M0iKCoCQ3ONNzOiPaPYNrGd2xxAmkshg="
          }, {
            "num_cand": "U2FsdGVkX1/tNDgiIiJDWQ4gv3RY5hd26rXuDEWw9f8=",
            "cpf": "U2FsdGVkX18HwvXv07+BDdw43HBOC6Y15AiFnq1TyMA="
          }, {
            "num_cand": "U2FsdGVkX19M4Rs6A5lQ55DKeROZoKsmEyNGWsspp0c=",
            "cpf": "U2FsdGVkX19uHonPXPcgfMLlV6ybuLqWHqXp0n1f58M="
          }, {
            "num_cand": "U2FsdGVkX18fHfgyFV9jv+2/BW3n2WpF+k2fBhZ64/8=",
            "cpf": "U2FsdGVkX1/bxrzFCt+Nv2i60iCh+z6dy9x3H38tyxA="
          }, {
            "num_cand": "U2FsdGVkX1/BsKLNSFSVdsOu/DVkimKouHgwtltl1f8=",
            "cpf": "U2FsdGVkX1/Mun99yMhrO51wdaCHD80TqnNnR14AGZY="
          }, {
            "num_cand": "U2FsdGVkX1/FTc9ZA03+QIY/SsElG6s6B3NRL6cCCk8=",
            "cpf": "U2FsdGVkX18bVKhe1K7BX+Ut9pO5rpkOtSGnmpK+ZN4="
          }, {
            "num_cand": "U2FsdGVkX1/TZg5JYhdRAWp7Fbx/VuCU6zbcd6xlS+8=",
            "cpf": "U2FsdGVkX18o7cjhgahynz3kU1GUqCzPN2frnv8gAYU="
          }, {
            "num_cand": "U2FsdGVkX19b0KOn3coTJ3fggr/aY5nge68bBngn9Jw=",
            "cpf": "U2FsdGVkX1/lwNncapX+j8TTwPMQKMkKQW9+M4TkxN4="
          }, {
            "num_cand": "U2FsdGVkX1/SguRLPSzbG5lv9u8zhEiwpte1XN7Dqxo=",
            "cpf": "U2FsdGVkX19drwfzb4VIkCdVDUGnQJI8w6kB9ADeQPA="
          }, {
            "num_cand": "U2FsdGVkX1+BKPEtlKmGRUmHy78GnoUTPwlrJyi8iAs=",
            "cpf": "U2FsdGVkX1/1PzR6D/pATQyI+9KGd/QTJZ60W9HXJ6A="
          }, {
            "num_cand": "U2FsdGVkX19lSUKPbQIhdYoKqdElxq2FrrAN3bqY1S4=",
            "cpf": "U2FsdGVkX197XqjqYoDLOi80ikG+L1kT+RNw6XibKZk="
          }, {
            "num_cand": "U2FsdGVkX1/BsUSIvAqVXxtC+GHNRCi0uRUwiiSNSCg=",
            "cpf": "U2FsdGVkX18/HYcFiK8KqGxm1+EbwPpZV2sVl7KShZo="
          }]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2204/not_disc_def/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
